import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import React__default, { useState, useRef, useEffect, useCallback, useMemo, useId as useId$1, useLayoutEffect, createContext, useContext, forwardRef, Fragment as Fragment$1 } from "react";
import { Minus, Check, ChevronLeftIcon as ChevronLeftIcon$1, ChevronRightIcon as ChevronRightIcon$1, ChevronDownIcon, X, Camera, ChevronLeft, SwitchCamera, Pencil, Plus, Trash2, MessageSquare } from "lucide-react";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
import { useReactTable, getSortedRowModel, getCoreRowModel } from "@tanstack/react-table";
import { queryOptions, useQuery } from "@tanstack/react-query";
import './capture.css';function resolveWorkstationName(input2) {
  return input2.alias ? input2.alias : input2.name;
}
function shortenOperatorName(name2) {
  if (!name2) return void 0;
  const words = name2.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return void 0;
  return words.slice(0, 2).join(" ");
}
function resolveWorkstationRibbon(input2) {
  if (input2.typeName !== "traceability") return null;
  switch (input2.services[0]) {
    case "create_traceability_order":
      return "order";
    case "tracking":
      return "tracking";
    case "boarding_outgoing":
      return "boarding";
    default:
      return "plain";
  }
}
function pickActiveItem(input2) {
  const matching = input2.items.filter((item2) => item2.type === input2.type);
  return matching[matching.length - 1] ?? null;
}
function toSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  if ([hours, minutes, seconds].some((part2) => Number.isNaN(part2))) return NaN;
  return hours * 3600 + minutes * 60 + seconds;
}
function scheduleCrossesMidnight(input2) {
  const start = toSeconds(input2.startsAt);
  const end = toSeconds(input2.endsAt);
  if (Number.isNaN(start) || Number.isNaN(end)) return false;
  return end <= start;
}
function getScheduleById(input2) {
  if (input2.id == null) return null;
  return input2.schedules.find((schedule) => schedule.id === input2.id) ?? null;
}
function filterWorkstationsBySearch(input2) {
  const term = input2.search.trim();
  if (!term) return input2.workstations;
  const matches = (value2) => value2.localeCompare(term, void 0, { sensitivity: "base" }) === 0 || value2.toLocaleLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").includes(
    term.toLocaleLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "")
  );
  return input2.workstations.filter(
    (workstation) => matches(workstation.name) || matches(workstation.alias ?? "")
  );
}
function filterWorkstationsByStatus(input2) {
  return input2.workstations.filter(
    (workstation) => workstation.status === input2.status
  );
}
const tabs = "_tabs_zf6z4_6 _root_7vfur_3";
const tab = "_tab_zf6z4_6";
const active$3 = "_active_zf6z4_50";
const styles$$ = {
  tabs,
  tab,
  active: active$3
};
function CaptureTabs({
  tabs: tabs2,
  value: value2,
  onChange,
  ariaLabel,
  className
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${styles$$.tabs} ${className ?? ""}`.trim(),
      role: "tablist",
      "aria-label": ariaLabel,
      children: tabs2.map((tab2) => {
        const isActive = tab2.value === value2;
        return /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            role: "tab",
            id: `capture-tab-${tab2.value}`,
            "aria-selected": isActive,
            "aria-controls": `capture-tabpanel-${tab2.value}`,
            className: `${styles$$.tab} ${isActive ? styles$$.active : ""}`.trim(),
            onClick: () => {
              if (!isActive) onChange(tab2.value);
            },
            children: tab2.label
          },
          tab2.value
        );
      })
    }
  );
}
function Icon({ children, strokeWidth = 1.5, ...props }) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox: "0 0 24 24",
      width: 20,
      height: 20,
      fill: "none",
      stroke: "currentColor",
      strokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      ...props,
      children
    }
  );
}
function ChevronRightIcon(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsx("polyline", { points: "9 6 15 12 9 18" }) });
}
function ChevronLeftIcon(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsx("polyline", { points: "15 6 9 12 15 18" }) });
}
function CheckIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { ...props, children: [
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ jsx("polyline", { points: "8 12.5 11 15.5 16 9" })
  ] });
}
function LockIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { ...props, children: [
    /* @__PURE__ */ jsx("rect", { x: "5", y: "11", width: "14", height: "10", rx: "2" }),
    /* @__PURE__ */ jsx("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
  ] });
}
function ZoomInIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { strokeWidth: 2, ...props, children: [
    /* @__PURE__ */ jsx("circle", { cx: "10.5", cy: "10.5", r: "6.5" }),
    /* @__PURE__ */ jsx("line", { x1: "15.5", y1: "15.5", x2: "21", y2: "21" }),
    /* @__PURE__ */ jsx("line", { x1: "7.5", y1: "10.5", x2: "13.5", y2: "10.5" }),
    /* @__PURE__ */ jsx("line", { x1: "10.5", y1: "7.5", x2: "10.5", y2: "13.5" })
  ] });
}
function ZoomOutIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { strokeWidth: 2, ...props, children: [
    /* @__PURE__ */ jsx("circle", { cx: "10.5", cy: "10.5", r: "6.5" }),
    /* @__PURE__ */ jsx("line", { x1: "15.5", y1: "15.5", x2: "21", y2: "21" }),
    /* @__PURE__ */ jsx("line", { x1: "7.5", y1: "10.5", x2: "13.5", y2: "10.5" })
  ] });
}
function EyeIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { ...props, children: [
    /* @__PURE__ */ jsx("path", { d: "M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "3" })
  ] });
}
function EyeOffIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { ...props, children: [
    /* @__PURE__ */ jsx("path", { d: "M9.9 4.24A9.1 9.1 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19M6.6 6.6A18.5 18.5 0 0 0 1 12s4 8 11 8a9.1 9.1 0 0 0 5.4-1.6" }),
    /* @__PURE__ */ jsx("path", { d: "M9.9 9.9a3 3 0 0 0 4.2 4.2" }),
    /* @__PURE__ */ jsx("line", { x1: "2", y1: "2", x2: "22", y2: "22" })
  ] });
}
function AlertIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, { ...props, children: [
    /* @__PURE__ */ jsx("path", { d: "M10.3 3.5 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.5a2 2 0 0 0-3.4 0Z" }),
    /* @__PURE__ */ jsx("line", { x1: "12", y1: "9", x2: "12", y2: "13" }),
    /* @__PURE__ */ jsx("line", { x1: "12", y1: "17", x2: "12.01", y2: "17" })
  ] });
}
const group$1 = "_group_19tzx_4 _root_1tw36_3";
const header$6 = "_header_19tzx_17";
const titleWrap = "_titleWrap_19tzx_33";
const title$7 = "_title_19tzx_33";
const subtitle$2 = "_subtitle_19tzx_44";
const right$1 = "_right_19tzx_49";
const count$2 = "_count_19tzx_55";
const chevron$3 = "_chevron_19tzx_60";
const open = "_open_19tzx_71";
const list$2 = "_list_19tzx_81";
const collapsed = "_collapsed_19tzx_94";
const styles$_ = {
  group: group$1,
  header: header$6,
  titleWrap,
  title: title$7,
  subtitle: subtitle$2,
  right: right$1,
  count: count$2,
  chevron: chevron$3,
  open,
  list: list$2,
  collapsed
};
function ChecklistGroup({
  title: title2,
  subtitle: subtitle2,
  count: count2,
  children,
  defaultOpen = false,
  className
}) {
  const [open2, setOpen] = useState(defaultOpen);
  return /* @__PURE__ */ jsxs("section", { className: `${styles$_.group} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: styles$_.header,
        "aria-expanded": open2,
        onClick: () => setOpen((value2) => !value2),
        children: [
          /* @__PURE__ */ jsxs("span", { className: styles$_.titleWrap, children: [
            /* @__PURE__ */ jsx("span", { className: styles$_.title, children: title2 }),
            subtitle2 != null && subtitle2 !== false && /* @__PURE__ */ jsx("span", { className: styles$_.subtitle, children: subtitle2 })
          ] }),
          /* @__PURE__ */ jsxs("span", { className: styles$_.right, children: [
            count2 != null && /* @__PURE__ */ jsx("span", { className: styles$_.count, children: count2 }),
            /* @__PURE__ */ jsx(
              "span",
              {
                className: `${styles$_.chevron} ${open2 ? styles$_.open : ""}`.trim(),
                children: /* @__PURE__ */ jsx(ChevronRightIcon, {})
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx("ul", { className: `${styles$_.list} ${open2 ? "" : styles$_.collapsed}`.trim(), children })
  ] });
}
const row$4 = "_row_uh34u_6 _root_e1cdo_3";
const surface = "_surface_uh34u_14";
const name$5 = "_name_uh34u_35";
const right = "_right_uh34u_40";
const icon$9 = "_icon_uh34u_48";
const styles$Z = {
  row: row$4,
  surface,
  name: name$5,
  right,
  icon: icon$9
};
function ChecklistRow({
  name: name2,
  status: status2,
  actionLabel,
  right: right2,
  onSelect,
  className
}) {
  const content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: styles$Z.name, children: name2 }),
    /* @__PURE__ */ jsxs("span", { className: styles$Z.right, children: [
      right2,
      actionLabel && /* @__PURE__ */ jsx("span", { children: actionLabel }),
      /* @__PURE__ */ jsx("span", { className: styles$Z.icon, children: status2 === "planned" ? /* @__PURE__ */ jsx(LockIcon, {}) : /* @__PURE__ */ jsx(ChevronRightIcon, {}) })
    ] })
  ] });
  return /* @__PURE__ */ jsx("li", { className: `${styles$Z.row} ${className ?? ""}`.trim(), children: onSelect ? /* @__PURE__ */ jsx("button", { type: "button", className: styles$Z.surface, onClick: onSelect, children: content2 }) : /* @__PURE__ */ jsx("div", { className: styles$Z.surface, children: content2 }) });
}
const item$1 = "_item_13erj_5 _root_1r1yi_3";
const name$4 = "_name_13erj_36";
const action$1 = "_action_13erj_41";
const icon$8 = "_icon_13erj_48";
const styles$Y = {
  item: item$1,
  name: name$4,
  action: action$1,
  icon: icon$8
};
function ChecklistTemplateItem({
  name: name2,
  actionLabel,
  onSelect,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: `${styles$Y.item} ${className ?? ""}`.trim(),
      onClick: onSelect,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles$Y.name, children: name2 }),
        /* @__PURE__ */ jsxs("span", { className: styles$Y.action, children: [
          actionLabel && /* @__PURE__ */ jsx("span", { children: actionLabel }),
          /* @__PURE__ */ jsx("span", { className: styles$Y.icon, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) })
        ] })
      ]
    }
  );
}
const partAndOf = "_partAndOf_s31kq_5 _root_1cko9_3";
const ofs = "_ofs_s31kq_35";
const muted = "_muted_s31kq_40";
const selected$3 = "_selected_s31kq_46";
const styles$X = {
  partAndOf,
  ofs,
  muted,
  selected: selected$3
};
function PartAndOf({
  name: name2,
  code,
  ofCode,
  selected: selected2 = false,
  muted: muted2 = false,
  disabled: disabled2 = false,
  onSelect,
  className
}) {
  const classes = [
    styles$X.partAndOf,
    selected2 ? styles$X.selected : null,
    muted2 ? styles$X.muted : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: classes,
      onClick: onSelect,
      disabled: disabled2,
      children: [
        ofCode && /* @__PURE__ */ jsx("span", { className: styles$X.ofs, children: ofCode }),
        /* @__PURE__ */ jsx("span", { children: code ? `${name2} - ${code}` : name2 })
      ]
    }
  );
}
function useCountField({
  value: value2,
  minValue,
  onChange
}) {
  const valueOnFocus = useRef("");
  return {
    filled: value2 !== "" && value2 !== null && value2 !== void 0,
    // Scrolling over a focused number field would otherwise change the count
    // without the operator noticing.
    onWheel: (event) => event.currentTarget.blur(),
    onFocus: (event) => {
      valueOnFocus.current = event.target.value;
    },
    onBlur: (event) => {
      if (valueOnFocus.current !== "" && event.target.value === "") {
        onChange(String(minValue));
      }
    }
  };
}
const inputsPart = "_inputsPart_8poca_5 _root_17paw_3";
const field$2 = "_field_8poca_15";
const input$6 = "_input_8poca_5";
const filled$4 = "_filled_8poca_53";
const styles$W = {
  inputsPart,
  field: field$2,
  input: input$6,
  filled: filled$4
};
function NumberField({
  label: label2,
  name: name2,
  value: value2,
  minValue,
  onChange
}) {
  const { filled: filled2, ...countField } = useCountField({
    value: value2,
    minValue,
    onChange
  });
  return /* @__PURE__ */ jsxs("label", { className: styles$W.field, children: [
    label2,
    /* @__PURE__ */ jsx(
      "input",
      {
        className: `${styles$W.input} ${filled2 ? styles$W.filled : ""}`.trim(),
        type: "number",
        name: name2,
        value: value2,
        ...countField,
        onChange: (event) => onChange(event.target.value)
      }
    )
  ] });
}
function PartsQuantityInput({
  ok: ok2 = "",
  nok: nok2 = "",
  okLabel = "OK",
  nokLabel = "NOK",
  onlyNok = false,
  minValue = 0,
  onChange,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: `${styles$W.inputsPart} ${className ?? ""}`.trim(), children: [
    !onlyNok && /* @__PURE__ */ jsx(
      NumberField,
      {
        label: okLabel,
        name: "ok",
        value: ok2,
        minValue,
        onChange: (value2) => onChange({ ok: value2 })
      }
    ),
    /* @__PURE__ */ jsx(
      NumberField,
      {
        label: nokLabel,
        name: "nok",
        value: nok2,
        minValue,
        onChange: (value2) => onChange({ nok: value2 })
      }
    )
  ] });
}
const label$7 = "_label_bdfqt_5 _root_12v2e_3";
const container$2 = "_container_bdfqt_17";
const input$5 = "_input_bdfqt_35";
const toggle = "_toggle_bdfqt_46";
const styles$V = {
  label: label$7,
  container: container$2,
  input: input$5,
  toggle
};
function PasswordInput({
  label: label2,
  classNameLabel,
  showLabel = "Show password",
  hideLabel = "Hide password",
  className,
  ...rest
}) {
  const [visible, setVisible] = useState(false);
  return /* @__PURE__ */ jsxs("label", { className: `${styles$V.label} ${classNameLabel ?? ""}`.trim(), children: [
    label2,
    /* @__PURE__ */ jsxs("div", { className: styles$V.container, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          ...rest,
          type: visible ? "text" : "password",
          className: `${styles$V.input} ${className ?? ""}`.trim()
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: styles$V.toggle,
          "aria-label": visible ? hideLabel : showLabel,
          "aria-pressed": visible,
          onClick: () => setVisible((value2) => !value2),
          children: visible ? /* @__PURE__ */ jsx(EyeOffIcon, {}) : /* @__PURE__ */ jsx(EyeIcon, {})
        }
      )
    ] })
  ] });
}
const indicator$1 = "_indicator_t61xy_5 _root_1pnf0_3";
const button$2 = "_button_t61xy_18";
const label$6 = "_label_t61xy_25";
const footer$1 = "_footer_t61xy_33";
const styles$U = {
  indicator: indicator$1,
  button: button$2,
  label: label$6,
  footer: footer$1
};
function IndicatorTile({
  label: label2,
  quantity: quantity2 = 0,
  icon: icon2,
  onClick,
  className
}) {
  const content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("span", { className: styles$U.label, children: [
      icon2 && /* @__PURE__ */ jsx("span", { children: icon2 }),
      label2
    ] }),
    /* @__PURE__ */ jsx("span", { className: styles$U.footer, children: quantity2 })
  ] });
  if (onClick) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `${styles$U.indicator} ${styles$U.button} ${className ?? ""}`.trim(),
        onClick,
        children: content2
      }
    );
  }
  return /* @__PURE__ */ jsx("div", { className: `${styles$U.indicator} ${className ?? ""}`.trim(), children: content2 });
}
const indicator = "_indicator_vh12r_5 _root_63nur_3";
const dot$2 = "_dot_vh12r_15";
const label$5 = "_label_vh12r_22";
const value$4 = "_value_vh12r_30";
const styles$T = {
  indicator,
  dot: dot$2,
  label: label$5,
  value: value$4
};
function MetricIndicator({
  color,
  label: label2,
  value: value2,
  className
}) {
  const dotStyle = { backgroundColor: color };
  return /* @__PURE__ */ jsxs("div", { className: `${styles$T.indicator} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("span", { className: styles$T.dot, style: dotStyle }),
    /* @__PURE__ */ jsxs("span", { className: styles$T.label, children: [
      label2,
      value2 != null && /* @__PURE__ */ jsx("span", { className: styles$T.value, children: value2 })
    ] })
  ] });
}
const sliderCard = "_sliderCard_7prv3_3 _root_1pr0o_3";
const styles$S = {
  sliderCard
};
function SliderCard({ children, className }) {
  return /* @__PURE__ */ jsx("div", { className: `${styles$S.sliderCard} ${className ?? ""}`.trim(), children });
}
const navigation = "_navigation_vzgns_4 _root_4glgl_3";
const slider = "_slider_vzgns_10";
const prevButton = "_prevButton_vzgns_16";
const nextButton = "_nextButton_vzgns_17";
const styles$R = {
  navigation,
  slider,
  prevButton,
  nextButton
};
function Slider({
  items: items2 = [],
  itemWidth = 250,
  prevLabel = "Previous",
  nextLabel = "Next",
  className
}) {
  const [itemsPerPage, setItemsPerPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  useEffect(() => {
    const calculate = () => {
      setItemsPerPage(Math.max(1, Math.floor(window.innerWidth / itemWidth)));
    };
    calculate();
    window.addEventListener("resize", calculate);
    return () => window.removeEventListener("resize", calculate);
  }, [itemWidth]);
  const totalPages = itemsPerPage > 0 ? Math.ceil(items2.length / itemsPerPage) : 0;
  const page = Math.min(currentPage, Math.max(0, totalPages - 1));
  const startIndex = page * itemsPerPage;
  const visibleItems = items2.slice(startIndex, startIndex + itemsPerPage);
  const showPrev = page > 0;
  const showNext = page < totalPages - 1;
  return /* @__PURE__ */ jsxs("div", { className: `${styles$R.navigation} ${className ?? ""}`.trim(), children: [
    showPrev && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: styles$R.prevButton,
        "aria-label": prevLabel,
        onClick: () => setCurrentPage(page - 1),
        children: /* @__PURE__ */ jsx(ChevronLeftIcon, {})
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles$R.slider, children: visibleItems.map((item2, index2) => /* @__PURE__ */ jsx(SliderCard, { children: item2 }, startIndex + index2)) }),
    showNext && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: styles$R.nextButton,
        "aria-label": nextLabel,
        onClick: () => setCurrentPage(page + 1),
        children: /* @__PURE__ */ jsx(ChevronRightIcon, {})
      }
    )
  ] });
}
const sideBar = "_sideBar_gghb6_4 _root_c17vu_3";
const nav$1 = "_nav_gghb6_15";
const styles$Q = {
  sideBar,
  nav: nav$1
};
function SideBar({ children, width, className }) {
  const style = width != null ? { width: typeof width === "number" ? `${width}px` : width } : void 0;
  return /* @__PURE__ */ jsx(
    "aside",
    {
      className: `${styles$Q.sideBar} ${className ?? ""}`.trim(),
      style,
      children: /* @__PURE__ */ jsx("nav", { className: styles$Q.nav, children })
    }
  );
}
const sideItem = "_sideItem_1na60_4";
const linkToItem = "_linkToItem_1na60_8 _root_1q0ei_3";
const selected$2 = "_selected_1na60_32";
const icon$7 = "_icon_1na60_37";
const styles$P = {
  sideItem,
  linkToItem,
  selected: selected$2,
  icon: icon$7
};
function SideItem({
  label: label2,
  icon: icon2,
  active: active2 = false,
  onClick,
  className
}) {
  return /* @__PURE__ */ jsx("li", { className: `${styles$P.sideItem} ${className ?? ""}`.trim(), children: /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: `${styles$P.linkToItem} ${active2 ? styles$P.selected : ""}`.trim(),
      "aria-current": active2 ? "page" : void 0,
      onClick,
      children: [
        icon2 && /* @__PURE__ */ jsx("span", { className: styles$P.icon, children: icon2 }),
        label2
      ]
    }
  ) });
}
const topBar = "_topBar_vop65_5 _root_xoltz_3";
const styles$O = {
  topBar
};
function TopBar({ children, className }) {
  return /* @__PURE__ */ jsx("header", { className: `${styles$O.topBar} ${className ?? ""}`.trim(), children });
}
const btnHeader = "_btnHeader_wwt40_6 _root_6lpg0_3";
const active$2 = "_active_wwt40_34";
const styles$N = {
  btnHeader,
  active: active$2
};
function TopBarButton({
  children,
  icon: icon2,
  href,
  target,
  active: active2 = false,
  onClick,
  disabled: disabled2 = false,
  ariaLabel,
  style,
  className
}) {
  const classes = [styles$N.btnHeader, active2 ? styles$N.active : null, className].filter(Boolean).join(" ");
  if (href) {
    return /* @__PURE__ */ jsxs(
      "a",
      {
        className: classes,
        href,
        target,
        "aria-label": ariaLabel,
        style,
        children: [
          icon2,
          children
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: classes,
      onClick,
      disabled: disabled2,
      "aria-label": ariaLabel,
      style,
      children: [
        icon2,
        children
      ]
    }
  );
}
const menu = "_menu_e7xj6_5 _root_1uqyn_3";
const option$3 = "_option_e7xj6_23";
const selected$1 = "_selected_e7xj6_43";
const styles$M = {
  menu,
  option: option$3,
  selected: selected$1
};
function LanguageMenu({
  languages,
  value: value2,
  onChange,
  className
}) {
  return /* @__PURE__ */ jsx("div", { className: `${styles$M.menu} ${className ?? ""}`.trim(), role: "menu", children: languages.map((language) => {
    const selected2 = value2 === language.value;
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        role: "menuitemradio",
        "aria-checked": selected2,
        className: `${styles$M.option} ${selected2 ? styles$M.selected : ""}`.trim(),
        onClick: () => onChange(language.value),
        children: language.label
      },
      language.value
    );
  }) });
}
const backdrop = "_backdrop_1d1pn_5 _root_axu9u_3";
const panel$4 = "_panel_1d1pn_19";
const fadeIn = "_fadeIn_1d1pn_31";
const fadeOut = "_fadeOut_1d1pn_39";
const styles$L = {
  backdrop,
  panel: panel$4,
  fadeIn,
  fadeOut
};
function Modal({
  onClose,
  children,
  className,
  closeOnBackdrop = true,
  closeOnEscape = true,
  ariaLabel
}) {
  const [closing, setClosing] = useState(false);
  const backdropRef = useRef(null);
  const close = useCallback(() => setClosing(true), []);
  useEffect(() => {
    if (!closeOnEscape) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") close();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [closeOnEscape, close]);
  const onBackdropClick = (event) => {
    if (closeOnBackdrop && event.target === backdropRef.current) close();
  };
  const onAnimationEnd = (event) => {
    if (event.target === backdropRef.current && closing) onClose();
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: backdropRef,
      className: `${styles$L.backdrop}
        ${closing ? styles$L.fadeOut : styles$L.fadeIn}`,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": ariaLabel,
      onClick: onBackdropClick,
      onAnimationEnd,
      children: /* @__PURE__ */ jsx("section", { className: `${styles$L.panel} ${className ?? ""}`.trim(), children: typeof children === "function" ? children(close) : children })
    }
  );
}
const drawer = "_drawer_174od_5 _root_l25w6_3";
const header$5 = "_header_174od_41";
const back$2 = "_back_174od_62";
const content$3 = "_content_174od_79";
const footer = "_footer_174od_84";
const styles$K = {
  drawer,
  header: header$5,
  back: back$2,
  content: content$3,
  footer
};
function SideDrawer({
  children,
  title: title2,
  onBack,
  footer: footer2,
  onClose,
  closeOnOutsideClick = true,
  closeOnEscape = true,
  className,
  ariaLabel
}) {
  const drawerRef = useRef(null);
  useEffect(() => {
    if (!onClose) return;
    const onPointerDown = (event) => {
      if (closeOnOutsideClick && drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose();
      }
    };
    const onKeyDown = (event) => {
      if (closeOnEscape && event.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose, closeOnOutsideClick, closeOnEscape]);
  const hasHeader = title2 != null || onBack != null;
  return /* @__PURE__ */ jsxs(
    "aside",
    {
      ref: drawerRef,
      className: `${styles$K.drawer} ${className ?? ""}`.trim(),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": ariaLabel,
      children: [
        hasHeader && /* @__PURE__ */ jsxs("h2", { className: styles$K.header, children: [
          onBack && /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: styles$K.back,
              "aria-label": "Back",
              onClick: onBack,
              children: /* @__PURE__ */ jsx(ChevronLeftIcon, {})
            }
          ),
          title2
        ] }),
        /* @__PURE__ */ jsx("section", { className: styles$K.content, children }),
        footer2 && /* @__PURE__ */ jsx("footer", { className: styles$K.footer, children: footer2 })
      ]
    }
  );
}
const successMessage = "_successMessage_1safm_4";
const message$2 = "_message_1safm_14";
const icon$6 = "_icon_1safm_23 _root_vqz19_3";
const styles$J = {
  successMessage,
  message: message$2,
  icon: icon$6
};
function SuccessMessage({
  message: message2,
  icon: icon2,
  className
}) {
  return /* @__PURE__ */ jsx("section", { className: `${styles$J.successMessage} ${className ?? ""}`.trim(), children: /* @__PURE__ */ jsxs("span", { className: styles$J.message, children: [
    /* @__PURE__ */ jsx("span", { className: styles$J.icon, children: icon2 ?? /* @__PURE__ */ jsx(CheckIcon, {}) }),
    message2
  ] }) });
}
const confirmPartOk = "_confirmPartOk_c4zzn_4";
const infoPart = "_infoPart_c4zzn_18";
const of = "_of_c4zzn_25";
const name$3 = "_name_c4zzn_29";
const parts = "_parts_c4zzn_35";
const quantity$1 = "_quantity_c4zzn_42";
const styles$I = {
  confirmPartOk,
  infoPart,
  of,
  name: name$3,
  parts,
  quantity: quantity$1
};
function ConfirmPartSummary({
  name: name2,
  code,
  ofCode,
  goodLabel,
  goodValue = 0,
  scrapLabel,
  scrapValue,
  className
}) {
  return /* @__PURE__ */ jsxs("section", { className: `${styles$I.confirmPartOk} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsxs("div", { className: styles$I.infoPart, children: [
      ofCode && /* @__PURE__ */ jsx("span", { className: styles$I.of, children: ofCode }),
      /* @__PURE__ */ jsx("p", { className: styles$I.name, children: code ? `${name2} - ${code}` : name2 })
    ] }),
    /* @__PURE__ */ jsxs("span", { className: styles$I.parts, children: [
      goodLabel,
      /* @__PURE__ */ jsx("span", { className: styles$I.quantity, children: goodValue })
    ] }),
    Boolean(scrapValue) && /* @__PURE__ */ jsxs("span", { className: styles$I.parts, children: [
      scrapLabel,
      /* @__PURE__ */ jsx("span", { className: styles$I.quantity, children: scrapValue })
    ] })
  ] });
}
const inputsContainer = "_inputsContainer_1rjcf_4 _root_2brva_3";
const text$1 = "_text_1rjcf_14";
const inputs = "_inputs_1rjcf_4";
const input$4 = "_input_1rjcf_4";
const filled$3 = "_filled_1rjcf_43";
const styles$H = {
  inputsContainer,
  text: text$1,
  inputs,
  input: input$4,
  filled: filled$3
};
function ConfirmField({ name: name2, value: value2, minValue, onChange }) {
  const { filled: filled2, ...countField } = useCountField({
    value: value2,
    minValue,
    onChange
  });
  return /* @__PURE__ */ jsx(
    "input",
    {
      type: "number",
      name: String(name2),
      className: `${styles$H.input} ${filled2 ? styles$H.filled : ""}`.trim(),
      value: value2,
      ...countField,
      onChange: (event) => onChange(event.target.value)
    }
  );
}
function ConfirmQuantityInputs({
  label: label2,
  names,
  values: values2,
  minValue = 0,
  onChange,
  className
}) {
  return /* @__PURE__ */ jsxs("section", { className: `${styles$H.inputsContainer} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("span", { className: styles$H.text, children: label2 }),
    /* @__PURE__ */ jsx("div", { className: styles$H.inputs, children: names.map((name2) => /* @__PURE__ */ jsx(
      ConfirmField,
      {
        name: name2,
        value: values2[name2] ?? "",
        minValue,
        onChange: (value2) => onChange({ ...values2, [name2]: value2 })
      },
      name2
    )) })
  ] });
}
const tooltip = "_tooltip_i3dco_5 _root_19jhd_3";
const top = "_top_i3dco_29";
const bottom = "_bottom_i3dco_39";
const styles$G = {
  tooltip,
  top,
  bottom
};
function CaptureTooltip({
  children,
  left,
  visible = true,
  placement = "top",
  accent,
  className
}) {
  const style = {
    left: `${left}px`,
    opacity: visible ? 1 : 0,
    borderBottomColor: accent
  };
  const classes = [
    styles$G.tooltip,
    placement === "bottom" ? styles$G.bottom : styles$G.top,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classes,
      style,
      role: "tooltip",
      "aria-hidden": !visible,
      children
    }
  );
}
const timeLine = "_timeLine_1b0d0_5 _root_he9wl_3";
const hour = "_hour_1b0d0_16";
const styles$F = {
  timeLine,
  hour
};
function ScheduleTimeline({ hours, className }) {
  return /* @__PURE__ */ jsx("div", { className: `${styles$F.timeLine} ${className ?? ""}`.trim(), children: hours.map((hour2, index2) => /* @__PURE__ */ jsx(
    "span",
    {
      className: styles$F.hour,
      style: hour2.width != null ? { width: `${hour2.width}%` } : void 0,
      children: hour2.label
    },
    `${hour2.label}-${index2}`
  )) });
}
const row$3 = "_row_1b2x8_5 _root_xw8r0_3";
const navRow = "_navRow_1b2x8_26";
const title$6 = "_title_1b2x8_30";
const titleTotal = "_titleTotal_1b2x8_37";
const titleCount = "_titleCount_1b2x8_45 _title_1b2x8_30";
const total$1 = "_total_1b2x8_51";
const totalValue = "_totalValue_1b2x8_61";
const value$3 = "_value_1b2x8_62";
const chevron$2 = "_chevron_1b2x8_74";
const input$3 = "_input_1b2x8_80";
const styles$E = {
  row: row$3,
  navRow,
  title: title$6,
  titleTotal,
  titleCount,
  total: total$1,
  totalValue,
  value: value$3,
  chevron: chevron$2,
  input: input$3
};
function PartTotalRow({
  title: title2,
  label: label2,
  value: value2,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: `${styles$E.row} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("p", { className: styles$E.titleTotal, children: title2 }),
    /* @__PURE__ */ jsxs("p", { className: styles$E.total, children: [
      label2,
      /* @__PURE__ */ jsx("span", { className: styles$E.totalValue, children: value2 })
    ] })
  ] });
}
function PartNavRow({
  label: label2,
  value: value2,
  onSelect,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: `${styles$E.row} ${styles$E.navRow} ${className ?? ""}`.trim(),
      onClick: onSelect,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles$E.title, children: label2 }),
        /* @__PURE__ */ jsxs("span", { className: styles$E.value, children: [
          value2,
          /* @__PURE__ */ jsx(ChevronRightIcon, { className: styles$E.chevron, "aria-hidden": "true" })
        ] })
      ]
    }
  );
}
function PartCountRow({
  label: label2,
  value: value2,
  onChange,
  minValue = 0,
  action: action2,
  className
}) {
  const { onWheel, onFocus, onBlur } = useCountField({
    value: value2,
    minValue,
    onChange
  });
  return /* @__PURE__ */ jsxs("div", { className: `${styles$E.row} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("p", { className: styles$E.titleCount, children: label2 }),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "number",
        className: styles$E.input,
        value: value2,
        onWheel,
        onFocus,
        onBlur,
        onChange: (event) => onChange(event.target.value)
      }
    ),
    action2
  ] });
}
const SvgAddWidget = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(1.25 3.25)" }, /* @__PURE__ */ React.createElement("path", { d: "M18.8499 0.75H2.65006C1.60068 0.75 0.75 1.55967 0.75 2.55845V14.9415C0.75 15.9403 1.60068 16.75 2.65006 16.75H18.8499C19.8993 16.75 20.75 15.9403 20.75 14.9415V2.55845C20.75 1.55967 19.8993 0.75 18.8499 0.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.75 8.75H6.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.75 12.75V4.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })));
const SvgArrowMiniUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.59951 6.2L6.79966 2L10.9997 6.2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.79883 3V12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgBookmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 4.16669C5 3.47633 5.55964 2.91669 6.25 2.91669H13.75C14.4404 2.91669 15 3.47633 15 4.16669V17.0834L10 13.3334L5 17.0834V4.16669Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgBreakdown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "path-1-inside-1_618_50", fill: "white" }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3.5, width: 18, height: 8, rx: 1 })), /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3.5, width: 18, height: 8, rx: 1, stroke: "currentColor", strokeWidth: 3, mask: "url(#path-1-inside-1_618_50)" }), /* @__PURE__ */ React.createElement("path", { d: "M4.28564 15.5H19.7142", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.28564 20.5H19.7142", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgCal = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 16, height: 16, rx: 8, stroke: "#E6C882", strokeWidth: 6 }));
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.75 4C0.75 3.44772 1.19772 3 1.75 3H17.75C18.3023 3 18.75 3.44772 18.75 4V17.75C18.75 18.3023 18.3023 18.75 17.75 18.75H1.75C1.19772 18.75 0.75 18.3023 0.75 17.75V4Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18.75 8.625H0.75", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M5.25 3V0.75", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.25 3V0.75", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }));
const SvgCat = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5883 20L17.8236 4", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.17645 20L10.4117 4", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13.5883 20L17.8236 4", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 8L4.05882 8", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.9412 16L3.00004 16", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }));
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 6L9.23516 18L4 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgChecklistGroup = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.478 11.358H1.254a.637.637 0 01-.627-.643v-9.43c0-.36.288-.643.627-.643h9.193c.351 0 .627.296.627.643v3.443", stroke: "currentColor", strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M12.747 4.612H6.965a.406.406 0 00-.402.412v5.923c0 .227.18.41.402.41h5.782a.406.406 0 00.4-.41V5.024a.406.406 0 00-.4-.412z", stroke: "currentColor", strokeMiterlimit: 10 }));
const SvgClean = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 21, viewBox: "0 0 18 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.0786 10.0705C13.912 11.3827 14.0879 13.4324 13.5311 15.648C12.9744 17.8635 11.5395 19.3388 11.02 20.0046C10.4309 20.4672 9.34567 19.954 9.14393 19.8586L2.05727 16.2624C1.75465 16.1193 1.08563 15.6548 0.830568 14.9413C0.627297 14.5102 0.720756 13.348 2.72076 12.148C4.72076 10.948 6.77679 8.31462 7.55481 7.14795", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3.05481 16.6479C3.38814 16.4813 5.05481 15.6479 6.05481 14.1479", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.05481 18.6479C7.38814 18.4813 8.05481 18.1479 9.55481 16.1479", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.11218 5.77028L16.8397 11.3445", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.2442 8.66465L14.5784 0.750195", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgCommentsDashboard = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 17, viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.75 11.9896H10.8088C10.8088 11.9896 13.0423 15.1469 13.4374 15.5869C13.8324 16.027 14.0727 16.1767 14.4962 16.1767C15.1958 16.1767 15.555 15.5869 15.555 14.9972C15.555 14.4074 15.5735 11.9896 15.5735 11.9896H17.75C18.3023 11.9896 18.75 11.5418 18.75 10.9896V1.75C18.75 1.19772 18.3023 0.75 17.75 0.75H1.75C1.19772 0.75 0.75 1.19771 0.75 1.75V10.9896C0.75 11.5418 1.19771 11.9896 1.75 11.9896Z", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgConsumption = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 26, viewBox: "0 0 24 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5294 3L7.02391 11.2446C6.32475 11.851 6.75362 13 7.67914 13H16.1754C17.1178 13 17.537 14.1843 16.8046 14.7772L6.64706 23", stroke: "#15AFC0", strokeWidth: 6, strokeLinecap: "round" }));
const SvgContractIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 9L7.5 9C8.05228 9 8.5 8.55228 8.5 8L8.5 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.5 15L7.5 15C8.05229 15 8.5 15.4477 8.5 16L8.5 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.5 9L16.5 9C15.9477 9 15.5 8.55228 15.5 8L15.5 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.5 15L16.5 15C15.9477 15 15.5 15.4477 15.5 16L15.5 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgCrossmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.75 0.75L8.75 8.75", stroke: "#333D5F", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0.75 8.75L8.75 0.750001", stroke: "#333D5F", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgDefect = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 4C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M19.5 4.5L5 19.5M15 4L4 15M10 4L4 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgDenseExclamation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.01 10L10.01 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 6.25, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.01 12.5L10.01 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgDirectRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 12L19.5 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13.5 19L20.5 12L13.5 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgDis = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 22, viewBox: "0 0 24 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.1712 4.00808C10.9389 2.66407 12.8768 2.66407 13.6445 4.00808L17.0625 9.99177L20.5355 15.9436C21.3156 17.2805 20.3467 18.9588 18.7989 18.9516L11.9079 18.9198L5.01688 18.9516C3.46908 18.9588 2.50014 17.2805 3.28023 15.9436L6.75329 9.99177L10.1712 4.00808Z", stroke: "#E99AC9", strokeWidth: 6 }));
const SvgDownTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 9, viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.46139 8.50071C6.06561 9.09483 5.19269 9.09483 4.79691 8.50072L0.169471 1.55442C-0.273252 0.88984 0.203169 1.76351e-07 1.00171 1.0654e-07L10.2566 -7.02547e-07C11.0551 -7.72358e-07 11.5316 0.889837 11.0888 1.55441L6.46139 8.50071Z", fill: "#FD6C6C" }));
const SvgDownload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.75 0.75L9.75 14.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.75 9.67188L9.75 15.6719L15.75 9.67188", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0.75 18.5938H18.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgDowntimeArrowRegular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 25, viewBox: "0 0 22 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.001 3L11.001 19.375", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12.0938L11 20.0938L19 12.0938", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round" }));
const SvgDowntimeArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 25, viewBox: "0 0 22 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.001 3L11.001 19.375", stroke: "currentColor", strokeWidth: 6, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12.0938L11 20.0938L19 12.0938", stroke: "currentColor", strokeWidth: 6, strokeLinecap: "round" }));
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 10, viewBox: "0 0 18 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.75 0.750002L8.75164 8.75L0.750001 0.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgEdit = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(4.443 2.153)" }, /* @__PURE__ */ React.createElement("path", { d: "M1.57865 18.0816L0.759749 12.2594C0.730557 12.0519 0.767315 11.8404 0.86483 11.6549L6.3154 1.28508C6.56972 0.80125 7.1654 0.611256 7.65289 0.858488L13.8158 3.98404C14.3114 4.23536 14.507 4.84243 14.2515 5.33581L8.92152 15.6268C8.82524 15.8128 8.67303 15.9638 8.48637 16.0586L3.02172 18.8339C2.40999 19.1446 1.67422 18.761 1.57865 18.0816Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.74415 4.94023L12.2441 8.94023", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })));
const SvgEnergy = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.2653 10.366H14.1707L15.4883 4.90894C15.5998 4.44309 15.2529 3.99805 14.7779 3.99805H7.73156C7.32678 3.99805 7.00049 4.32663 7.00049 4.73425V12.3375C7.00049 12.7451 7.32678 13.0737 7.73156 13.0737H9.03674V19.2586C9.03674 19.9865 9.97019 20.2735 10.375 19.6745L15.8724 11.5181C16.2029 11.0273 15.8559 10.366 15.2653 10.366Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10 }));
const SvgExpand = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.5 4H4.5C3.94772 4 3.5 4.44772 3.5 5V9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.5 20H4.5C3.94772 20 3.5 19.5523 3.5 19V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.5 4L19.5 4C20.0523 4 20.5 4.44772 20.5 5V9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.5 20H19.5C20.0523 20 20.5 19.5523 20.5 19V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgEyeOff = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(1.25 6.25)" }, /* @__PURE__ */ React.createElement("path", { d: "M20.75 0.750002C20.75 2.03445 18.25 6.95772 10.616 6.7432C2.98203 6.52867 0.75 2.03445 0.75 0.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.75 7.25L10.75 10.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.11603 5.75L2.38397 8.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.2499 5.75L18.982 8.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })));
const SvgEye = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 12C2 12 5.63636 5 12 5C18.3636 5 22 12 22 12C22 12 18.3636 19 12 19C5.63636 19 2 12 2 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 2.75, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 17.7984 17.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.75292 0.75H16.0455C16.8403 0.75 17.3175 1.63252 16.8822 2.2976L11.145 11.0642V15.75C11.145 16.3023 10.6973 16.75 10.145 16.75H7.70058C7.1483 16.75 6.70058 16.3023 6.70058 15.75V11.0642L0.918244 2.30074C0.479554 1.63588 0.956375 0.75 1.75292 0.75Z", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgGas = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(2.5 5)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-211.847 -253.127)" }, /* @__PURE__ */ React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: 1.2, transform: "translate(211.847 256.127)" }, /* @__PURE__ */ React.createElement("rect", { stroke: "none", width: 19, height: 10, rx: 5 }), /* @__PURE__ */ React.createElement("rect", { x: 0.6, y: 0.6, width: 17.8, height: 8.8, rx: 4.4, fill: "none" })), /* @__PURE__ */ React.createElement("g", { fill: "none" }, /* @__PURE__ */ React.createElement("path", { stroke: "none", d: "M.01 0h5.158l1.317 4.047h-7.858z", transform: "translate(218.714 253.127)" }), /* @__PURE__ */ React.createElement("path", { d: "M.868 1.2.305 2.847h4.528L4.296 1.2H.868M.01 0h5.158l1.317 4.047h-7.858L.01 0z", fill: "currentColor", stroke: "none", transform: "translate(218.714 253.127)" })), /* @__PURE__ */ React.createElement("g", { transform: "translate(217.341 264.585)" }, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: 1.2, transform: "translate(-.494 -.458)", d: "M0 0v3" }), /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: 1.2, transform: "translate(8.506 -.458)", d: "M0 0v3" })))));
const SvgGroupTags = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 20, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.93726 11.75H17.1253C17.786 11.75 18.2651 12.3794 18.0892 13.0163L16.708 18.0163C16.5882 18.4498 16.1938 18.75 15.7441 18.75H1.75082C1.09065 18.75 0.61164 18.1216 0.786563 17.485L5.18318 1.48503C5.30248 1.05089 5.6972 0.75 6.14744 0.75L9.79585 0.75C10.4614 0.75 10.9413 1.38802 10.7566 2.02745L6.93801 15.25M6.09549 6.9142H17.9802M16.7193 2.28107L12.9403 15.25", stroke: "#9BA4B9", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgGroupstations = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 4C3 3.44772 3.44772 3 4 3H9C9.55228 3 10 3.44772 10 4V9C10 9.55228 9.55228 10 9 10H4C3.44772 10 3 9.55228 3 9V4ZM14 4C14 3.44772 14.4477 3 15 3H20C20.5523 3 21 3.44772 21 4V9C21 9.55228 20.5523 10 20 10H15C14.4477 10 14 9.55228 14 9V4ZM3 15C3 14.4477 3.44772 14 4 14H9C9.55228 14 10 14.4477 10 15V20C10 20.5523 9.55228 21 9 21H4C3.44772 21 3 20.5523 3 20V15ZM14 15C14 14.4477 14.4477 14 15 14H20C20.5523 14 21 14.4477 21 15V20C21 20.5523 20.5523 21 20 21H15C14.4477 21 14 20.5523 14 20V15Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
const SvgHashBold = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4V20", stroke: "currentColor", strokeWidth: 5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 8L4 8", stroke: "currentColor", strokeWidth: 5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 4V20", stroke: "currentColor", strokeWidth: 5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 16L4 16", stroke: "currentColor", strokeWidth: 5, strokeLinecap: "round" }));
const SvgHours = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9.25, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 8.6665V12.1109C12 12.6632 12.4477 13.1109 13 13.1109H15.3333", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgHuman = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 20C5.51852 18.6667 7.64444 16 12 16C16.3556 16 18.4815 18.6667 19 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 9, r: 4.25, stroke: "currentColor", strokeWidth: 1.5 }));
const SvgIconCollapseVertical = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 2.125L12.001 7.125L7 2.125", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.99998 21.875L11.999 16.875L17 21.875", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 11.875H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgIconExpandVertical = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 22, viewBox: "0 0 20 22", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.75 6.06066L9.74897 1.06066L14.75 6.06066", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0.75 10.8107H18.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.75 15.8107L9.75103 20.8107L4.75 15.8107", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgIconPause = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 6C5 5.44772 5.44772 5 6 5H9C9.55228 5 10 5.44772 10 6V18C10 18.5523 9.55228 19 9 19H6C5.44772 19 5 18.5523 5 18V6Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 6C14 5.44772 14.4477 5 15 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H15C14.4477 19 14 18.5523 14 18V6Z", stroke: "currentColor", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }));
const SvgInfo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 11V16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 8H12.01", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgLeftChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 20L8 12.0016L16 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgLuminaire = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12.0962, r: 4.85896, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 2L12 4.24358", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.1956 19.2916L17.6091 17.7052", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.14746 5.36538L5.73391 6.95183", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.3174 5.36538L18.7309 6.95183", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.80432 19.2916L6.39078 17.7052", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 22L12 19.7564", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22.0961 12.0961L19.8525 12.0961", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.90381 12.0961L4.14739 12.0961", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgMinusCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 12H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgOee = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.0066 3.37416C11.7029 2.87544 12.6395 2.87544 13.3358 3.37416L16.9499 5.96273L20.5286 8.60005C21.2181 9.10815 21.5075 9.99888 21.2483 10.8152L19.9033 15.0523L18.5009 19.2709C18.2308 20.0836 17.4731 20.6341 16.6166 20.6399L12.1712 20.67L7.7258 20.6399C6.86934 20.6341 6.11165 20.0836 5.84147 19.2709L4.43911 15.0523L3.09406 10.8152C2.83492 9.99888 3.12433 9.10815 3.81381 8.60005L7.39251 5.96273L11.0066 3.37416Z", stroke: "#FFBF85", strokeWidth: 6 }));
const SvgOrder = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.5 7.5L8 4L11.5 7.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 20V4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.5 16.5L16 20L12.5 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgPaper = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.759 3.30175C19.9728 2.83377 21.1665 4.02739 20.6985 5.2412L15.0696 19.8418C14.5256 21.2527 12.4714 21.0637 12.1946 19.5771L11.0383 13.3613C11.0004 13.1584 10.8418 12.9998 10.6389 12.9619L4.4231 11.8057C2.93656 11.5289 2.74749 9.47463 4.15845 8.93065L18.759 3.30175Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11.1389 12.873L20.1389 3.87305", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgPart = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.375 1.22656C9.76168 1.00337 10.2383 1.00337 10.625 1.22656L17.2852 5.07227C17.6718 5.29549 17.91 5.70787 17.9102 6.1543V13.8457C17.91 14.2921 17.6718 14.7045 17.2852 14.9277L10.625 18.7734C10.2383 18.9966 9.76168 18.9966 9.375 18.7734L2.71484 14.9277C2.32821 14.7045 2.08999 14.2921 2.08984 13.8457V6.1543C2.08999 5.70787 2.32821 5.29549 2.71484 5.07227L9.375 1.22656Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 3.25, stroke: "currentColor", strokeWidth: 1.5 }));
const SvgPartsCount = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2.75C13.2798 2.75002 14.2978 3.76864 14.2979 5C14.2979 5.01979 14.2966 5.03986 14.2949 5.08398L14.2666 5.86133H18.9844C19.1421 5.86146 19.2499 5.98442 19.25 6.11133V9.375C19.1625 9.36668 19.074 9.36037 18.9844 9.36035C17.4592 9.36035 16.2028 10.5814 16.2021 12.1104V12.1113C16.2024 13.641 17.4594 14.8613 18.9844 14.8613C19.074 14.8613 19.1625 14.855 19.25 14.8467V18.1123C19.2498 18.2393 19.1418 18.3622 18.9844 18.3623H14.3223L14.2949 19.084C14.2503 20.277 13.2501 21.25 12 21.25L11.7686 21.2393C10.6285 21.1279 9.74691 20.2023 9.70508 19.084L9.67773 18.3623H5.01562C4.85816 18.3622 4.75023 18.2393 4.75 18.1123V6.11133C4.75011 5.98442 4.85786 5.86146 5.01562 5.86133H9.7334L9.70508 5.08398C9.70344 5.03987 9.70215 5.01979 9.70215 5C9.70223 3.84555 10.5972 2.87804 11.7637 2.76172L12 2.75Z", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgPercentage = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(3.21 3.12)" }, /* @__PURE__ */ React.createElement("circle", { cx: 13.5808, cy: 13.7513, r: 3.25, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 4.21005, cy: 4.03091, r: 3.25, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16.75 0.75L0.75 16.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })));
const SvgPerformance = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 9.75, cy: 10.75, r: 2.25, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18.75 10.75C18.75 5.77944 14.7206 1.75 9.75 1.75C4.77944 1.75 0.75 5.77944 0.75 10.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.75 8.75L14.75 0.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgPersonalizedTime = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinecap: "square", color: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", d: "M10 7.758V2h5v5.758M15 15.242V22h-5v-6.758" }), /* @__PURE__ */ React.createElement("circle", { cx: 12.5, cy: 11.5, r: 4.5 }));
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 18.3072L5 5.75385C5 4.97924 5.84271 4.49875 6.50932 4.89327L17.4935 11.3941C18.1595 11.7883 18.1446 12.7571 17.4668 13.1305L6.4826 19.1831C5.81614 19.5503 5 19.0682 5 18.3072Z", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 1.5V18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.5 10H18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgPressure = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2.9375L12 14.6042", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7 11.0625L12.0002 16.0625L17 11.0625", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2 17.7292C4.50984 19.782 8.06186 21.0625 12 21.0625C15.9381 21.0625 19.4902 19.782 22 17.7292", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgRecurrence = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "-1 -1 20 20", fill: "none", stroke: "currentColor", strokeLinecap: "round", color: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.384 14.268a6.884 6.884 0 116.884-6.884", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11.917 6.172l3.624 1.903 1.903-3.624", strokeWidth: 1.5 }));
const SvgReload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C14.6503 4.5 16.9791 5.87614 18.3137 7.95455", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18.75 4.5V8.25H15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C9.34974 19.5 7.02092 18.1239 5.68629 16.0455", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.25 19.5V15.75H9", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgRemoveCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 12H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgRen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "path-1-inside-1_584_5165", fill: "white" }, /* @__PURE__ */ React.createElement("rect", { width: 22, height: 22, rx: 5 })), /* @__PURE__ */ React.createElement("rect", { width: 22, height: 22, rx: 5, stroke: "#6EB5FF", strokeWidth: 12, mask: "url(#path-1-inside-1_584_5165)" }));
const SvgRightChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4L16 11.9984L8 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgRound = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(16.735 21.618) rotate(180) translate(-0.5658 0)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.1561 12.0376C12.858 10.571 13.0807 8.86336 12.6744 7.15858C11.7321 3.20501 7.76318 0.763905 3.8096 1.70623C2.64167 1.9846 1.60573 2.5271 0.750015 3.2553", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.3002 11.305L11.6418 13.2993L9.67081 9.62743", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("g", { transform: "translate(6.6942 2.48)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.1561 12.0376C12.858 10.571 13.0807 8.86336 12.6744 7.15859C11.7321 3.20501 7.76318 0.763907 3.8096 1.70623C2.64167 1.98461 1.60573 2.5271 0.750015 3.2553", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.3002 11.305L11.6418 13.2994L9.67081 9.62744", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })));
const SvgScrap = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 21, viewBox: "0 0 22 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 10.625L7.30796 16.9018C7.43132 17.3301 7.82321 17.625 8.26889 17.625H13.7261C14.1715 17.625 14.5632 17.3304 14.6868 16.9025L16.5 10.625", stroke: "#FFABAB", strokeWidth: 6, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 3L19 3", stroke: "#FFABAB", strokeWidth: 6, strokeLinecap: "round" }));
const SvgSearch = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10.1841, cy: 10.1841, r: 6.25, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15.1841 15.1841L20.816 20.816", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgSensor = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2V10", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 3, stroke: "currentColor", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M7.05 7.05C5.68 8.42 4.85 10.3 4.85 12.37C4.85 16.32 8.05 19.52 12 19.52C15.95 19.52 19.15 16.32 19.15 12.37C19.15 10.3 18.32 8.42 16.95 7.05", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.22 4.22C2.24 6.2 1 8.95 1 12C1 18.08 5.92 23 12 23C18.08 23 23 18.08 23 12C23 8.95 21.76 6.2 19.78 4.22", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const SvgTag = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.91669 2.5L6.25002 17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13.75 2.5L12.0833 17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.33331 6.66669H16.6666", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2.91669 13.3333H16.25", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgTemperature = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2.75C13.6115 2.75 14.8495 3.98015 14.8496 5.41602V12.1377L15.165 12.3623C16.4416 13.2724 17.25 14.7067 17.25 16.3066C17.2498 19.0003 14.9369 21.25 12 21.25C9.06308 21.25 6.75016 19.0003 6.75 16.3066C6.75 14.7067 7.55844 13.2724 8.83496 12.3623L9.15039 12.1377V5.41602C9.15049 3.98015 10.3885 2.75 12 2.75Z", stroke: "currentColor", strokeWidth: 1.5 }));
const SvgTrash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.80005 6.59998V20C4.80005 20.5523 5.24776 21 5.80005 21H18.2C18.7523 21 19.2 20.5523 19.2 20V6.59998", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M3 6.59998L21 6.59998", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.30005 10.2V17.4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.7 10.2V17.4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16.5 6.6L16.5 4C16.5 3.44772 16.0523 3 15.5 3L8.5 3C7.94772 3 7.5 3.44771 7.5 4L7.5 6.15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const SvgTrendDownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.99999 1L1.30762 8.69237", stroke: "#ED7878", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1 2.84705V9.00094H7.1539", stroke: "#ED7878", strokeWidth: 2, strokeLinecap: "round" }));
const SvgTrendDownBoldArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.8492 5.81006L6.27036 17.3889", stroke: "#FFABAB", strokeWidth: 6, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.65686 6.38232L5.65685 17.696L16.9706 17.696", stroke: "#FFABAB", strokeWidth: 6, strokeLinecap: "round" }));
const SvgTrendUpArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.00001 9.00098L8.69238 1.3086", stroke: "#32CFB0", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 7.1539L9 1L2.8461 1", stroke: "#32CFB0", strokeWidth: 2, strokeLinecap: "round" }));
const SvgTrendUpBoldArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.50394 17.543L17.0828 5.96416", stroke: "#50E3C2", strokeWidth: 6, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.696 16.9706L17.696 5.65687L6.38226 5.65687", stroke: "#50E3C2", strokeWidth: 6, strokeLinecap: "round" }));
const SvgUpTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 9, viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.79691 0.445591C5.19269 -0.148521 6.06561 -0.148522 6.46139 0.44559L11.0888 7.39189C11.5316 8.05647 11.0551 8.94631 10.2566 8.94631L1.00171 8.94631C0.203166 8.94631 -0.273255 8.05647 0.169469 7.39189L4.79691 0.445591Z", fill: "#32CFB0" }));
const SvgUptimeArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 25, viewBox: "0 0 22 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.001 22L11.001 5.625", stroke: "#50E3C2", strokeWidth: 6, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12.9062L11 4.90625L19 12.9062", stroke: "#50E3C2", strokeWidth: 6, strokeLinecap: "round" }));
const SvgVibration = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 9.78168H6.77629C7.32858 9.78168 7.77629 10.2294 7.77629 10.7817L7.77629 14.9789C7.77629 15.5312 8.22401 15.9789 8.77629 15.9789H12.9014C13.4537 15.9789 13.9014 16.4266 13.9014 16.9789V21.3169", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.32397 2.68308H13.8749C14.4272 2.68308 14.8749 3.1308 14.8749 3.68308L14.8749 7.88027C14.8749 8.43256 15.3226 8.88028 15.8749 8.88028H20.0001C20.5523 8.88028 21.0001 9.32799 21.0001 9.88028V15.3592", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgWater = (props) => /* @__PURE__ */ React.createElement("svg", { stroke: "currentColor", width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.25 15.495c0 1.92-.625 3.213-1.485 4.028-.87.826-2.05 1.227-3.265 1.227a4.75 4.75 0 0 1-3.187-1.233c-.894-.825-1.563-2.12-1.563-4.022 0-1.406.723-3.388 1.709-5.398.969-1.975 2.129-3.854 2.882-5.013a.186.186 0 0 1 .159-.093c.055 0 .114.023.16.093.752 1.159 1.912 3.038 2.881 5.013.986 2.01 1.709 3.992 1.709 5.398z", strokeWidth: 1.5 }));
const SvgWorkstation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 6.96045V17.9604C3.75 18.5127 4.19772 18.9604 4.75 18.9604H16.75C17.3023 18.9604 17.75 18.5127 17.75 17.9604V12.9604V6.96045", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M0.75 8.96045L10.75 0.960449L20.75 8.96045", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgImportFile = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 6.50001L6.5 5.02909C6.5 4.4768 6.94772 4.02908 7.50001 4.02909L14.5795 4.02917C14.8484 4.02918 15.106 4.13751 15.2941 4.32971L19.2148 8.33563C19.3978 8.52251 19.5002 8.7736 19.5002 9.03509L19.5002 17.4554C19.5002 18.0077 19.0525 18.4554 18.5002 18.4554L17 18.4554", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.49982 7.97095L4.49982 18.9709C4.49982 19.5232 4.94753 19.9709 5.49982 19.9709L15.4998 19.9709C16.0521 19.9709 16.4998 19.5232 16.4998 18.9709L16.4998 11.0287C16.4998 10.771 16.4004 10.5233 16.2222 10.3372L13.2953 7.27951C13.1067 7.08245 12.8457 6.97101 12.5729 6.971L5.49982 6.97095C4.94754 6.97095 4.49982 7.41867 4.49982 7.97095Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }));
const SvgTwoParts = (props) => /* @__PURE__ */ React.createElement("svg", { width: 44, height: 25, viewBox: "0 0 44 25", fill: "none", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { "data-part": "primary" }, /* @__PURE__ */ React.createElement("path", { d: "m31.782 1.443 8.636 4.987a1 1 0 0 1 .5.866v9.972a1 1 0 0 1-.5.866l-8.636 4.986a1 1 0 0 1-1 0l-8.637-4.986a1 1 0 0 1-.5-.866V7.296a1 1 0 0 1 .5-.866l8.637-4.987a1 1 0 0 1 1 0z", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { cx: 31.114, cy: 12.282, r: 2.685, strokeWidth: 2 })), /* @__PURE__ */ React.createElement("g", { "data-part": "secondary" }, /* @__PURE__ */ React.createElement("path", { d: "m12.782 1.443 8.636 4.987a1 1 0 0 1 .5.866v9.972a1 1 0 0 1-.5.866l-8.636 4.986a1 1 0 0 1-1 0l-8.637-4.986a1 1 0 0 1-.5-.866V7.296a1 1 0 0 1 .5-.866l8.637-4.987a1 1 0 0 1 1 0z", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { cx: 12.278, cy: 12.282, r: 2.685, strokeWidth: 2 })));
const CaptureTwoPartsIcon = SvgTwoParts;
const CaptureImportFileIcon = SvgImportFile;
const BRAND_ICON_COLOR = "var(--mp-icon-color, var(--mp-brand-jacaranda-500))";
const withBrandColor = (Component) => {
  const Wrapped = ({ style, ...props }) => /* @__PURE__ */ jsx(Component, { style: { color: BRAND_ICON_COLOR, ...style }, ...props });
  Wrapped.displayName = `Branded(${Component.displayName ?? Component.name ?? "Icon"})`;
  return Wrapped;
};
withBrandColor(SvgBreakdown);
const CalendarIcon = withBrandColor(SvgCalendar);
withBrandColor(SvgClean);
withBrandColor(SvgContractIcon);
withBrandColor(SvgDefect);
withBrandColor(SvgDenseExclamation);
withBrandColor(SvgDirectRight);
withBrandColor(SvgDownload);
withBrandColor(SvgDowntimeArrow);
withBrandColor(SvgDowntimeArrowRegular);
const DropdownIcon = withBrandColor(SvgDropdown);
withBrandColor(SvgEdit);
withBrandColor(SvgIconCollapseVertical);
withBrandColor(SvgIconExpandVertical);
withBrandColor(SvgExpand);
withBrandColor(SvgFilter);
withBrandColor(SvgEye);
withBrandColor(SvgEyeOff);
withBrandColor(SvgPerformance);
withBrandColor(SvgArrowMiniUp);
withBrandColor(SvgScrap);
const SearchIcon = withBrandColor(SvgSearch);
withBrandColor(SvgOrder);
withBrandColor(SvgInfo);
withBrandColor(SvgTrendDownArrow);
withBrandColor(SvgTrendDownBoldArrow);
withBrandColor(SvgTrendUpArrow);
withBrandColor(SvgTrendUpBoldArrow);
withBrandColor(SvgUpTriangle);
withBrandColor(SvgDownTriangle);
withBrandColor(SvgUptimeArrow);
withBrandColor(SvgWorkstation);
const CrossmarkIcon = withBrandColor(SvgCrossmark);
withBrandColor(SvgPlay);
withBrandColor(SvgIconPause);
withBrandColor(SvgHours);
withBrandColor(SvgGroupstations);
withBrandColor(SvgChecklistGroup);
withBrandColor(SvgPersonalizedTime);
withBrandColor(SvgRecurrence);
withBrandColor(SvgPart);
withBrandColor(SvgPaper);
withBrandColor(SvgAddWidget);
withBrandColor(SvgPercentage);
withBrandColor(SvgHuman);
withBrandColor(SvgLeftChevron);
withBrandColor(SvgRightChevron);
withBrandColor(SvgCheck);
withBrandColor(SvgPlus);
withBrandColor(SvgTag);
withBrandColor(SvgMinusCircle);
withBrandColor(SvgTrash);
withBrandColor(SvgRemoveCircle);
withBrandColor(SvgGroupTags);
withBrandColor(SvgHashBold);
withBrandColor(SvgBookmark);
withBrandColor(SvgReload);
withBrandColor(SvgRound);
withBrandColor(SvgTemperature);
withBrandColor(SvgVibration);
withBrandColor(SvgPressure);
withBrandColor(SvgLuminaire);
withBrandColor(SvgPartsCount);
withBrandColor(SvgEnergy);
withBrandColor(SvgWater);
withBrandColor(SvgGas);
withBrandColor(SvgCommentsDashboard);
withBrandColor(SvgCat);
withBrandColor(SvgRen);
withBrandColor(SvgDis);
withBrandColor(SvgCal);
withBrandColor(SvgOee);
withBrandColor(SvgConsumption);
withBrandColor(SvgSensor);
const container$1 = "_container_o44mk_1 _root_122fe_3";
const lg$1 = "_lg_o44mk_16";
const md$1 = "_md_o44mk_20";
const sm$1 = "_sm_o44mk_24";
const icon$5 = "_icon_o44mk_33";
const clearButton = "_clearButton_o44mk_42";
const input$2 = "_input_o44mk_53";
const clearIcon = "_clearIcon_o44mk_105";
const styles$D = {
  container: container$1,
  lg: lg$1,
  md: md$1,
  sm: sm$1,
  icon: icon$5,
  clearButton,
  input: input$2,
  clearIcon
};
function SearchInput({
  value: value2,
  onChange,
  placeholder = "Buscar estación o parte",
  clearable = true,
  clearLabel = "Clear search",
  size: size2 = "lg",
  className
}) {
  const inputRef = useRef(null);
  const showClear = clearable && value2.length > 0;
  const handleClear = () => {
    var _a;
    onChange("");
    (_a = inputRef.current) == null ? void 0 : _a.focus();
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: [styles$D.container, styles$D[size2], className].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ jsx(SearchIcon, { className: styles$D.icon, "aria-hidden": "true" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: inputRef,
            type: "text",
            placeholder,
            value: value2,
            onChange: (e) => onChange(e.target.value),
            className: styles$D.input
          }
        ),
        showClear && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: styles$D.clearButton,
            onClick: handleClear,
            onMouseDown: (e) => e.preventDefault(),
            "aria-label": clearLabel,
            children: /* @__PURE__ */ jsx(CrossmarkIcon, { className: styles$D.clearIcon, "aria-hidden": "true" })
          }
        )
      ]
    }
  );
}
const listDefects = "_listDefects_je2uo_4 _root_3sgvi_3";
const part = "_part_je2uo_20";
const quantity = "_quantity_je2uo_26";
const current = "_current_je2uo_37";
const slash = "_slash_je2uo_38";
const total = "_total_je2uo_39";
const complete = "_complete_je2uo_58";
const list$1 = "_list_je2uo_4";
const search$2 = "_search_je2uo_74";
const scroll = "_scroll_je2uo_83";
const defectList = "_defectList_je2uo_89";
const defectContainer = "_defectContainer_je2uo_95";
const defect = "_defect_je2uo_89";
const input$1 = "_input_je2uo_107";
const filled$2 = "_filled_je2uo_126";
const styles$C = {
  listDefects,
  part,
  quantity,
  current,
  slash,
  total,
  complete,
  list: list$1,
  search: search$2,
  scroll,
  defectList,
  defectContainer,
  defect,
  input: input$1,
  filled: filled$2
};
function DefectRow({ name: name2, label: label2, value: value2, minValue, onChange }) {
  const { filled: filled2, ...countField } = useCountField({
    value: value2,
    minValue,
    onChange
  });
  return /* @__PURE__ */ jsx("li", { className: styles$C.defectContainer, children: /* @__PURE__ */ jsxs("label", { className: styles$C.defect, children: [
    label2,
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "number",
        name: name2,
        className: `${styles$C.input} ${filled2 ? styles$C.filled : ""}`.trim(),
        value: value2,
        ...countField,
        onChange: (event) => onChange(event.target.value)
      }
    )
  ] }) });
}
function DefectCountList({
  title: title2,
  total: total2,
  classifiedTotal,
  defects,
  values: values2,
  onChange,
  searchPlaceholder,
  minValue = 0,
  className
}) {
  const [filter, setFilter] = useState("");
  const complete2 = Number(classifiedTotal) === Number(total2);
  const query = filter.trim().toLowerCase();
  const visible = query ? defects.filter((defect2) => defect2.name.toLowerCase().includes(query)) : defects;
  return /* @__PURE__ */ jsxs("div", { className: `${styles$C.listDefects} ${className ?? ""}`.trim(), children: [
    title2 && /* @__PURE__ */ jsx("p", { className: styles$C.part, children: title2 }),
    /* @__PURE__ */ jsxs("p", { className: styles$C.quantity, children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: `${styles$C.current} ${complete2 ? styles$C.complete : ""}`.trim(),
          children: classifiedTotal
        }
      ),
      /* @__PURE__ */ jsx("span", { className: styles$C.slash, "aria-hidden": "true", children: "/" }),
      /* @__PURE__ */ jsx("span", { className: styles$C.total, children: total2 || 0 })
    ] }),
    /* @__PURE__ */ jsxs("section", { className: styles$C.list, children: [
      /* @__PURE__ */ jsx(
        SearchInput,
        {
          className: styles$C.search,
          size: "md",
          value: filter,
          onChange: setFilter,
          placeholder: searchPlaceholder
        }
      ),
      /* @__PURE__ */ jsx("div", { className: styles$C.scroll, children: /* @__PURE__ */ jsx("ul", { className: styles$C.defectList, children: visible.map((defect2, index2) => /* @__PURE__ */ jsx(
        DefectRow,
        {
          name: defect2.name,
          label: `${index2 + 1}.- ${defect2.name}`,
          value: values2[defect2.name] ?? "",
          minValue,
          onChange: (value2) => onChange({ [defect2.name]: value2 })
        },
        defect2.name
      )) }) })
    ] })
  ] });
}
const container = "_container_hew31_4 _root_1uo8c_5";
const error$2 = "_error_hew31_18";
const modalWarning = "_modalWarning_hew31_24";
const title$5 = "_title_hew31_40";
const subtitle$1 = "_subtitle_hew31_47";
const icon$4 = "_icon_hew31_53";
const messageBox = "_messageBox_hew31_63";
const message$1 = "_message_hew31_63";
const action = "_action_hew31_76";
const styles$B = {
  container,
  error: error$2,
  modalWarning,
  title: title$5,
  subtitle: subtitle$1,
  icon: icon$4,
  messageBox,
  message: message$1,
  action
};
function WarningModal({
  variant = "success",
  title: title2,
  subtitle: subtitle2,
  message: message2,
  icon: icon2,
  actionLabel,
  onAction,
  className
}) {
  const containerClass = [
    styles$B.container,
    variant === "error" ? styles$B.error : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("div", { className: containerClass, role: "alertdialog", "aria-modal": "true", children: /* @__PURE__ */ jsxs("div", { className: styles$B.modalWarning, children: [
    title2 != null && /* @__PURE__ */ jsx("h2", { className: styles$B.title, children: title2 }),
    subtitle2 != null && /* @__PURE__ */ jsx("h3", { className: styles$B.subtitle, children: subtitle2 }),
    /* @__PURE__ */ jsx("span", { className: styles$B.icon, children: icon2 ?? (variant === "error" ? /* @__PURE__ */ jsx(AlertIcon, {}) : /* @__PURE__ */ jsx(CheckIcon, {})) }),
    message2 != null && /* @__PURE__ */ jsx("div", { className: styles$B.messageBox, children: /* @__PURE__ */ jsx("span", { className: styles$B.message, children: message2 }) }),
    /* @__PURE__ */ jsx("button", { type: "button", className: styles$B.action, onClick: onAction, children: actionLabel })
  ] }) });
}
const progressBarParts = "_progressBarParts_1kadk_5 _root_mzwxh_3";
const label$4 = "_label_1kadk_20";
const bar$1 = "_bar_1kadk_24";
const segment = "_segment_1kadk_34";
const ok = "_ok_1kadk_52";
const nok = "_nok_1kadk_56";
const sensor = "_sensor_1kadk_60";
const values = "_values_1kadk_64";
const value$2 = "_value_1kadk_64";
const styles$A = {
  progressBarParts,
  label: label$4,
  bar: bar$1,
  segment,
  ok,
  nok,
  sensor,
  values,
  value: value$2
};
const toneClass$1 = {
  ok: styles$A.ok,
  nok: styles$A.nok,
  sensor: styles$A.sensor
};
const percent$1 = (value2, goal) => {
  if (goal) return value2 * 100 / goal;
  if (goal === 0) return 100;
  return 0;
};
function PartsProgressBar({
  label: label2,
  segments,
  goal,
  total: total2 = 0,
  goalValue = 0,
  separator: separator2 = "/",
  showValues = false,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: `${styles$A.progressBarParts} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("span", { className: styles$A.label, children: label2 }),
    /* @__PURE__ */ jsx("div", { className: styles$A.bar, children: segments.map((segment2) => /* @__PURE__ */ jsx(
      "span",
      {
        className: `${styles$A.segment} ${toneClass$1[segment2.tone]}`,
        style: { width: `${percent$1(segment2.value, goal)}%` }
      },
      segment2.tone
    )) }),
    showValues && /* @__PURE__ */ jsxs("div", { className: styles$A.values, children: [
      /* @__PURE__ */ jsx("span", { className: styles$A.value, children: total2 }),
      separator2,
      /* @__PURE__ */ jsx("span", { className: styles$A.value, children: goalValue })
    ] })
  ] });
}
const selectList = "_selectList_1hg7k_5 _root_o0jcv_5";
const search$1 = "_search_1hg7k_20";
const searchInput$3 = "_searchInput_1hg7k_27";
const panel$3 = "_panel_1hg7k_44";
const title$4 = "_title_1hg7k_51";
const options$1 = "_options_1hg7k_58";
const option$2 = "_option_1hg7k_58";
const selected = "_selected_1hg7k_87";
const styles$z = {
  selectList,
  search: search$1,
  searchInput: searchInput$3,
  panel: panel$3,
  title: title$4,
  options: options$1,
  option: option$2,
  selected
};
function matchesQuery$1(option2, query) {
  const haystack = `${option2.label} ${option2.searchText ?? ""}`.toLowerCase();
  return query.toLowerCase().trim().split(/\s+/).filter(Boolean).every((word) => haystack.includes(word));
}
function CaptureSelectList({
  options,
  value: value2 = null,
  onChange,
  title: title2,
  placeholder,
  className
}) {
  const [filter, setFilter] = useState("");
  const filtered = useMemo(
    () => filter.trim() ? options.filter((option2) => matchesQuery$1(option2, filter)) : options,
    [options, filter]
  );
  return /* @__PURE__ */ jsxs("section", { className: `${styles$z.selectList} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx("div", { className: styles$z.search, children: /* @__PURE__ */ jsx(
      SearchInput,
      {
        className: styles$z.searchInput,
        value: filter,
        onChange: setFilter,
        placeholder,
        size: "md"
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: styles$z.panel, children: [
      title2 && /* @__PURE__ */ jsx("h6", { className: styles$z.title, children: title2 }),
      /* @__PURE__ */ jsx("ul", { className: styles$z.options, role: "listbox", children: filtered.map((option2) => {
        const isSelected = option2.value === value2;
        return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            role: "option",
            "aria-selected": isSelected,
            className: `${styles$z.option} ${isSelected ? styles$z.selected : ""}`.trim(),
            onClick: () => onChange(option2.value),
            children: option2.label
          }
        ) }, option2.value);
      }) })
    ] })
  ] });
}
const checkbox = "_checkbox_u2hil_3 _root_1cwno_3";
const active$1 = "_active_u2hil_21";
const icon$3 = "_icon_u2hil_26";
const radio$1 = "_radio_u2hil_39";
const dot$1 = "_dot_u2hil_48";
const styles$y = {
  checkbox,
  active: active$1,
  icon: icon$3,
  radio: radio$1,
  dot: dot$1
};
function Checkbox({
  checked,
  onChange,
  indeterminate = false,
  disabled: disabled2 = false,
  variant = "checkbox",
  ariaLabel,
  id,
  className
}) {
  const isRadio = variant === "radio";
  const mixed = indeterminate && !isRadio;
  const active2 = checked || mixed;
  const classes = [
    styles$y.checkbox,
    isRadio ? styles$y.radio : null,
    active2 ? styles$y.active : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      role: isRadio ? "radio" : "checkbox",
      id,
      "aria-checked": mixed ? "mixed" : checked,
      "aria-label": ariaLabel,
      disabled: disabled2,
      onClick: () => onChange(!checked),
      className: classes,
      children: isRadio ? checked && /* @__PURE__ */ jsx("span", { className: styles$y.dot, "aria-hidden": true }) : mixed ? /* @__PURE__ */ jsx(Minus, { className: styles$y.icon, "aria-hidden": true, strokeWidth: 3 }) : checked && /* @__PURE__ */ jsx(Check, { className: styles$y.icon, "aria-hidden": true, strokeWidth: 3 })
    }
  );
}
const multiSelect = "_multiSelect_1iliv_5 _root_lotqf_3";
const searchContent = "_searchContent_1iliv_27";
const searchInput$2 = "_searchInput_1iliv_34";
const header$4 = "_header_1iliv_40";
const title$3 = "_title_1iliv_51";
const selectAllRow = "_selectAllRow_1iliv_62";
const list = "_list_1iliv_67";
const item = "_item_1iliv_76";
const itemSelected = "_itemSelected_1iliv_85";
const label$3 = "_label_1iliv_93";
const styles$x = {
  multiSelect,
  searchContent,
  searchInput: searchInput$2,
  header: header$4,
  title: title$3,
  selectAllRow,
  list,
  item,
  itemSelected,
  label: label$3
};
function matchesQuery(option2, query) {
  const haystack = `${option2.label} ${option2.searchText ?? ""}`.toLowerCase();
  return query.toLowerCase().trim().split(/\s+/).filter(Boolean).every((word) => haystack.includes(word));
}
function CaptureMultiSelectList({
  options,
  selected: selected2,
  onToggle,
  onToggleAll,
  title: title2,
  placeholder,
  selectAllLabel = "Select all",
  sort,
  className
}) {
  const [filter, setFilter] = useState("");
  const uid = useId$1();
  const filtered = useMemo(() => {
    const base = filter.trim() ? options.filter((option2) => matchesQuery(option2, filter)) : options;
    return sort ? [...base].sort(sort) : base;
  }, [options, filter, sort]);
  const allSelected = options.length > 0 && options.every((option2) => selected2.includes(option2.value));
  const someSelected = selected2.length > 0 && !allSelected;
  const showSelectAll = onToggleAll != null && filter.trim().length === 0;
  return /* @__PURE__ */ jsxs("section", { className: `${styles$x.multiSelect} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsxs("div", { className: styles$x.header, children: [
      title2 && /* @__PURE__ */ jsx("h4", { className: styles$x.title, children: title2 }),
      /* @__PURE__ */ jsx("div", { className: `${styles$x.searchContent}`, children: /* @__PURE__ */ jsx(
        SearchInput,
        {
          className: styles$x.searchInput,
          value: filter,
          onChange: setFilter,
          placeholder,
          size: "md"
        }
      ) })
    ] }),
    showSelectAll && /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${styles$x.item} ${styles$x.selectAllRow} ${allSelected ? styles$x.itemSelected : ""}`.trim(),
        children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              id: `${uid}-select-all`,
              checked: allSelected,
              indeterminate: someSelected,
              onChange: onToggleAll,
              ariaLabel: selectAllLabel
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: `${uid}-select-all`, className: styles$x.label, children: selectAllLabel })
        ]
      }
    ),
    /* @__PURE__ */ jsx("ul", { className: styles$x.list, children: filtered.map((option2) => {
      const checked = selected2.includes(option2.value);
      const id = `${uid}-${option2.value}`;
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${styles$x.item} ${checked ? styles$x.itemSelected : ""}`.trim(),
          children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                id,
                checked,
                onChange: () => onToggle(option2.value),
                ariaLabel: option2.label
              }
            ),
            /* @__PURE__ */ jsx("label", { htmlFor: id, className: styles$x.label, children: option2.label })
          ]
        }
      ) }, option2.value);
    }) })
  ] });
}
const group = "_group_1moi0_5 _root_ew9t8_5";
const column = "_column_1moi0_12";
const option$1 = "_option_1moi0_17";
const disabled$2 = "_disabled_1moi0_27";
const text = "_text_1moi0_32";
const styles$w = {
  group,
  column,
  option: option$1,
  disabled: disabled$2,
  text
};
function RadioGroup({
  options,
  value: value2,
  onChange,
  disabled: disabled2 = false,
  orientation = "row",
  ariaLabel,
  className
}) {
  const groupClass = [
    styles$w.group,
    orientation === "column" ? styles$w.column : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("div", { className: groupClass, role: "radiogroup", "aria-label": ariaLabel, children: options.map((option2) => {
    const selected2 = value2 === option2.value;
    const text2 = option2.ext ? `${option2.label} - ${option2.ext}` : option2.label;
    const select = () => {
      if (!disabled2 && !selected2) onChange(option2.value);
    };
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${styles$w.option} ${disabled2 ? styles$w.disabled : ""}`.trim(),
        children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              variant: "radio",
              checked: selected2,
              disabled: disabled2,
              ariaLabel: text2,
              onChange: (next) => {
                if (next) select();
              }
            }
          ),
          /* @__PURE__ */ jsx("span", { className: styles$w.text, onClick: select, children: text2 })
        ]
      },
      option2.value
    );
  }) });
}
const row$2 = "_row_5srxk_4 _root_5b3wj_4";
const disabled$1 = "_disabled_5srxk_15";
const label$2 = "_label_5srxk_20";
const styles$v = {
  row: row$2,
  disabled: disabled$1,
  label: label$2
};
function CheckAnswer({
  checked,
  onChange,
  label: label2,
  disabled: disabled2 = false,
  ariaLabel,
  className
}) {
  const toggle2 = () => {
    if (!disabled2) onChange(!checked);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: [styles$v.row, disabled2 ? styles$v.disabled : null, className].filter(Boolean).join(" "),
      children: [
        label2 != null && /* @__PURE__ */ jsx("span", { className: styles$v.label, onClick: toggle2, children: label2 }),
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked,
            onChange,
            disabled: disabled2,
            ariaLabel: ariaLabel ?? label2
          }
        )
      ]
    }
  );
}
const input = "_input_2yror_3 _root_tjiel_3";
const invalid$1 = "_invalid_2yror_22";
const styles$u = {
  input,
  invalid: invalid$1
};
function Input({
  value: value2,
  onChange,
  invalid: invalid2 = false,
  type = "text",
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      ...rest,
      type,
      value: value2,
      onChange: (e) => onChange(e.target.value),
      "aria-invalid": invalid2 || void 0,
      className: `${styles$u.input} ${invalid2 ? styles$u.invalid : ""} ${className ?? ""}`
    }
  );
}
const row$1 = "_row_tkqrj_4 _root_vtuco_4";
const unit = "_unit_tkqrj_12";
const filled$1 = "_filled_tkqrj_36";
const styles$t = {
  row: row$1,
  unit,
  filled: filled$1
};
const DEFAULT_MAX_LENGTH = 12;
function RangeAnswer({
  value: value2,
  onChange,
  unit: unit2,
  placeholder,
  maxLength = DEFAULT_MAX_LENGTH,
  disabled: disabled2 = false,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: [styles$t.row, value2 ? styles$t.filled : null, className].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "number",
            value: value2,
            placeholder,
            disabled: disabled2,
            onChange: (next) => onChange(next.slice(0, maxLength))
          }
        ),
        unit2 && /* @__PURE__ */ jsx("span", { className: styles$t.unit, children: unit2 })
      ]
    }
  );
}
const textarea = "_textarea_2z3hi_3 _root_cshi7_3";
const sunken = "_sunken_2z3hi_36 _sunken_cshi7_30";
const invalid = "_invalid_2z3hi_40";
const styles$s = {
  textarea,
  sunken,
  invalid
};
function Textarea({
  value: value2,
  onChange,
  invalid: invalid2 = false,
  variant = "default",
  className,
  ...rest
}) {
  const classes = [
    styles$s.textarea,
    variant === "sunken" ? styles$s.sunken : null,
    invalid2 ? styles$s.invalid : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      ...rest,
      value: value2,
      onChange: (e) => onChange(e.target.value),
      "aria-invalid": invalid2 || void 0,
      className: classes
    }
  );
}
const filled = "_filled_15k7b_14";
const styles$r = {
  filled
};
function OpenAnswer({
  value: value2,
  onChange,
  placeholder,
  rows = 2,
  disabled: disabled2 = false,
  className
}) {
  return /* @__PURE__ */ jsx(
    Textarea,
    {
      variant: "sunken",
      value: value2,
      onChange,
      placeholder,
      rows,
      disabled: disabled2,
      className: [value2 ? styles$r.filled : null, className].filter(Boolean).join(" ") || void 0
    }
  );
}
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const constructFromSymbol = Symbol.for("constructDateFrom");
function constructFrom(date, value2) {
  if (typeof date === "function") return date(value2);
  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value2);
  if (date instanceof Date) return new date.constructor(value2);
  return new Date(value2);
}
function toDate(argument, context) {
  return constructFrom(context || argument, argument);
}
function addDays(date, amount, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) return _date;
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addMonths(date, amount, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth
    );
    return _date;
  }
}
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date, options == null ? void 0 : options.in);
  const day2 = _date.getDay();
  const diff = (day2 < weekStartsOn ? 7 : 0) + day2 - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date, options) {
  return startOfWeek(date, { ...options, weekStartsOn: 1 });
}
function getISOWeekYear(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function normalizeDates(context, ...dates) {
  const normalize = constructFrom.bind(
    null,
    dates.find((date) => typeof date === "object")
  );
  return dates.map(normalize);
}
function startOfDay(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function differenceInCalendarDays(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  const laterStartOfDay = startOfDay(laterDate_);
  const earlierStartOfDay = startOfDay(earlierDate_);
  const laterTimestamp = +laterStartOfDay - getTimezoneOffsetInMilliseconds(laterStartOfDay);
  const earlierTimestamp = +earlierStartOfDay - getTimezoneOffsetInMilliseconds(earlierStartOfDay);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay);
}
function startOfISOWeekYear(date, options) {
  const year = getISOWeekYear(date, options);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function addWeeks(date, amount, options) {
  return addDays(date, amount * 7, options);
}
function addYears(date, amount, options) {
  return addMonths(date, amount * 12, options);
}
function max$1(dates, options) {
  let result;
  let context = options == null ? void 0 : options.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result < date_ || isNaN(+date_)) result = date_;
  });
  return constructFrom(context, result || NaN);
}
function min$1(dates, options) {
  let result;
  let context = options == null ? void 0 : options.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom.bind(null, date);
    const date_ = toDate(date, context);
    if (!result || result > date_ || isNaN(+date_)) result = date_;
  });
  return constructFrom(context, result || NaN);
}
function isSameDay(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  return +startOfDay(dateLeft_) === +startOfDay(dateRight_);
}
function isDate(value2) {
  return value2 instanceof Date || typeof value2 === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid(date) {
  return !(!isDate(date) && typeof date !== "number" || isNaN(+toDate(date)));
}
function differenceInCalendarMonths(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
  const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
  return yearsDiff * 12 + monthsDiff;
}
function endOfMonth(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const month2 = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month2 + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function normalizeInterval(context, interval) {
  const [start, end] = normalizeDates(context, interval.start, interval.end);
  return { start, end };
}
function eachMonthOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options == null ? void 0 : options.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setDate(1);
  let step = 1;
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setMonth(date.getMonth() + step);
  }
  return reversed ? dates.reverse() : dates;
}
function startOfMonth(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfYear(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function startOfYear(date, options) {
  const date_ = toDate(date, options == null ? void 0 : options.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}
function eachYearOfInterval(interval, options) {
  const { start, end } = normalizeInterval(options == null ? void 0 : options.in, interval);
  let reversed = +start > +end;
  const endTime = reversed ? +start : +end;
  const date = reversed ? end : start;
  date.setHours(0, 0, 0, 0);
  date.setMonth(0, 1);
  let step = 1;
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom(start, date));
    date.setFullYear(date.getFullYear() + step);
  }
  return reversed ? dates.reverse() : dates;
}
function endOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date, options == null ? void 0 : options.in);
  const day2 = _date.getDay();
  const diff = (day2 < weekStartsOn ? -7 : 0) + 6 - (day2 - weekStartsOn);
  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfISOWeek(date, options) {
  return endOfWeek(date, { ...options, weekStartsOn: 1 });
}
const formatDistanceLocale$2 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance$2 = (token, count2, options) => {
  let result;
  const tokenValue = formatDistanceLocale$2[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats$2 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats$2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats$2 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$2 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative$2 = (token, _date, _baseDate, _options) => formatRelativeLocale$2[token];
function buildLocalizeFn(args) {
  return (value2, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index2 = args.argumentCallback ? args.argumentCallback(value2) : value2;
    return valuesArray[index2];
  };
}
const eraValues$2 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues$2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues$2 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues$2 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues$2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues$2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber$2 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize$2 = {
  ordinalNumber: ordinalNumber$2,
  era: buildLocalizeFn({
    values: eraValues$2,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$2,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // [TODO] -- I challenge you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      options.valueCallback(value2)
    ) : value2;
    const rest = string.slice(matchedString.length);
    return { value: value2, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    const rest = string.slice(matchedString.length);
    return { value: value2, rest };
  };
}
const matchOrdinalNumberPattern$2 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$2 = /\d+/i;
const matchEraPatterns$2 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns$2 = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns$2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns$2 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns$2 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns$2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns$2 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns$2 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: (value2) => parseInt(value2, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: "any"
  })
};
const enUS$1 = {
  code: "en-US",
  formatDistance: formatDistance$2,
  formatLong: formatLong$2,
  formatRelative: formatRelative$2,
  localize: localize$2,
  match: match$2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function getISOWeek(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a, _b, _c, _d;
  const _date = toDate(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom((options == null ? void 0 : options.in) || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom((options == null ? void 0 : options.in) || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom((options == null ? void 0 : options.in) || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}
const lightFormatters = {
  // Year
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month2 = date.getMonth();
    return token === "M" ? String(month2 + 1) : addLeadingZeros(month2 + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    const month2 = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month2 + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month2, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month2, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month2, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    const month2 = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month2 + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month2 + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month2 + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month2, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month2, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month2, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    const week2 = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week2, { unit: "week" });
    }
    return addLeadingZeros(week2, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(+date / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize) {
    return addLeadingZeros(+date, token.length);
  }
};
function formatTimezoneShort(offset2, delimiter = "") {
  const sign = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, delimiter) {
  if (offset2 % 60 === 0) {
    const sign = offset2 > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, delimiter);
}
function formatTimezone(offset2, delimiter = "") {
  const sign = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input2) {
  const _message = message(token, format2, input2);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format2, input2) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input2}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS$1;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e = options == null ? void 0 : options.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate(date, options == null ? void 0 : options.in);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts2 = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts2 = locale.localize.preprocessor(originalDate, parts2);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts2.map((part2) => {
    if (!part2.isToken) return part2.value;
    const token = part2.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input2) {
  const matched = input2.match(escapedStringRegExp);
  if (!matched) {
    return input2;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function getDaysInMonth(date, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(_date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getMonth(date, options) {
  return toDate(date, options == null ? void 0 : options.in).getMonth();
}
function getYear(date, options) {
  return toDate(date, options == null ? void 0 : options.in).getFullYear();
}
function isAfter(date, dateToCompare) {
  return +toDate(date) > +toDate(dateToCompare);
}
function isBefore(date, dateToCompare) {
  return +toDate(date) < +toDate(dateToCompare);
}
function isSameMonth(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
function isSameYear(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
function setMonth(date, month2, options) {
  const _date = toDate(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const day2 = _date.getDate();
  const midMonth = constructFrom(date, 0);
  midMonth.setFullYear(year, month2, 15);
  midMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(midMonth);
  _date.setMonth(month2, Math.min(day2, daysInMonth));
  return _date;
}
function setYear(date, year, options) {
  const date_ = toDate(date, options == null ? void 0 : options.in);
  if (isNaN(+date_)) return constructFrom(date, NaN);
  date_.setFullYear(year);
  return date_;
}
const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
};
const formatDistance$1 = (token, count2, options) => {
  let result;
  const tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "hace " + result;
    }
  }
  return result;
};
const dateFormats$1 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
const timeFormats$1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$1 = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$1 = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
};
const formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
};
const formatRelative$1 = (token, date, _baseDate, _options) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return formatRelativeLocale$1[token];
  }
};
const eraValues$1 = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
};
const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
};
const monthValues$1 = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
};
const dayValues$1 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
};
const dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
};
const formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
};
const ordinalNumber$1 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};
const localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
const matchOrdinalNumberPattern$1 = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;
const matchEraPatterns$1 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const parseEraPatterns$1 = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
};
const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
const parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$1 = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const parseMonthPatterns$1 = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
};
const matchDayPatterns$1 = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const parseDayPatterns$1 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
const matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
const match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
const es$4 = {
  code: "es",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
};
const formatDistance = (token, count2, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count2));
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "în " + result;
    } else {
      return result + " în urmă";
    }
  }
  return result;
};
const dateFormats = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
};
const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
const eraValues = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru"
  ]
};
const monthValues = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec"
  ],
  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie"
  ]
};
const dayValues = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const matchOrdinalNumberPattern = /^(\d+)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
const parseEraPatterns = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i
  ]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
const parseMonthPatterns = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
const parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value2) => parseInt(value2, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const ro$4 = {
  code: "ro",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function tzName(timeZone, date, format2 = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone,
    timeZoneName: format2
  }).format(date).split(/\s/g).slice(2).join(" ");
}
const offsetFormatCache = {};
const offsetCache = {};
function tzOffset(timeZone, date) {
  try {
    const format2 = offsetFormatCache[timeZone] || (offsetFormatCache[timeZone] = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "longOffset"
    }).format);
    const offsetStr = format2(date).split("GMT")[1];
    if (offsetStr in offsetCache) return offsetCache[offsetStr];
    return calcOffset(offsetStr, offsetStr.split(":"));
  } catch {
    if (timeZone in offsetCache) return offsetCache[timeZone];
    const captures = timeZone == null ? void 0 : timeZone.match(offsetRe);
    if (captures) return calcOffset(timeZone, captures.slice(1));
    return NaN;
  }
}
const offsetRe = /([+-]\d\d):?(\d\d)?/;
function calcOffset(cacheStr, values2) {
  const hours = +(values2[0] || 0);
  const minutes = +(values2[1] || 0);
  const seconds = +(values2[2] || 0) / 60;
  return offsetCache[cacheStr] = hours * 60 + minutes > 0 ? hours * 60 + minutes + seconds : hours * 60 - minutes - seconds;
}
class TZDateMini extends Date {
  //#region static
  constructor(...args) {
    super();
    if (args.length > 1 && typeof args[args.length - 1] === "string") {
      this.timeZone = args.pop();
    }
    this.internal = /* @__PURE__ */ new Date();
    if (isNaN(tzOffset(this.timeZone, this))) {
      this.setTime(NaN);
    } else {
      if (!args.length) {
        this.setTime(Date.now());
      } else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) {
        this.setTime(args[0]);
      } else if (typeof args[0] === "string") {
        this.setTime(+new Date(args[0]));
      } else if (args[0] instanceof Date) {
        this.setTime(+args[0]);
      } else {
        this.setTime(+new Date(...args));
        adjustToSystemTZ(this);
        syncToInternal(this);
      }
    }
  }
  static tz(tz, ...args) {
    return args.length ? new TZDateMini(...args, tz) : new TZDateMini(Date.now(), tz);
  }
  //#endregion
  //#region time zone
  withTimeZone(timeZone) {
    return new TZDateMini(+this, timeZone);
  }
  getTimezoneOffset() {
    const offset2 = -tzOffset(this.timeZone, this);
    return offset2 > 0 ? Math.floor(offset2) : Math.ceil(offset2);
  }
  //#endregion
  //#region time
  setTime(time) {
    Date.prototype.setTime.apply(this, arguments);
    syncToInternal(this);
    return +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](date) {
    return new TZDateMini(+new Date(date), this.timeZone);
  }
  //#endregion
}
const re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method) => {
  if (!re.test(method)) return;
  const utcMethod = method.replace(re, "$1UTC");
  if (!TZDateMini.prototype[utcMethod]) return;
  if (method.startsWith("get")) {
    TZDateMini.prototype[method] = function() {
      return this.internal[utcMethod]();
    };
  } else {
    TZDateMini.prototype[method] = function() {
      Date.prototype[utcMethod].apply(this.internal, arguments);
      syncFromInternal(this);
      return +this;
    };
    TZDateMini.prototype[utcMethod] = function() {
      Date.prototype[utcMethod].apply(this, arguments);
      syncToInternal(this);
      return +this;
    };
  }
});
function syncToInternal(date) {
  date.internal.setTime(+date);
  date.internal.setUTCSeconds(date.internal.getUTCSeconds() - Math.round(-tzOffset(date.timeZone, date) * 60));
}
function syncFromInternal(date) {
  Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
  Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());
  adjustToSystemTZ(date);
}
function adjustToSystemTZ(date) {
  const baseOffset = tzOffset(date.timeZone, date);
  const offset2 = baseOffset > 0 ? Math.floor(baseOffset) : Math.ceil(baseOffset);
  const prevHour = /* @__PURE__ */ new Date(+date);
  prevHour.setUTCHours(prevHour.getUTCHours() - 1);
  const systemOffset = -(/* @__PURE__ */ new Date(+date)).getTimezoneOffset();
  const prevHourSystemOffset = -(/* @__PURE__ */ new Date(+prevHour)).getTimezoneOffset();
  const systemDSTChange = systemOffset - prevHourSystemOffset;
  const dstShift = Date.prototype.getHours.apply(date) !== date.internal.getUTCHours();
  if (systemDSTChange && dstShift) date.internal.setUTCMinutes(date.internal.getUTCMinutes() + systemDSTChange);
  const offsetDiff = systemOffset - offset2;
  if (offsetDiff) Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);
  const systemDate = /* @__PURE__ */ new Date(+date);
  systemDate.setUTCSeconds(0);
  const systemSecondsOffset = systemOffset > 0 ? systemDate.getSeconds() : (systemDate.getSeconds() - 60) % 60;
  const secondsOffset = Math.round(-(tzOffset(date.timeZone, date) * 60)) % 60;
  if (secondsOffset || systemSecondsOffset) {
    date.internal.setUTCSeconds(date.internal.getUTCSeconds() + secondsOffset);
    Date.prototype.setUTCSeconds.call(date, Date.prototype.getUTCSeconds.call(date) + secondsOffset + systemSecondsOffset);
  }
  const postBaseOffset = tzOffset(date.timeZone, date);
  const postOffset = postBaseOffset > 0 ? Math.floor(postBaseOffset) : Math.ceil(postBaseOffset);
  const postSystemOffset = -(/* @__PURE__ */ new Date(+date)).getTimezoneOffset();
  const postOffsetDiff = postSystemOffset - postOffset;
  const offsetChanged = postOffset !== offset2;
  const postDiff = postOffsetDiff - offsetDiff;
  if (offsetChanged && postDiff) {
    Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);
    const newBaseOffset = tzOffset(date.timeZone, date);
    const newOffset = newBaseOffset > 0 ? Math.floor(newBaseOffset) : Math.ceil(newBaseOffset);
    const offsetChange = postOffset - newOffset;
    if (offsetChange) {
      date.internal.setUTCMinutes(date.internal.getUTCMinutes() + offsetChange);
      Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
    }
  }
}
class TZDate extends TZDateMini {
  //#region static
  static tz(tz, ...args) {
    return args.length ? new TZDate(...args, tz) : new TZDate(Date.now(), tz);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [sign, hours, minutes] = this.tzComponents();
    const tz = `${sign}${hours}:${minutes}`;
    return this.internal.toISOString().slice(0, -1) + tz;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [day2, date, month2, year] = this.internal.toUTCString().split(" ");
    return `${day2 == null ? void 0 : day2.slice(0, -1)} ${month2} ${date} ${year}`;
  }
  toTimeString() {
    const time = this.internal.toUTCString().split(" ")[4];
    const [sign, hours, minutes] = this.tzComponents();
    return `${time} GMT${sign}${hours}${minutes} (${tzName(this.timeZone, this)})`;
  }
  toLocaleString(locales, options) {
    return Date.prototype.toLocaleString.call(this, locales, {
      ...options,
      timeZone: (options == null ? void 0 : options.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(locales, options) {
    return Date.prototype.toLocaleDateString.call(this, locales, {
      ...options,
      timeZone: (options == null ? void 0 : options.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(locales, options) {
    return Date.prototype.toLocaleTimeString.call(this, locales, {
      ...options,
      timeZone: (options == null ? void 0 : options.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const offset2 = this.getTimezoneOffset();
    const sign = offset2 > 0 ? "-" : "+";
    const hours = String(Math.floor(Math.abs(offset2) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset2) % 60).padStart(2, "0");
    return [sign, hours, minutes];
  }
  //#endregion
  withTimeZone(timeZone) {
    return new TZDate(+this, timeZone);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](date) {
    return new TZDate(+new Date(date), this.timeZone);
  }
  //#endregion
}
const FIVE_WEEKS = 5;
const FOUR_WEEKS = 4;
function getBroadcastWeeksInMonth(month2, dateLib) {
  const firstDayOfMonth = dateLib.startOfMonth(month2);
  const firstDayOfWeek = firstDayOfMonth.getDay() > 0 ? firstDayOfMonth.getDay() : 7;
  const broadcastStartDate = dateLib.addDays(month2, -firstDayOfWeek + 1);
  const lastDateOfLastWeek = dateLib.addDays(broadcastStartDate, FIVE_WEEKS * 7 - 1);
  const numberOfWeeks = dateLib.getMonth(month2) === dateLib.getMonth(lastDateOfLastWeek) ? FIVE_WEEKS : FOUR_WEEKS;
  return numberOfWeeks;
}
function startOfBroadcastWeek(date, dateLib) {
  const firstOfMonth = dateLib.startOfMonth(date);
  const dayOfWeek = firstOfMonth.getDay();
  if (dayOfWeek === 1) {
    return firstOfMonth;
  } else if (dayOfWeek === 0) {
    return dateLib.addDays(firstOfMonth, -1 * 6);
  } else {
    return dateLib.addDays(firstOfMonth, -1 * (dayOfWeek - 1));
  }
}
function endOfBroadcastWeek(date, dateLib) {
  const startDate = startOfBroadcastWeek(date, dateLib);
  const numberOfWeeks = getBroadcastWeeksInMonth(date, dateLib);
  const endDate = dateLib.addDays(startDate, numberOfWeeks * 7 - 1);
  return endDate;
}
const enUS = {
  ...enUS$1,
  labels: {
    labelDayButton: (date, modifiers, options, dateLib) => {
      let formatDate;
      if (dateLib && typeof dateLib.format === "function") {
        formatDate = dateLib.format.bind(dateLib);
      } else {
        formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
      }
      let label2 = formatDate(date, "PPPP");
      if (modifiers.today)
        label2 = `Today, ${label2}`;
      if (modifiers.selected)
        label2 = `${label2}, selected`;
      return label2;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (weekNumber2) => `Week ${weekNumber2}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (date, options, dateLib) => {
      let formatDate;
      if (dateLib && typeof dateLib.format === "function") {
        formatDate = dateLib.format.bind(dateLib);
      } else {
        formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
      }
      return formatDate(date, "LLLL yyyy");
    },
    labelGridcell: (date, modifiers, options, dateLib) => {
      let formatDate;
      if (dateLib && typeof dateLib.format === "function") {
        formatDate = dateLib.format.bind(dateLib);
      } else {
        formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
      }
      let label2 = formatDate(date, "PPPP");
      if (modifiers == null ? void 0 : modifiers.today) {
        label2 = `Today, ${label2}`;
      }
      return label2;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (date, options, dateLib) => {
      let formatDate;
      if (dateLib && typeof dateLib.format === "function") {
        formatDate = dateLib.format.bind(dateLib);
      } else {
        formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
      }
      return formatDate(date, "cccc");
    }
  }
};
class DateLib {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(options, overrides) {
    this.Date = Date;
    this.today = () => {
      var _a;
      if ((_a = this.overrides) == null ? void 0 : _a.today) {
        return this.overrides.today();
      }
      if (this.options.timeZone) {
        return TZDate.tz(this.options.timeZone);
      }
      return new this.Date();
    };
    this.newDate = (year, monthIndex, date) => {
      var _a;
      if ((_a = this.overrides) == null ? void 0 : _a.newDate) {
        return this.overrides.newDate(year, monthIndex, date);
      }
      if (this.options.timeZone) {
        return new TZDate(year, monthIndex, date, this.options.timeZone);
      }
      return new Date(year, monthIndex, date);
    };
    this.addDays = (date, amount) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.addDays) ? this.overrides.addDays(date, amount) : addDays(date, amount);
    };
    this.addMonths = (date, amount) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.addMonths) ? this.overrides.addMonths(date, amount) : addMonths(date, amount);
    };
    this.addWeeks = (date, amount) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.addWeeks) ? this.overrides.addWeeks(date, amount) : addWeeks(date, amount);
    };
    this.addYears = (date, amount) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.addYears) ? this.overrides.addYears(date, amount) : addYears(date, amount);
    };
    this.differenceInCalendarDays = (dateLeft, dateRight) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.differenceInCalendarDays) ? this.overrides.differenceInCalendarDays(dateLeft, dateRight) : differenceInCalendarDays(dateLeft, dateRight);
    };
    this.differenceInCalendarMonths = (dateLeft, dateRight) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.differenceInCalendarMonths) ? this.overrides.differenceInCalendarMonths(dateLeft, dateRight) : differenceInCalendarMonths(dateLeft, dateRight);
    };
    this.eachMonthOfInterval = (interval) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.eachMonthOfInterval) ? this.overrides.eachMonthOfInterval(interval) : eachMonthOfInterval(interval);
    };
    this.eachYearOfInterval = (interval) => {
      var _a;
      const years = ((_a = this.overrides) == null ? void 0 : _a.eachYearOfInterval) ? this.overrides.eachYearOfInterval(interval) : eachYearOfInterval(interval);
      const uniqueYears = new Set(years.map((d) => this.getYear(d)));
      if (uniqueYears.size === years.length) {
        return years;
      }
      const yearsArray = [];
      uniqueYears.forEach((y) => {
        yearsArray.push(new Date(y, 0, 1));
      });
      return yearsArray;
    };
    this.endOfBroadcastWeek = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.endOfBroadcastWeek) ? this.overrides.endOfBroadcastWeek(date) : endOfBroadcastWeek(date, this);
    };
    this.endOfISOWeek = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.endOfISOWeek) ? this.overrides.endOfISOWeek(date) : endOfISOWeek(date);
    };
    this.endOfMonth = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.endOfMonth) ? this.overrides.endOfMonth(date) : endOfMonth(date);
    };
    this.endOfWeek = (date, options2) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.endOfWeek) ? this.overrides.endOfWeek(date, options2) : endOfWeek(date, this.options);
    };
    this.endOfYear = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.endOfYear) ? this.overrides.endOfYear(date) : endOfYear(date);
    };
    this.format = (date, formatStr, _options) => {
      var _a;
      const formatted = ((_a = this.overrides) == null ? void 0 : _a.format) ? this.overrides.format(date, formatStr, this.options) : format(date, formatStr, this.options);
      if (this.options.numerals && this.options.numerals !== "latn") {
        return this.replaceDigits(formatted);
      }
      return formatted;
    };
    this.getISOWeek = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.getISOWeek) ? this.overrides.getISOWeek(date) : getISOWeek(date);
    };
    this.getMonth = (date, _options) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.getMonth) ? this.overrides.getMonth(date, this.options) : getMonth(date, this.options);
    };
    this.getYear = (date, _options) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.getYear) ? this.overrides.getYear(date, this.options) : getYear(date, this.options);
    };
    this.getWeek = (date, _options) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.getWeek) ? this.overrides.getWeek(date, this.options) : getWeek(date, this.options);
    };
    this.isAfter = (date, dateToCompare) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isAfter) ? this.overrides.isAfter(date, dateToCompare) : isAfter(date, dateToCompare);
    };
    this.isBefore = (date, dateToCompare) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isBefore) ? this.overrides.isBefore(date, dateToCompare) : isBefore(date, dateToCompare);
    };
    this.isDate = (value2) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isDate) ? this.overrides.isDate(value2) : isDate(value2);
    };
    this.isSameDay = (dateLeft, dateRight) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isSameDay) ? this.overrides.isSameDay(dateLeft, dateRight) : isSameDay(dateLeft, dateRight);
    };
    this.isSameMonth = (dateLeft, dateRight) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isSameMonth) ? this.overrides.isSameMonth(dateLeft, dateRight) : isSameMonth(dateLeft, dateRight);
    };
    this.isSameYear = (dateLeft, dateRight) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.isSameYear) ? this.overrides.isSameYear(dateLeft, dateRight) : isSameYear(dateLeft, dateRight);
    };
    this.max = (dates) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.max) ? this.overrides.max(dates) : max$1(dates);
    };
    this.min = (dates) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.min) ? this.overrides.min(dates) : min$1(dates);
    };
    this.setMonth = (date, month2) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.setMonth) ? this.overrides.setMonth(date, month2) : setMonth(date, month2);
    };
    this.setYear = (date, year) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.setYear) ? this.overrides.setYear(date, year) : setYear(date, year);
    };
    this.startOfBroadcastWeek = (date, _dateLib) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfBroadcastWeek) ? this.overrides.startOfBroadcastWeek(date, this) : startOfBroadcastWeek(date, this);
    };
    this.startOfDay = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfDay) ? this.overrides.startOfDay(date) : startOfDay(date);
    };
    this.startOfISOWeek = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfISOWeek) ? this.overrides.startOfISOWeek(date) : startOfISOWeek(date);
    };
    this.startOfMonth = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfMonth) ? this.overrides.startOfMonth(date) : startOfMonth(date);
    };
    this.startOfWeek = (date, _options) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfWeek) ? this.overrides.startOfWeek(date, this.options) : startOfWeek(date, this.options);
    };
    this.startOfYear = (date) => {
      var _a;
      return ((_a = this.overrides) == null ? void 0 : _a.startOfYear) ? this.overrides.startOfYear(date) : startOfYear(date);
    };
    this.options = { locale: enUS, ...options };
    this.overrides = overrides;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals = "latn" } = this.options;
    const formatter = new Intl.NumberFormat("en-US", {
      numberingSystem: numerals
    });
    const digitMap = {};
    for (let i = 0; i < 10; i++) {
      digitMap[i.toString()] = formatter.format(i);
    }
    return digitMap;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(input2) {
    const digitMap = this.getDigitMap();
    return input2.replace(/\d/g, (digit) => digitMap[digit] || digit);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(value2) {
    return this.replaceDigits(value2.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    var _a;
    const code = (_a = this.options.locale) == null ? void 0 : _a.code;
    if (!code) {
      return "month-first";
    }
    return DateLib.yearFirstLocales.has(code) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(date) {
    const { locale, timeZone, numerals } = this.options;
    const localeCode = locale == null ? void 0 : locale.code;
    if (localeCode && DateLib.yearFirstLocales.has(localeCode)) {
      try {
        const intl = new Intl.DateTimeFormat(localeCode, {
          month: "long",
          year: "numeric",
          timeZone,
          numberingSystem: numerals
        });
        const formatted = intl.format(date);
        return formatted;
      } catch {
      }
    }
    const pattern = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(date, pattern);
  }
}
DateLib.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const defaultDateLib = new DateLib();
const es$3 = {
  ...es$4,
  labels: {
    labelDayButton: (date, modifiers, options, dateLib) => {
      const lib = dateLib ?? new DateLib(options);
      let label2 = lib.format(date, "PPPP");
      if (modifiers.today)
        label2 = `Hoy, ${label2}`;
      if (modifiers.selected)
        label2 = `${label2}, seleccionado`;
      return label2;
    },
    labelMonthDropdown: "Elegir el mes",
    labelNext: "Ir al mes siguiente",
    labelPrevious: "Ir al mes anterior",
    labelWeekNumber: (weekNumber2) => `Semana ${weekNumber2}`,
    labelYearDropdown: "Elegir el año",
    labelGrid: (date, options, dateLib) => (dateLib ?? new DateLib(options)).formatMonthYear(date),
    labelGridcell: (date, modifiers, options, dateLib) => {
      const lib = dateLib ?? new DateLib(options);
      let label2 = lib.format(date, "PPPP");
      if (modifiers == null ? void 0 : modifiers.today) {
        label2 = `Hoy, ${label2}`;
      }
      return label2;
    },
    labelNav: "Barra de navegación",
    labelWeekNumberHeader: "Número de semana",
    labelWeekday: (date, options, dateLib) => (dateLib ?? new DateLib(options)).format(date, "cccc")
  }
};
const ro$3 = {
  ...ro$4,
  labels: {
    labelDayButton: (date, modifiers, options, dateLib) => {
      const lib = dateLib ?? new DateLib(options);
      let label2 = lib.format(date, "PPPP");
      if (modifiers.today)
        label2 = `Astăzi, ${label2}`;
      if (modifiers.selected)
        label2 = `${label2}, selectat`;
      return label2;
    },
    labelMonthDropdown: "Alege luna",
    labelNext: "Mergi la luna următoare",
    labelPrevious: "Mergi la luna anterioară",
    labelWeekNumber: (weekNumber2) => `Săptămâna ${weekNumber2}`,
    labelYearDropdown: "Alege anul",
    labelGrid: (date, options, dateLib) => (dateLib ?? new DateLib(options)).formatMonthYear(date),
    labelGridcell: (date, modifiers, options, dateLib) => {
      const lib = dateLib ?? new DateLib(options);
      let label2 = lib.format(date, "PPPP");
      if (modifiers == null ? void 0 : modifiers.today) {
        label2 = `Astăzi, ${label2}`;
      }
      return label2;
    },
    labelNav: "Bară de navigare",
    labelWeekNumberHeader: "Numărul săptămânii",
    labelWeekday: (date, options, dateLib) => (dateLib ?? new DateLib(options)).format(date, "cccc")
  }
};
const DATE_LOCALES = { en: enUS, es: es$3, ro: ro$3 };
function getPathDateLocale() {
  const segment2 = window.location.pathname.split("/")[1];
  return DATE_LOCALES[segment2] ?? enUS;
}
function setRef(ref, value2) {
  if (typeof ref === "function") {
    return ref(value2);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value2;
  }
}
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        }
      };
    }
  };
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
  const Slot2 = React.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenArray = React.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map((child) => {
        if (child === slottable) {
          if (React.Children.count(newElement) > 1) return React.Children.only(null);
          return React.isValidElement(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children: React.isValidElement(newElement) ? React.cloneElement(newElement, void 0, newChildren) : null });
    }
    return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
var Slot$1 = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
  const SlotClone = React.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    if (React.isValidElement(children)) {
      const childrenRef = getElementRef$1(children);
      const props2 = mergeProps(slotProps, children.props);
      if (children.type !== React.Fragment) {
        props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
      }
      return React.cloneElement(children, props2);
    }
    return React.Children.count(children) > 1 ? React.Children.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
function isSlottable(child) {
  return React.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef$1(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot2 = /* @__PURE__ */ createSlot(`Primitive.${node}`);
  const Node2 = React.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot2 : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node2.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node2 };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(() => target.dispatchEvent(event));
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = React.createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider = (props) => {
      var _a;
      const { scope, children, ...context } = props;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index2]) || BaseContext;
      const value2 = React.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx(Context.Provider, { value: value2, children });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, scope) {
      var _a;
      const Context = ((_a = scope == null ? void 0 : scope[scopeName]) == null ? void 0 : _a[index2]) || BaseContext;
      const context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}
var useLayoutEffect2 = (globalThis == null ? void 0 : globalThis.document) ? React.useLayoutEffect : () => {
};
var useInsertionEffect = React[" useInsertionEffect ".trim().toString()] || useLayoutEffect2;
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  },
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value2 = isControlled ? prop : uncontrolledProp;
  {
    const isControlledRef = React.useRef(prop !== void 0);
    React.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from = wasControlled ? "controlled" : "uncontrolled";
        const to = isControlled ? "controlled" : "uncontrolled";
        console.warn(
          `${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        );
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const setValue = React.useCallback(
    (nextValue) => {
      var _a;
      if (isControlled) {
        const value22 = isFunction(nextValue) ? nextValue(prop) : nextValue;
        if (value22 !== prop) {
          (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value22);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef]
  );
  return [value2, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const [value2, setValue] = React.useState(defaultProp);
  const prevValueRef = React.useRef(value2);
  const onChangeRef = React.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(() => {
    var _a;
    if (prevValueRef.current !== value2) {
      (_a = onChangeRef.current) == null ? void 0 : _a.call(onChangeRef, value2);
      prevValueRef.current = value2;
    }
  }, [value2, prevValueRef]);
  return [value2, setValue, onChangeRef];
}
function isFunction(value2) {
  return typeof value2 === "function";
}
function useStateMachine(initialState, machine) {
  return React.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React.Children.only(children);
  const ref = useComposedRefs(presence.ref, getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = React.useState();
  const stylesRef = React.useRef(null);
  const prevPresentRef = React.useRef(present);
  const prevAnimationNameRef = React.useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles2 = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles2);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || (styles2 == null ? void 0 : styles2.display) === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React.useCallback((node2) => {
      stylesRef.current = node2 ? getComputedStyle(node2) : null;
      setNode(node2);
    }, [])
  };
}
function getAnimationName(styles2) {
  return (styles2 == null ? void 0 : styles2.animationName) || "none";
}
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var useReactId = React[" useId ".trim().toString()] || (() => void 0);
var count$1 = 0;
function useId(deterministicId) {
  const [id, setId] = React.useState(useReactId());
  useLayoutEffect2(() => {
    setId((reactId) => reactId ?? String(count$1++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
function useCallbackRef$1(callback) {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(() => (...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, []);
}
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const onEscapeKeyDown = useCallbackRef$1(onEscapeKeyDownProp);
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = React.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = React.forwardRef(
  (props, forwardedRef) => {
    const {
      disableOutsidePointerEvents = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      ...layerProps
    } = props;
    const context = React.useContext(DismissableLayerContext);
    const [node, setNode] = React.useState(null);
    const ownerDocument = (node == null ? void 0 : node.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document);
    const [, force] = React.useState({});
    const composedRefs = useComposedRefs(forwardedRef, (node2) => setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index2 = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
      onPointerDownOutside == null ? void 0 : onPointerDownOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch) return;
      onFocusOutside == null ? void 0 : onFocusOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented) onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    useEscapeKeydown((event) => {
      const isHighestLayer = index2 === context.layers.size - 1;
      if (!isHighestLayer) return;
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    }, ownerDocument);
    React.useEffect(() => {
      if (!node) return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node, ownerDocument, disableOutsidePointerEvents, context]);
    React.useEffect(() => {
      return () => {
        if (!node) return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context]);
    React.useEffect(() => {
      const handleUpdate = () => force({});
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        ...layerProps,
        ref: composedRefs,
        style: {
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
          ...props.style
        },
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      }
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = React.forwardRef((props, forwardedRef) => {
  const context = React.useContext(DismissableLayerContext);
  const ref = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  React.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ jsx(Primitive.div, { ...props, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handlePointerDownOutside = useCallbackRef$1(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React.useRef(false);
  const handleClickRef = React.useRef(() => {
  });
  React.useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handleFocusOutside = useCallbackRef$1(onFocusOutside);
  const isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name2, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name2, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name2, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React.forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container2, setContainer] = React.useState(null);
  const onMountAutoFocus = useCallbackRef$1(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef$1(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContainer(node));
  const focusScope = React.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  React.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container2) return;
        const target = event.target;
        if (container2.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container2) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container2.contains(relatedTarget)) {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0) focus(container2);
        }
      };
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container2) mutationObserver.observe(container2, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container2, focusScope.paused]);
  React.useEffect(() => {
    if (container2) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container2.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container2.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container2.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container2)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container2);
          }
        }
      }
      return () => {
        container2.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container2.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container2.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container2.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container2, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = React.useCallback(
    (event) => {
      if (!loop && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container22 = event.currentTarget;
        const [first, last] = getTabbableEdges(container22);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container22) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop) focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop) focus(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ jsx(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container2) {
  const candidates = getTabbableCandidates(container2);
  const first = findVisible(candidates, container2);
  const last = findVisible(candidates.reverse(), container2);
  return [first, last];
}
function getTabbableCandidates(container2) {
  const nodes = [];
  const walker = document.createTreeWalker(container2, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container2) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container2 })) return element;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope == null ? void 0 : activeFocusScope.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _a;
      stack = arrayRemove(stack, focusScope);
      (_a = stack[0]) == null ? void 0 : _a.resume();
    }
  };
}
function arrayRemove(array, item2) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item2);
  if (index2 !== -1) {
    updatedArray.splice(index2, 1);
  }
  return updatedArray;
}
function removeLinks(items2) {
  return items2.filter((item2) => item2.tagName !== "A");
}
var PORTAL_NAME$1 = "Portal";
var Portal$1 = React.forwardRef((props, forwardedRef) => {
  var _a;
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container2 = containerProp || mounted && ((_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body);
  return container2 ? ReactDOM__default.createPortal(/* @__PURE__ */ jsx(Primitive.div, { ...portalProps, ref: forwardedRef }), container2) : null;
});
Portal$1.displayName = PORTAL_NAME$1;
var count = 0;
function useFocusGuards() {
  React.useEffect(() => {
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
    document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
    count++;
    return () => {
      if (count === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach((node) => node.remove());
      }
      count--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e = new Error(message2);
  return e.name = "SuppressedError", e.error = error2, e.suppressed = suppressed, e;
};
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value2) {
  if (typeof ref === "function") {
    ref(value2);
  } else if (ref) {
    ref.current = value2;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = useState(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value2) {
          var last = ref.value;
          if (last !== value2) {
            ref.value = value2;
            ref.callback(value2, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item2 = middleware(data, assigned);
      buffer.push(item2);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item2;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar$1 = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function() {
  return;
};
var RemoveScroll = React.forwardRef(function(props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(
    React.Fragment,
    null,
    enabled && React.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noRelative, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }),
    forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React.createElement(Container, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head2 = document.head || document.getElementsByTagName("head")[0];
  head2.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles2, isDynamic) {
    React.useEffect(function() {
      sheet.add(styles2);
      return function() {
        sheet.remove();
      };
    }, [styles2 && isDynamic]);
  };
};
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles2 = _a.styles, dynamic = _a.dynamic;
    useStyle(styles2, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x) {
  return parseInt(x || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top2 = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right2 = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top2), parse(right2)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top2 = _a.top, right2 = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top2, "px;\n    padding-right: ").concat(right2, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  React.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? { passive: false } : false;
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  if (!(node instanceof Element)) {
    return false;
  }
  var styles2 = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles2[overflow] !== "hidden" && // contains scroll inside self
    !(styles2.overflowY === styles2.overflowX && !alwaysContainsScroll(node) && styles2[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current2 = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current2 instanceof ShadowRoot) {
      current2 = current2.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current2);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current2), scrollHeight = _a[1], clientHeight = _a[2];
      if (scrollHeight > clientHeight) {
        return true;
      }
    }
    current2 = current2.parentNode;
  } while (current2 && current2 !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    if (!target) {
      break;
    }
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    var parent_1 = target.parentNode;
    target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (Math.abs(availableScroll) < 1 || false)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (Math.abs(availableScrollTop) < 1 || false)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style2 = React.useState(styleSingleton)[0];
  var lastProps = React.useRef(props);
  React.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var selection = window.getSelection();
    var anchorNode = selection && selection.anchorNode;
    var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
    if (isTouchingSelection) {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY);
  }, []);
  var shouldPrevent = React.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function(name2, delta, target, should) {
    var event = { name: name2, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React.createElement(
    React.Fragment,
    null,
    inert ? React.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React.createElement(RemoveScrollBar, { noRelative: props.noRelative, gapMode: props.gapMode }) : null
  );
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function(props, ref) {
  return React.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e) {
          console.error("aria-hidden: cannot operate on ", node, e);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
function useSize(element) {
  const [size2, setSize] = React.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size2;
}
const sides = ["top", "right", "bottom", "left"];
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp(start, value2, end) {
  return max(start, min(value2, end));
}
function evaluate(value2, param) {
  return typeof value2 === "function" ? value2(param) : value2;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const MAX_RESET_COUNT = 50;
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const platformWithDetectOverflow = platform2.detectOverflow ? platform2 : {
    ...platform2,
    detectOverflow
  };
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name: name2,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name2] = {
      ...middlewareData[name2],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
const arrow$3 = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$12, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$12 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$12 ? center - min$12 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
const hide$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects,
        platform: platform2
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await platform2.detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await platform2.detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement,
        platform: platform2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const limitShift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
const size$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof Node || value2 instanceof getWindow(value2).Node;
}
function isElement(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof Element || value2 instanceof getWindow(value2).Element;
}
function isHTMLElement(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof HTMLElement || value2 instanceof getWindow(value2).HTMLElement;
}
function isShadowRoot(value2) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value2 instanceof ShadowRoot || value2 instanceof getWindow(value2).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(":popover-open")) {
      return true;
    }
  } catch (_e) {
  }
  try {
    return element.matches(":modal");
  } catch (_e) {
    return false;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value2) => !!value2 && value2 !== "none";
let isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || "") || containRe.test(css.contain || "");
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top2;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll2) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll2.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll2.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll2 = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll2) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll2.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll2.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll2 = getNodeScroll(element);
  const body2 = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body2.scrollWidth, body2.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body2.scrollHeight, body2.clientHeight);
  let x = -scroll2.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll2.scrollTop;
  if (getComputedStyle$1(body2).direction === "rtl") {
    x += max(html.clientWidth, body2.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body2 = doc.body;
    const bodyStyles = getComputedStyle(body2);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body2.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top2 = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top2 * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === "absolute" || currentContainingBlockComputedStyle.position === "fixed") || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top2 = firstRect.top;
  let right2 = firstRect.right;
  let bottom2 = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top2 = max(rect.top, top2);
    right2 = min(rect.right, right2);
    bottom2 = min(rect.bottom, bottom2);
    left = max(rect.left, left);
  }
  return {
    width: right2 - left,
    height: bottom2 - top2,
    x: left,
    y: top2
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll2 = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll2) : createCoords(0);
  const x = rect.left + scroll2.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll2.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top: top2,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left + width));
    const insetBottom = floor(root2.clientHeight - (top2 + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating ? getOverflowAncestors(floating) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const hide$1 = hide$2;
const arrow$2 = arrow$3;
const limitShift$1 = limitShift$2;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var isClient = typeof document !== "undefined";
var noop = function noop2() {
};
var index = isClient ? useLayoutEffect : noop;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value2) {
  const dpr = getDPR(element);
  return Math.round(value2 * dpr) / dpr;
}
function useLatestRef(value2) {
  const ref = React.useRef(value2);
  index(() => {
    ref.current = value2;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open: open2
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open2);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open2 === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open2]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const arrow$1 = (options) => {
  function isRef(value2) {
    return {}.hasOwnProperty.call(value2, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
const offset = (options, deps) => {
  const result = offset$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const shift = (options, deps) => {
  const result = shift$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const limitShift = (options, deps) => {
  const result = limitShift$1(options);
  return {
    fn: result.fn,
    options: [options, deps]
  };
};
const flip = (options, deps) => {
  const result = flip$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const size = (options, deps) => {
  const result = size$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const hide = (options, deps) => {
  const result = hide$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
const arrow = (options, deps) => {
  const result = arrow$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
var NAME = "Arrow";
var Arrow$1 = React.forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ jsx(
    Primitive.svg,
    {
      ...arrowProps,
      ref: forwardedRef,
      width,
      height,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: props.asChild ? children : /* @__PURE__ */ jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Arrow$1.displayName = NAME;
var Root$1 = Arrow$1;
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = createContextScope(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React.useState(null);
  return /* @__PURE__ */ jsx(PopperProvider, { scope: __scopePopper, anchor, onAnchorChange: setAnchor, children });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME$1 = "PopperAnchor";
var PopperAnchor = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const context = usePopperContext(ANCHOR_NAME$1, __scopePopper);
    const ref = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const anchorRef = React.useRef(null);
    React.useEffect(() => {
      const previousAnchor = anchorRef.current;
      anchorRef.current = (virtualRef == null ? void 0 : virtualRef.current) || ref.current;
      if (previousAnchor !== anchorRef.current) {
        context.onAnchorChange(anchorRef.current);
      }
    });
    return virtualRef ? null : /* @__PURE__ */ jsx(Primitive.div, { ...anchorProps, ref: composedRefs });
  }
);
PopperAnchor.displayName = ANCHOR_NAME$1;
var CONTENT_NAME$1 = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME$1);
var PopperContent = React.forwardRef(
  (props, forwardedRef) => {
    var _a, _b, _c, _d, _e, _f;
    const {
      __scopePopper,
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset = 0,
      arrowPadding = 0,
      avoidCollisions = true,
      collisionBoundary = [],
      collisionPadding: collisionPaddingProp = 0,
      sticky = "partial",
      hideWhenDetached = false,
      updatePositionStrategy = "optimized",
      onPlaced,
      ...contentProps
    } = props;
    const context = usePopperContext(CONTENT_NAME$1, __scopePopper);
    const [content2, setContent] = React.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setContent(node));
    const [arrow$12, setArrow] = React.useState(null);
    const arrowSize = useSize(arrow$12);
    const arrowWidth = (arrowSize == null ? void 0 : arrowSize.width) ?? 0;
    const arrowHeight = (arrowSize == null ? void 0 : arrowSize.height) ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : { top: 0, right: 0, bottom: 0, left: 0, ...collisionPaddingProp };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
      padding: collisionPadding,
      boundary: boundary.filter(isNotNull),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: (...args) => {
        const cleanup = autoUpdate(...args, {
          animationFrame: updatePositionStrategy === "always"
        });
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [
        offset({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
        avoidCollisions && shift({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === "partial" ? limitShift() : void 0,
          ...detectOverflowOptions
        }),
        avoidCollisions && flip({ ...detectOverflowOptions }),
        size({
          ...detectOverflowOptions,
          apply: ({ elements, rects, availableWidth, availableHeight }) => {
            const { width: anchorWidth, height: anchorHeight } = rects.reference;
            const contentStyle = elements.floating.style;
            contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
            contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
            contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
            contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
          }
        }),
        arrow$12 && arrow({ element: arrow$12, padding: arrowPadding }),
        transformOrigin({ arrowWidth, arrowHeight }),
        hideWhenDetached && hide({ strategy: "referenceHidden", ...detectOverflowOptions })
      ]
    });
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = useCallbackRef$1(onPlaced);
    useLayoutEffect2(() => {
      if (isPositioned) {
        handlePlaced == null ? void 0 : handlePlaced();
      }
    }, [isPositioned, handlePlaced]);
    const arrowX = (_a = middlewareData.arrow) == null ? void 0 : _a.x;
    const arrowY = (_b = middlewareData.arrow) == null ? void 0 : _b.y;
    const cannotCenterArrow = ((_c = middlewareData.arrow) == null ? void 0 : _c.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = React.useState();
    useLayoutEffect2(() => {
      if (content2) setContentZIndex(window.getComputedStyle(content2).zIndex);
    }, [content2]);
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...floatingStyles,
          transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: contentZIndex,
          ["--radix-popper-transform-origin"]: [
            (_d = middlewareData.transformOrigin) == null ? void 0 : _d.x,
            (_e = middlewareData.transformOrigin) == null ? void 0 : _e.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((_f = middlewareData.hide) == null ? void 0 : _f.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: props.dir,
        children: /* @__PURE__ */ jsx(
          PopperContentProvider,
          {
            scope: __scopePopper,
            placedSide,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ jsx(
              Primitive.div,
              {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                  ...contentProps.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: !isPositioned ? "none" : void 0
                }
              }
            )
          }
        )
      }
    );
  }
);
PopperContent.displayName = CONTENT_NAME$1;
var ARROW_NAME$1 = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = React.forwardRef(function PopperArrow2(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = useContentContext(ARROW_NAME$1, __scopePopper);
  const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ jsx(
      "span",
      {
        ref: contentContext.onArrowChange,
        style: {
          position: "absolute",
          left: contentContext.arrowX,
          top: contentContext.arrowY,
          [baseSide]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[contentContext.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: `rotate(180deg)`,
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[contentContext.placedSide],
          visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ jsx(
          Root$1,
          {
            ...arrowProps,
            ref: forwardedRef,
            style: {
              ...arrowProps.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
PopperArrow.displayName = ARROW_NAME$1;
function isNotNull(value2) {
  return value2 !== null;
}
var transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _a, _b, _c;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_a = middlewareData.arrow) == null ? void 0 : _a.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = (((_b = middlewareData.arrow) == null ? void 0 : _b.x) ?? 0) + arrowWidth / 2;
    const arrowYCenter = (((_c = middlewareData.arrow) == null ? void 0 : _c.y) ?? 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
});
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
var Root2$1 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow = PopperArrow;
var POPOVER_NAME = "Popover";
var [createPopoverContext] = createContextScope(POPOVER_NAME, [
  createPopperScope
]);
var usePopperScope = createPopperScope();
var [PopoverProvider, usePopoverContext] = createPopoverContext(POPOVER_NAME);
var Popover$2 = (props) => {
  const {
    __scopePopover,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal: modal2 = false
  } = props;
  const popperScope = usePopperScope(__scopePopover);
  const triggerRef = React.useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = React.useState(false);
  const [open2, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: POPOVER_NAME
  });
  return /* @__PURE__ */ jsx(Root2$1, { ...popperScope, children: /* @__PURE__ */ jsx(
    PopoverProvider,
    {
      scope: __scopePopover,
      contentId: useId(),
      triggerRef,
      open: open2,
      onOpenChange: setOpen,
      onOpenToggle: React.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      hasCustomAnchor,
      onCustomAnchorAdd: React.useCallback(() => setHasCustomAnchor(true), []),
      onCustomAnchorRemove: React.useCallback(() => setHasCustomAnchor(false), []),
      modal: modal2,
      children
    }
  ) });
};
Popover$2.displayName = POPOVER_NAME;
var ANCHOR_NAME = "PopoverAnchor";
var PopoverAnchor = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...anchorProps } = props;
    const context = usePopoverContext(ANCHOR_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
    React.useEffect(() => {
      onCustomAnchorAdd();
      return () => onCustomAnchorRemove();
    }, [onCustomAnchorAdd, onCustomAnchorRemove]);
    return /* @__PURE__ */ jsx(Anchor, { ...popperScope, ...anchorProps, ref: forwardedRef });
  }
);
PopoverAnchor.displayName = ANCHOR_NAME;
var TRIGGER_NAME = "PopoverTrigger";
var PopoverTrigger$2 = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...triggerProps } = props;
    const context = usePopoverContext(TRIGGER_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
    const trigger2 = /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      }
    );
    return context.hasCustomAnchor ? trigger2 : /* @__PURE__ */ jsx(Anchor, { asChild: true, ...popperScope, children: trigger2 });
  }
);
PopoverTrigger$2.displayName = TRIGGER_NAME;
var PORTAL_NAME = "PopoverPortal";
var [PortalProvider, usePortalContext] = createPopoverContext(PORTAL_NAME, {
  forceMount: void 0
});
var PopoverPortal = (props) => {
  const { __scopePopover, forceMount, children, container: container2 } = props;
  const context = usePopoverContext(PORTAL_NAME, __scopePopover);
  return /* @__PURE__ */ jsx(PortalProvider, { scope: __scopePopover, forceMount, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal$1, { asChild: true, container: container2, children }) }) });
};
PopoverPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "PopoverContent";
var PopoverContent$2 = React.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopePopover);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ jsx(PopoverContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx(PopoverContentNonModal, { ...contentProps, ref: forwardedRef }) });
  }
);
PopoverContent$2.displayName = CONTENT_NAME;
var Slot = /* @__PURE__ */ createSlot("PopoverContent.RemoveScroll");
var PopoverContentModal = React.forwardRef(
  (props, forwardedRef) => {
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const contentRef = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    const isRightClickOutsideRef = React.useRef(false);
    React.useEffect(() => {
      const content2 = contentRef.current;
      if (content2) return hideOthers(content2);
    }, []);
    return /* @__PURE__ */ jsx(ReactRemoveScroll, { as: Slot, allowPinchZoom: true, children: /* @__PURE__ */ jsx(
      PopoverContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          var _a;
          event.preventDefault();
          if (!isRightClickOutsideRef.current) (_a = context.triggerRef.current) == null ? void 0 : _a.focus();
        }),
        onPointerDownOutside: composeEventHandlers(
          props.onPointerDownOutside,
          (event) => {
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
          },
          { checkForDefaultPrevented: false }
        ),
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault(),
          { checkForDefaultPrevented: false }
        )
      }
    ) });
  }
);
var PopoverContentNonModal = React.forwardRef(
  (props, forwardedRef) => {
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = React.useRef(false);
    const hasPointerDownOutsideRef = React.useRef(false);
    return /* @__PURE__ */ jsx(
      PopoverContentImpl,
      {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          var _a, _b;
          (_a = props.onCloseAutoFocus) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current) (_b = context.triggerRef.current) == null ? void 0 : _b.focus();
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
          hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          var _a, _b;
          (_a = props.onInteractOutside) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            hasInteractedOutsideRef.current = true;
            if (event.detail.originalEvent.type === "pointerdown") {
              hasPointerDownOutsideRef.current = true;
            }
          }
          const target = event.target;
          const targetIsTrigger = (_b = context.triggerRef.current) == null ? void 0 : _b.contains(target);
          if (targetIsTrigger) event.preventDefault();
          if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
            event.preventDefault();
          }
        }
      }
    );
  }
);
var PopoverContentImpl = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopePopover,
      trapFocus,
      onOpenAutoFocus,
      onCloseAutoFocus,
      disableOutsidePointerEvents,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      ...contentProps
    } = props;
    const context = usePopoverContext(CONTENT_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    useFocusGuards();
    return /* @__PURE__ */ jsx(
      FocusScope,
      {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ jsx(
          DismissableLayer,
          {
            asChild: true,
            disableOutsidePointerEvents,
            onInteractOutside,
            onEscapeKeyDown,
            onPointerDownOutside,
            onFocusOutside,
            onDismiss: () => context.onOpenChange(false),
            children: /* @__PURE__ */ jsx(
              Content,
              {
                "data-state": getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                  ...contentProps.style,
                  // re-namespace exposed content custom properties
                  ...{
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                  }
                }
              }
            )
          }
        )
      }
    );
  }
);
var CLOSE_NAME = "PopoverClose";
var PopoverClose = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...closeProps } = props;
    const context = usePopoverContext(CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false))
      }
    );
  }
);
PopoverClose.displayName = CLOSE_NAME;
var ARROW_NAME = "PopoverArrow";
var PopoverArrow = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopover, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopePopover);
    return /* @__PURE__ */ jsx(Arrow, { ...popperScope, ...arrowProps, ref: forwardedRef });
  }
);
PopoverArrow.displayName = ARROW_NAME;
function getState(open2) {
  return open2 ? "open" : "closed";
}
var Root2 = Popover$2;
var Trigger = PopoverTrigger$2;
var Portal = PopoverPortal;
var Content2 = PopoverContent$2;
const root$2 = "_root_v74lp_4";
const destructive = "_destructive_v74lp_64";
const outline = "_outline_v74lp_77";
const secondary$1 = "_secondary_v74lp_88";
const ghost$1 = "_ghost_v74lp_97";
const link = "_link_v74lp_104";
const sizeDefault = "_sizeDefault_v74lp_114";
const sizeXs = "_sizeXs_v74lp_124";
const sizeSm = "_sizeSm_v74lp_142";
const sizeLg = "_sizeLg_v74lp_154";
const sizeIcon = "_sizeIcon_v74lp_165";
const sizeIconXs = "_sizeIconXs_v74lp_170";
const sizeIconSm = "_sizeIconSm_v74lp_181";
const sizeIconLg = "_sizeIconLg_v74lp_186";
const styles$q = {
  root: root$2,
  "default": "_default_v74lp_55",
  destructive,
  outline,
  secondary: secondary$1,
  ghost: ghost$1,
  link,
  sizeDefault,
  sizeXs,
  sizeSm,
  sizeLg,
  sizeIcon,
  sizeIconXs,
  sizeIconSm,
  sizeIconLg
};
const variantStyles = {
  default: styles$q.default,
  destructive: styles$q.destructive,
  outline: styles$q.outline,
  secondary: styles$q.secondary,
  ghost: styles$q.ghost,
  link: styles$q.link
};
const sizeStyles = {
  default: styles$q.sizeDefault,
  xs: styles$q.sizeXs,
  sm: styles$q.sizeSm,
  lg: styles$q.sizeLg,
  icon: styles$q.sizeIcon,
  "icon-xs": styles$q.sizeIconXs,
  "icon-sm": styles$q.sizeIconSm,
  "icon-lg": styles$q.sizeIconLg
};
function buttonVariants({
  variant = "default",
  size: size2 = "default",
  className
} = {}) {
  return clsx(styles$q.root, variantStyles[variant], sizeStyles[size2], className);
}
const Button$2 = React.forwardRef(function Button2({
  className,
  variant = "default",
  size: size2 = "default",
  asChild = false,
  ...props
}, ref) {
  const Comp = asChild ? Slot$1 : "button";
  return /* @__PURE__ */ jsx(
    Comp,
    {
      ref,
      "data-slot": "button",
      "data-variant": variant,
      "data-size": size2,
      className: buttonVariants({ variant, size: size2, className }),
      ...props
    }
  );
});
class CalendarDay {
  constructor(date, displayMonth, dateLib = defaultDateLib) {
    this.date = date;
    this.displayMonth = displayMonth;
    this.outside = Boolean(displayMonth && !dateLib.isSameMonth(date, displayMonth));
    this.dateLib = dateLib;
    this.isoDate = dateLib.format(date, "yyyy-MM-dd");
    this.displayMonthId = dateLib.format(displayMonth, "yyyy-MM");
    this.dateMonthId = dateLib.format(date, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(day2) {
    return this.dateLib.isSameDay(day2.date, this.date) && this.dateLib.isSameMonth(day2.displayMonth, this.displayMonth);
  }
}
class CalendarMonth {
  constructor(month2, weeks) {
    this.date = month2;
    this.weeks = weeks;
  }
}
class CalendarWeek {
  constructor(weekNumber2, days) {
    this.days = days;
    this.weekNumber = weekNumber2;
  }
}
function Button$1(props) {
  return React__default.createElement("button", { ...props });
}
function CaptionLabel(props) {
  return React__default.createElement("span", { ...props });
}
function Chevron(props) {
  const { size: size2 = 24, orientation = "left", className } = props;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    React__default.createElement(
      "svg",
      { className, width: size2, height: size2, viewBox: "0 0 24 24" },
      orientation === "up" && React__default.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      orientation === "down" && React__default.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      orientation === "left" && React__default.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      orientation === "right" && React__default.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function Day(props) {
  const { day: day2, modifiers, ...tdProps } = props;
  return React__default.createElement("td", { ...tdProps });
}
function DayButton(props) {
  const { day: day2, modifiers, ...buttonProps } = props;
  const ref = React__default.useRef(null);
  React__default.useEffect(() => {
    var _a;
    if (modifiers.focused)
      (_a = ref.current) == null ? void 0 : _a.focus();
  }, [modifiers.focused]);
  return React__default.createElement("button", { ref, ...buttonProps });
}
var UI;
(function(UI2) {
  UI2["Root"] = "root";
  UI2["Chevron"] = "chevron";
  UI2["Day"] = "day";
  UI2["DayButton"] = "day_button";
  UI2["CaptionLabel"] = "caption_label";
  UI2["Dropdowns"] = "dropdowns";
  UI2["Dropdown"] = "dropdown";
  UI2["DropdownRoot"] = "dropdown_root";
  UI2["Footer"] = "footer";
  UI2["MonthGrid"] = "month_grid";
  UI2["MonthCaption"] = "month_caption";
  UI2["MonthsDropdown"] = "months_dropdown";
  UI2["Month"] = "month";
  UI2["Months"] = "months";
  UI2["Nav"] = "nav";
  UI2["NextMonthButton"] = "button_next";
  UI2["PreviousMonthButton"] = "button_previous";
  UI2["Week"] = "week";
  UI2["Weeks"] = "weeks";
  UI2["Weekday"] = "weekday";
  UI2["Weekdays"] = "weekdays";
  UI2["WeekNumber"] = "week_number";
  UI2["WeekNumberHeader"] = "week_number_header";
  UI2["YearsDropdown"] = "years_dropdown";
})(UI || (UI = {}));
var DayFlag;
(function(DayFlag2) {
  DayFlag2["disabled"] = "disabled";
  DayFlag2["hidden"] = "hidden";
  DayFlag2["outside"] = "outside";
  DayFlag2["focused"] = "focused";
  DayFlag2["today"] = "today";
})(DayFlag || (DayFlag = {}));
var SelectionState;
(function(SelectionState2) {
  SelectionState2["range_end"] = "range_end";
  SelectionState2["range_middle"] = "range_middle";
  SelectionState2["range_start"] = "range_start";
  SelectionState2["selected"] = "selected";
})(SelectionState || (SelectionState = {}));
var Animation;
(function(Animation2) {
  Animation2["weeks_before_enter"] = "weeks_before_enter";
  Animation2["weeks_before_exit"] = "weeks_before_exit";
  Animation2["weeks_after_enter"] = "weeks_after_enter";
  Animation2["weeks_after_exit"] = "weeks_after_exit";
  Animation2["caption_after_enter"] = "caption_after_enter";
  Animation2["caption_after_exit"] = "caption_after_exit";
  Animation2["caption_before_enter"] = "caption_before_enter";
  Animation2["caption_before_exit"] = "caption_before_exit";
})(Animation || (Animation = {}));
function Dropdown(props) {
  const { options, className, components: components2, classNames, ...selectProps } = props;
  const cssClassSelect = [classNames[UI.Dropdown], className].join(" ");
  const selectedOption = options == null ? void 0 : options.find(({ value: value2 }) => value2 === selectProps.value);
  return React__default.createElement(
    "span",
    { "data-disabled": selectProps.disabled, className: classNames[UI.DropdownRoot] },
    React__default.createElement(components2.Select, { className: cssClassSelect, ...selectProps }, options == null ? void 0 : options.map(({ value: value2, label: label2, disabled: disabled2 }) => React__default.createElement(components2.Option, { key: value2, value: value2, disabled: disabled2 }, label2))),
    React__default.createElement(
      "span",
      { className: classNames[UI.CaptionLabel], "aria-hidden": true },
      selectedOption == null ? void 0 : selectedOption.label,
      React__default.createElement(components2.Chevron, { orientation: "down", size: 18, className: classNames[UI.Chevron] })
    )
  );
}
function DropdownNav(props) {
  return React__default.createElement("div", { ...props });
}
function Footer(props) {
  return React__default.createElement("div", { ...props });
}
function Month(props) {
  const { calendarMonth, displayIndex, ...divProps } = props;
  return React__default.createElement("div", { ...divProps }, props.children);
}
function MonthCaption(props) {
  const { calendarMonth, displayIndex, ...divProps } = props;
  return React__default.createElement("div", { ...divProps });
}
function MonthGrid(props) {
  return React__default.createElement("table", { ...props });
}
function Months(props) {
  return React__default.createElement("div", { ...props });
}
const dayPickerContext = createContext(void 0);
function useDayPicker() {
  const context = useContext(dayPickerContext);
  if (context === void 0) {
    throw new Error("useDayPicker() must be used within a custom component.");
  }
  return context;
}
function MonthsDropdown(props) {
  const { components: components2 } = useDayPicker();
  return React__default.createElement(components2.Dropdown, { ...props });
}
function Nav(props) {
  const { onPreviousClick, onNextClick, previousMonth, nextMonth, ...navProps } = props;
  const { components: components2, classNames, labels: { labelPrevious: labelPrevious2, labelNext: labelNext2 } } = useDayPicker();
  const handleNextClick = useCallback((e) => {
    if (nextMonth) {
      onNextClick == null ? void 0 : onNextClick(e);
    }
  }, [nextMonth, onNextClick]);
  const handlePreviousClick = useCallback((e) => {
    if (previousMonth) {
      onPreviousClick == null ? void 0 : onPreviousClick(e);
    }
  }, [previousMonth, onPreviousClick]);
  return React__default.createElement(
    "nav",
    { ...navProps },
    React__default.createElement(
      components2.PreviousMonthButton,
      { type: "button", className: classNames[UI.PreviousMonthButton], tabIndex: previousMonth ? void 0 : -1, "aria-disabled": previousMonth ? void 0 : true, "aria-label": labelPrevious2(previousMonth), onClick: handlePreviousClick },
      React__default.createElement(components2.Chevron, { disabled: previousMonth ? void 0 : true, className: classNames[UI.Chevron], orientation: "left" })
    ),
    React__default.createElement(
      components2.NextMonthButton,
      { type: "button", className: classNames[UI.NextMonthButton], tabIndex: nextMonth ? void 0 : -1, "aria-disabled": nextMonth ? void 0 : true, "aria-label": labelNext2(nextMonth), onClick: handleNextClick },
      React__default.createElement(components2.Chevron, { disabled: nextMonth ? void 0 : true, orientation: "right", className: classNames[UI.Chevron] })
    )
  );
}
function NextMonthButton(props) {
  const { components: components2 } = useDayPicker();
  return React__default.createElement(components2.Button, { ...props });
}
function Option(props) {
  return React__default.createElement("option", { ...props });
}
function PreviousMonthButton(props) {
  const { components: components2 } = useDayPicker();
  return React__default.createElement(components2.Button, { ...props });
}
function Root(props) {
  const { rootRef, ...rest } = props;
  return React__default.createElement("div", { ...rest, ref: rootRef });
}
function Select$1(props) {
  return React__default.createElement("select", { ...props });
}
function Week(props) {
  const { week: week2, ...trProps } = props;
  return React__default.createElement("tr", { ...trProps });
}
function Weekday(props) {
  return React__default.createElement("th", { ...props });
}
function Weekdays(props) {
  return React__default.createElement(
    "thead",
    { "aria-hidden": true },
    React__default.createElement("tr", { ...props })
  );
}
function WeekNumber(props) {
  const { week: week2, ...thProps } = props;
  return React__default.createElement("th", { ...thProps });
}
function WeekNumberHeader(props) {
  return React__default.createElement("th", { ...props });
}
function Weeks(props) {
  return React__default.createElement("tbody", { ...props });
}
function YearsDropdown(props) {
  const { components: components2 } = useDayPicker();
  return React__default.createElement(components2.Dropdown, { ...props });
}
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Button$1,
  CaptionLabel,
  Chevron,
  Day,
  DayButton,
  Dropdown,
  DropdownNav,
  Footer,
  Month,
  MonthCaption,
  MonthGrid,
  Months,
  MonthsDropdown,
  Nav,
  NextMonthButton,
  Option,
  PreviousMonthButton,
  Root,
  Select: Select$1,
  Week,
  WeekNumber,
  WeekNumberHeader,
  Weekday,
  Weekdays,
  Weeks,
  YearsDropdown
}, Symbol.toStringTag, { value: "Module" }));
function rangeIncludesDate(range2, date, excludeEnds = false, dateLib = defaultDateLib) {
  let { from, to } = range2;
  const { differenceInCalendarDays: differenceInCalendarDays2, isSameDay: isSameDay2 } = dateLib;
  if (from && to) {
    const isRangeInverted = differenceInCalendarDays2(to, from) < 0;
    if (isRangeInverted) {
      [from, to] = [to, from];
    }
    const isInRange = differenceInCalendarDays2(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays2(to, date) >= (excludeEnds ? 1 : 0);
    return isInRange;
  }
  if (!excludeEnds && to) {
    return isSameDay2(to, date);
  }
  if (!excludeEnds && from) {
    return isSameDay2(from, date);
  }
  return false;
}
function isDateInterval(matcher) {
  return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function isDateRange(value2) {
  return Boolean(value2 && typeof value2 === "object" && "from" in value2);
}
function isDateAfterType(value2) {
  return Boolean(value2 && typeof value2 === "object" && "after" in value2);
}
function isDateBeforeType(value2) {
  return Boolean(value2 && typeof value2 === "object" && "before" in value2);
}
function isDayOfWeekType(value2) {
  return Boolean(value2 && typeof value2 === "object" && "dayOfWeek" in value2);
}
function isDatesArray(value2, dateLib) {
  return Array.isArray(value2) && value2.every(dateLib.isDate);
}
function dateMatchModifiers(date, matchers, dateLib = defaultDateLib) {
  const matchersArr = !Array.isArray(matchers) ? [matchers] : matchers;
  const { isSameDay: isSameDay2, differenceInCalendarDays: differenceInCalendarDays2, isAfter: isAfter2 } = dateLib;
  return matchersArr.some((matcher) => {
    if (typeof matcher === "boolean") {
      return matcher;
    }
    if (dateLib.isDate(matcher)) {
      return isSameDay2(date, matcher);
    }
    if (isDatesArray(matcher, dateLib)) {
      return matcher.some((matcherDate) => isSameDay2(date, matcherDate));
    }
    if (isDateRange(matcher)) {
      return rangeIncludesDate(matcher, date, false, dateLib);
    }
    if (isDayOfWeekType(matcher)) {
      if (!Array.isArray(matcher.dayOfWeek)) {
        return matcher.dayOfWeek === date.getDay();
      }
      return matcher.dayOfWeek.includes(date.getDay());
    }
    if (isDateInterval(matcher)) {
      const diffBefore = differenceInCalendarDays2(matcher.before, date);
      const diffAfter = differenceInCalendarDays2(matcher.after, date);
      const isDayBefore = diffBefore > 0;
      const isDayAfter = diffAfter < 0;
      const isClosedInterval = isAfter2(matcher.before, matcher.after);
      if (isClosedInterval) {
        return isDayAfter && isDayBefore;
      } else {
        return isDayBefore || isDayAfter;
      }
    }
    if (isDateAfterType(matcher)) {
      return differenceInCalendarDays2(date, matcher.after) > 0;
    }
    if (isDateBeforeType(matcher)) {
      return differenceInCalendarDays2(matcher.before, date) > 0;
    }
    if (typeof matcher === "function") {
      return matcher(date);
    }
    return false;
  });
}
function createGetModifiers(days, props, navStart, navEnd, dateLib) {
  const { disabled: disabled2, hidden: hidden2, modifiers, showOutsideDays, broadcastCalendar, today: today2 = dateLib.today() } = props;
  const { isSameDay: isSameDay2, isSameMonth: isSameMonth2, startOfMonth: startOfMonth2, isBefore: isBefore2, endOfMonth: endOfMonth2, isAfter: isAfter2 } = dateLib;
  const computedNavStart = navStart && startOfMonth2(navStart);
  const computedNavEnd = navEnd && endOfMonth2(navEnd);
  const internalModifiersMap = {
    [DayFlag.focused]: [],
    [DayFlag.outside]: [],
    [DayFlag.disabled]: [],
    [DayFlag.hidden]: [],
    [DayFlag.today]: []
  };
  const customModifiersMap = {};
  for (const day2 of days) {
    const { date, displayMonth } = day2;
    const isOutside = Boolean(displayMonth && !isSameMonth2(date, displayMonth));
    const isBeforeNavStart = Boolean(computedNavStart && isBefore2(date, computedNavStart));
    const isAfterNavEnd = Boolean(computedNavEnd && isAfter2(date, computedNavEnd));
    const isDisabled = Boolean(disabled2 && dateMatchModifiers(date, disabled2, dateLib));
    const isHidden2 = Boolean(hidden2 && dateMatchModifiers(date, hidden2, dateLib)) || isBeforeNavStart || isAfterNavEnd || // Broadcast calendar will show outside days as default
    !broadcastCalendar && !showOutsideDays && isOutside || broadcastCalendar && showOutsideDays === false && isOutside;
    const isToday = isSameDay2(date, today2);
    if (isOutside)
      internalModifiersMap.outside.push(day2);
    if (isDisabled)
      internalModifiersMap.disabled.push(day2);
    if (isHidden2)
      internalModifiersMap.hidden.push(day2);
    if (isToday)
      internalModifiersMap.today.push(day2);
    if (modifiers) {
      Object.keys(modifiers).forEach((name2) => {
        const modifierValue = modifiers == null ? void 0 : modifiers[name2];
        const isMatch = modifierValue ? dateMatchModifiers(date, modifierValue, dateLib) : false;
        if (!isMatch)
          return;
        if (customModifiersMap[name2]) {
          customModifiersMap[name2].push(day2);
        } else {
          customModifiersMap[name2] = [day2];
        }
      });
    }
  }
  return (day2) => {
    const dayFlags = {
      [DayFlag.focused]: false,
      [DayFlag.disabled]: false,
      [DayFlag.hidden]: false,
      [DayFlag.outside]: false,
      [DayFlag.today]: false
    };
    const customModifiers = {};
    for (const name2 in internalModifiersMap) {
      const days2 = internalModifiersMap[name2];
      dayFlags[name2] = days2.some((d) => d === day2);
    }
    for (const name2 in customModifiersMap) {
      customModifiers[name2] = customModifiersMap[name2].some((d) => d === day2);
    }
    return {
      ...dayFlags,
      // custom modifiers should override all the previous ones
      ...customModifiers
    };
  };
}
function getClassNamesForModifiers(modifiers, classNames, modifiersClassNames = {}) {
  const modifierClassNames = Object.entries(modifiers).filter(([, active2]) => active2 === true).reduce((previousValue, [key]) => {
    if (modifiersClassNames[key]) {
      previousValue.push(modifiersClassNames[key]);
    } else if (classNames[DayFlag[key]]) {
      previousValue.push(classNames[DayFlag[key]]);
    } else if (classNames[SelectionState[key]]) {
      previousValue.push(classNames[SelectionState[key]]);
    }
    return previousValue;
  }, [classNames[UI.Day]]);
  return modifierClassNames;
}
function getComponents(customComponents) {
  return {
    ...components,
    ...customComponents
  };
}
function getDataAttributes(props) {
  const dataAttributes = {
    "data-mode": props.mode ?? void 0,
    "data-required": "required" in props ? props.required : void 0,
    "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || void 0,
    "data-week-numbers": props.showWeekNumber || void 0,
    "data-broadcast-calendar": props.broadcastCalendar || void 0,
    "data-nav-layout": props.navLayout || void 0
  };
  Object.entries(props).forEach(([key, val]) => {
    if (key.startsWith("data-")) {
      dataAttributes[key] = val;
    }
  });
  return dataAttributes;
}
function getDefaultClassNames() {
  const classNames = {};
  for (const key in UI) {
    classNames[UI[key]] = `rdp-${UI[key]}`;
  }
  for (const key in DayFlag) {
    classNames[DayFlag[key]] = `rdp-${DayFlag[key]}`;
  }
  for (const key in SelectionState) {
    classNames[SelectionState[key]] = `rdp-${SelectionState[key]}`;
  }
  for (const key in Animation) {
    classNames[Animation[key]] = `rdp-${Animation[key]}`;
  }
  return classNames;
}
function formatCaption(month2, options, dateLib) {
  const lib = dateLib ?? new DateLib(options);
  return lib.formatMonthYear(month2);
}
const formatMonthCaption = formatCaption;
function formatDay(date, options, dateLib) {
  return (dateLib ?? new DateLib(options)).format(date, "d");
}
function formatMonthDropdown(month2, dateLib = defaultDateLib) {
  return dateLib.format(month2, "LLLL");
}
function formatWeekdayName(weekday2, options, dateLib) {
  return (dateLib ?? new DateLib(options)).format(weekday2, "cccccc");
}
function formatWeekNumber(weekNumber2, dateLib = defaultDateLib) {
  if (weekNumber2 < 10) {
    return dateLib.formatNumber(`0${weekNumber2.toLocaleString()}`);
  }
  return dateLib.formatNumber(`${weekNumber2.toLocaleString()}`);
}
function formatWeekNumberHeader() {
  return ``;
}
function formatYearDropdown(year, dateLib = defaultDateLib) {
  return dateLib.format(year, "yyyy");
}
const formatYearCaption = formatYearDropdown;
const defaultFormatters = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption,
  formatDay,
  formatMonthCaption,
  formatMonthDropdown,
  formatWeekNumber,
  formatWeekNumberHeader,
  formatWeekdayName,
  formatYearCaption,
  formatYearDropdown
}, Symbol.toStringTag, { value: "Module" }));
function getFormatters(customFormatters) {
  if ((customFormatters == null ? void 0 : customFormatters.formatMonthCaption) && !customFormatters.formatCaption) {
    customFormatters.formatCaption = customFormatters.formatMonthCaption;
  }
  if ((customFormatters == null ? void 0 : customFormatters.formatYearCaption) && !customFormatters.formatYearDropdown) {
    customFormatters.formatYearDropdown = customFormatters.formatYearCaption;
  }
  return {
    ...defaultFormatters,
    ...customFormatters
  };
}
function labelDayButton(date, modifiers, options, dateLib) {
  let label2 = (dateLib ?? new DateLib(options)).format(date, "PPPP");
  if (modifiers.today)
    label2 = `Today, ${label2}`;
  if (modifiers.selected)
    label2 = `${label2}, selected`;
  return label2;
}
const labelDay = labelDayButton;
function labelGrid(date, options, dateLib) {
  const lib = dateLib ?? new DateLib(options);
  return lib.formatMonthYear(date);
}
const labelCaption = labelGrid;
function labelGridcell(date, modifiers, options, dateLib) {
  let label2 = (dateLib ?? new DateLib(options)).format(date, "PPPP");
  if (modifiers == null ? void 0 : modifiers.today) {
    label2 = `Today, ${label2}`;
  }
  return label2;
}
function labelMonthDropdown(_options) {
  return "Choose the Month";
}
function labelNav() {
  return "";
}
const defaultLabel = "Go to the Next Month";
function labelNext(_month, _options) {
  return defaultLabel;
}
function labelPrevious(_month) {
  return "Go to the Previous Month";
}
function labelWeekday(date, options, dateLib) {
  return (dateLib ?? new DateLib(options)).format(date, "cccc");
}
function labelWeekNumber(weekNumber2, _options) {
  return `Week ${weekNumber2}`;
}
function labelWeekNumberHeader(_options) {
  return "Week Number";
}
function labelYearDropdown(_options) {
  return "Choose the Year";
}
const defaultLabels = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption,
  labelDay,
  labelDayButton,
  labelGrid,
  labelGridcell,
  labelMonthDropdown,
  labelNav,
  labelNext,
  labelPrevious,
  labelWeekNumber,
  labelWeekNumberHeader,
  labelWeekday,
  labelYearDropdown
}, Symbol.toStringTag, { value: "Module" }));
const resolveLabel = (defaultLabel2, customLabel, localeLabel) => {
  if (customLabel)
    return customLabel;
  if (localeLabel) {
    return typeof localeLabel === "function" ? localeLabel : (..._args) => localeLabel;
  }
  return defaultLabel2;
};
function getLabels(customLabels, options) {
  var _a;
  const localeLabels = ((_a = options.locale) == null ? void 0 : _a.labels) ?? {};
  return {
    ...defaultLabels,
    ...customLabels ?? {},
    labelDayButton: resolveLabel(labelDayButton, customLabels == null ? void 0 : customLabels.labelDayButton, localeLabels.labelDayButton),
    labelMonthDropdown: resolveLabel(labelMonthDropdown, customLabels == null ? void 0 : customLabels.labelMonthDropdown, localeLabels.labelMonthDropdown),
    labelNext: resolveLabel(labelNext, customLabels == null ? void 0 : customLabels.labelNext, localeLabels.labelNext),
    labelPrevious: resolveLabel(labelPrevious, customLabels == null ? void 0 : customLabels.labelPrevious, localeLabels.labelPrevious),
    labelWeekNumber: resolveLabel(labelWeekNumber, customLabels == null ? void 0 : customLabels.labelWeekNumber, localeLabels.labelWeekNumber),
    labelYearDropdown: resolveLabel(labelYearDropdown, customLabels == null ? void 0 : customLabels.labelYearDropdown, localeLabels.labelYearDropdown),
    labelGrid: resolveLabel(labelGrid, customLabels == null ? void 0 : customLabels.labelGrid, localeLabels.labelGrid),
    labelGridcell: resolveLabel(labelGridcell, customLabels == null ? void 0 : customLabels.labelGridcell, localeLabels.labelGridcell),
    labelNav: resolveLabel(labelNav, customLabels == null ? void 0 : customLabels.labelNav, localeLabels.labelNav),
    labelWeekNumberHeader: resolveLabel(labelWeekNumberHeader, customLabels == null ? void 0 : customLabels.labelWeekNumberHeader, localeLabels.labelWeekNumberHeader),
    labelWeekday: resolveLabel(labelWeekday, customLabels == null ? void 0 : customLabels.labelWeekday, localeLabels.labelWeekday)
  };
}
function getMonthOptions(displayMonth, navStart, navEnd, formatters2, dateLib) {
  const { startOfMonth: startOfMonth2, startOfYear: startOfYear2, endOfYear: endOfYear2, eachMonthOfInterval: eachMonthOfInterval2, getMonth: getMonth2 } = dateLib;
  const months2 = eachMonthOfInterval2({
    start: startOfYear2(displayMonth),
    end: endOfYear2(displayMonth)
  });
  const options = months2.map((month2) => {
    const label2 = formatters2.formatMonthDropdown(month2, dateLib);
    const value2 = getMonth2(month2);
    const disabled2 = navStart && month2 < startOfMonth2(navStart) || navEnd && month2 > startOfMonth2(navEnd) || false;
    return { value: value2, label: label2, disabled: disabled2 };
  });
  return options;
}
function getStyleForModifiers(dayModifiers, styles2 = {}, modifiersStyles = {}) {
  let style = { ...styles2 == null ? void 0 : styles2[UI.Day] };
  Object.entries(dayModifiers).filter(([, active2]) => active2 === true).forEach(([modifier]) => {
    style = {
      ...style,
      ...modifiersStyles == null ? void 0 : modifiersStyles[modifier]
    };
  });
  return style;
}
function getWeekdays(dateLib, ISOWeek, broadcastCalendar, today2) {
  const referenceToday = today2 ?? dateLib.today();
  const start = broadcastCalendar ? dateLib.startOfBroadcastWeek(referenceToday, dateLib) : ISOWeek ? dateLib.startOfISOWeek(referenceToday) : dateLib.startOfWeek(referenceToday);
  const days = [];
  for (let i = 0; i < 7; i++) {
    const day2 = dateLib.addDays(start, i);
    days.push(day2);
  }
  return days;
}
function getYearOptions(navStart, navEnd, formatters2, dateLib, reverse = false) {
  if (!navStart)
    return void 0;
  if (!navEnd)
    return void 0;
  const { startOfYear: startOfYear2, endOfYear: endOfYear2, eachYearOfInterval: eachYearOfInterval2, getYear: getYear2 } = dateLib;
  const firstNavYear = startOfYear2(navStart);
  const lastNavYear = endOfYear2(navEnd);
  const years = eachYearOfInterval2({ start: firstNavYear, end: lastNavYear });
  if (reverse)
    years.reverse();
  return years.map((year) => {
    const label2 = formatters2.formatYearDropdown(year, dateLib);
    return {
      value: getYear2(year),
      label: label2,
      disabled: false
    };
  });
}
function createNoonOverrides(timeZone, options = {}) {
  var _a;
  const { weekStartsOn, locale } = options;
  const fallbackWeekStartsOn = weekStartsOn ?? ((_a = locale == null ? void 0 : locale.options) == null ? void 0 : _a.weekStartsOn) ?? 0;
  const toNoonTZDate = (date) => {
    const normalizedDate = typeof date === "number" || typeof date === "string" ? new Date(date) : date;
    return new TZDate(normalizedDate.getFullYear(), normalizedDate.getMonth(), normalizedDate.getDate(), 12, 0, 0, timeZone);
  };
  const toCalendarDate = (date) => {
    const zoned = toNoonTZDate(date);
    return new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => {
      return toNoonTZDate(TZDate.tz(timeZone));
    },
    newDate: (year, monthIndex, date) => {
      return new TZDate(year, monthIndex, date, 12, 0, 0, timeZone);
    },
    startOfDay: (date) => {
      return toNoonTZDate(date);
    },
    startOfWeek: (date, options2) => {
      const base = toNoonTZDate(date);
      const weekStartsOnValue = (options2 == null ? void 0 : options2.weekStartsOn) ?? fallbackWeekStartsOn;
      const diff = (base.getDay() - weekStartsOnValue + 7) % 7;
      base.setDate(base.getDate() - diff);
      return base;
    },
    startOfISOWeek: (date) => {
      const base = toNoonTZDate(date);
      const diff = (base.getDay() - 1 + 7) % 7;
      base.setDate(base.getDate() - diff);
      return base;
    },
    startOfMonth: (date) => {
      const base = toNoonTZDate(date);
      base.setDate(1);
      return base;
    },
    startOfYear: (date) => {
      const base = toNoonTZDate(date);
      base.setMonth(0, 1);
      return base;
    },
    endOfWeek: (date, options2) => {
      const base = toNoonTZDate(date);
      const weekStartsOnValue = (options2 == null ? void 0 : options2.weekStartsOn) ?? fallbackWeekStartsOn;
      const endDow = (weekStartsOnValue + 6) % 7;
      const diff = (endDow - base.getDay() + 7) % 7;
      base.setDate(base.getDate() + diff);
      return base;
    },
    endOfISOWeek: (date) => {
      const base = toNoonTZDate(date);
      const diff = (7 - base.getDay()) % 7;
      base.setDate(base.getDate() + diff);
      return base;
    },
    endOfMonth: (date) => {
      const base = toNoonTZDate(date);
      base.setMonth(base.getMonth() + 1, 0);
      return base;
    },
    endOfYear: (date) => {
      const base = toNoonTZDate(date);
      base.setMonth(11, 31);
      return base;
    },
    eachMonthOfInterval: (interval) => {
      const start = toNoonTZDate(interval.start);
      const end = toNoonTZDate(interval.end);
      const result = [];
      const cursor = new TZDate(start.getFullYear(), start.getMonth(), 1, 12, 0, 0, timeZone);
      const endKey = end.getFullYear() * 12 + end.getMonth();
      while (cursor.getFullYear() * 12 + cursor.getMonth() <= endKey) {
        result.push(new TZDate(cursor, timeZone));
        cursor.setMonth(cursor.getMonth() + 1, 1);
      }
      return result;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (date, amount) => {
      const base = toNoonTZDate(date);
      base.setDate(base.getDate() + amount);
      return base;
    },
    addWeeks: (date, amount) => {
      const base = toNoonTZDate(date);
      base.setDate(base.getDate() + amount * 7);
      return base;
    },
    addMonths: (date, amount) => {
      const base = toNoonTZDate(date);
      base.setMonth(base.getMonth() + amount);
      return base;
    },
    addYears: (date, amount) => {
      const base = toNoonTZDate(date);
      base.setFullYear(base.getFullYear() + amount);
      return base;
    },
    eachYearOfInterval: (interval) => {
      const start = toNoonTZDate(interval.start);
      const end = toNoonTZDate(interval.end);
      const years = [];
      const cursor = new TZDate(start.getFullYear(), 0, 1, 12, 0, 0, timeZone);
      while (cursor.getFullYear() <= end.getFullYear()) {
        years.push(new TZDate(cursor, timeZone));
        cursor.setFullYear(cursor.getFullYear() + 1, 0, 1);
      }
      return years;
    },
    getWeek: (date, options2) => {
      var _a2;
      const base = toCalendarDate(date);
      return getWeek(base, {
        weekStartsOn: (options2 == null ? void 0 : options2.weekStartsOn) ?? fallbackWeekStartsOn,
        firstWeekContainsDate: (options2 == null ? void 0 : options2.firstWeekContainsDate) ?? ((_a2 = locale == null ? void 0 : locale.options) == null ? void 0 : _a2.firstWeekContainsDate) ?? 1
      });
    },
    getISOWeek: (date) => {
      const base = toCalendarDate(date);
      return getISOWeek(base);
    },
    differenceInCalendarDays: (dateLeft, dateRight) => {
      const left = toCalendarDate(dateLeft);
      const right2 = toCalendarDate(dateRight);
      return differenceInCalendarDays(left, right2);
    },
    differenceInCalendarMonths: (dateLeft, dateRight) => {
      const left = toCalendarDate(dateLeft);
      const right2 = toCalendarDate(dateRight);
      return differenceInCalendarMonths(left, right2);
    }
  };
}
const asHtmlElement = (element) => {
  if (element instanceof HTMLElement)
    return element;
  return null;
};
const queryMonthEls = (element) => [
  ...element.querySelectorAll("[data-animated-month]") ?? []
];
const queryMonthEl = (element) => asHtmlElement(element.querySelector("[data-animated-month]"));
const queryCaptionEl = (element) => asHtmlElement(element.querySelector("[data-animated-caption]"));
const queryWeeksEl = (element) => asHtmlElement(element.querySelector("[data-animated-weeks]"));
const queryNavEl = (element) => asHtmlElement(element.querySelector("[data-animated-nav]"));
const queryWeekdaysEl = (element) => asHtmlElement(element.querySelector("[data-animated-weekdays]"));
function useAnimation(rootElRef, enabled, { classNames, months: months2, focused, dateLib }) {
  const previousRootElSnapshotRef = useRef(null);
  const previousMonthsRef = useRef(months2);
  const animatingRef = useRef(false);
  useLayoutEffect(() => {
    const previousMonths = previousMonthsRef.current;
    previousMonthsRef.current = months2;
    if (!enabled || !rootElRef.current || // safety check because the ref can be set to anything by consumers
    !(rootElRef.current instanceof HTMLElement) || // validation required for the animation to work as expected
    months2.length === 0 || previousMonths.length === 0 || months2.length !== previousMonths.length) {
      return;
    }
    const isSameMonth2 = dateLib.isSameMonth(months2[0].date, previousMonths[0].date);
    const isAfterPreviousMonth = dateLib.isAfter(months2[0].date, previousMonths[0].date);
    const captionAnimationClass = isAfterPreviousMonth ? classNames[Animation.caption_after_enter] : classNames[Animation.caption_before_enter];
    const weeksAnimationClass = isAfterPreviousMonth ? classNames[Animation.weeks_after_enter] : classNames[Animation.weeks_before_enter];
    const previousRootElSnapshot = previousRootElSnapshotRef.current;
    const rootElSnapshot = rootElRef.current.cloneNode(true);
    if (rootElSnapshot instanceof HTMLElement) {
      const currentMonthElsSnapshot = queryMonthEls(rootElSnapshot);
      currentMonthElsSnapshot.forEach((currentMonthElSnapshot) => {
        if (!(currentMonthElSnapshot instanceof HTMLElement))
          return;
        const previousMonthElSnapshot = queryMonthEl(currentMonthElSnapshot);
        if (previousMonthElSnapshot && currentMonthElSnapshot.contains(previousMonthElSnapshot)) {
          currentMonthElSnapshot.removeChild(previousMonthElSnapshot);
        }
        const captionEl = queryCaptionEl(currentMonthElSnapshot);
        if (captionEl) {
          captionEl.classList.remove(captionAnimationClass);
        }
        const weeksEl = queryWeeksEl(currentMonthElSnapshot);
        if (weeksEl) {
          weeksEl.classList.remove(weeksAnimationClass);
        }
      });
      previousRootElSnapshotRef.current = rootElSnapshot;
    } else {
      previousRootElSnapshotRef.current = null;
    }
    if (animatingRef.current || isSameMonth2 || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    focused) {
      return;
    }
    const previousMonthEls = previousRootElSnapshot instanceof HTMLElement ? queryMonthEls(previousRootElSnapshot) : [];
    const currentMonthEls = queryMonthEls(rootElRef.current);
    if ((currentMonthEls == null ? void 0 : currentMonthEls.every((el) => el instanceof HTMLElement)) && previousMonthEls && previousMonthEls.every((el) => el instanceof HTMLElement)) {
      animatingRef.current = true;
      rootElRef.current.style.isolation = "isolate";
      const navEl = queryNavEl(rootElRef.current);
      if (navEl) {
        navEl.style.zIndex = "1";
      }
      currentMonthEls.forEach((currentMonthEl, index2) => {
        const previousMonthEl = previousMonthEls[index2];
        if (!previousMonthEl) {
          return;
        }
        currentMonthEl.style.position = "relative";
        currentMonthEl.style.overflow = "hidden";
        const captionEl = queryCaptionEl(currentMonthEl);
        if (captionEl) {
          captionEl.classList.add(captionAnimationClass);
        }
        const weeksEl = queryWeeksEl(currentMonthEl);
        if (weeksEl) {
          weeksEl.classList.add(weeksAnimationClass);
        }
        const cleanUp = () => {
          animatingRef.current = false;
          if (rootElRef.current) {
            rootElRef.current.style.isolation = "";
          }
          if (navEl) {
            navEl.style.zIndex = "";
          }
          if (captionEl) {
            captionEl.classList.remove(captionAnimationClass);
          }
          if (weeksEl) {
            weeksEl.classList.remove(weeksAnimationClass);
          }
          currentMonthEl.style.position = "";
          currentMonthEl.style.overflow = "";
          if (currentMonthEl.contains(previousMonthEl)) {
            currentMonthEl.removeChild(previousMonthEl);
          }
        };
        previousMonthEl.style.pointerEvents = "none";
        previousMonthEl.style.position = "absolute";
        previousMonthEl.style.overflow = "hidden";
        previousMonthEl.setAttribute("aria-hidden", "true");
        const previousWeekdaysEl = queryWeekdaysEl(previousMonthEl);
        if (previousWeekdaysEl) {
          previousWeekdaysEl.style.opacity = "0";
        }
        const previousCaptionEl = queryCaptionEl(previousMonthEl);
        if (previousCaptionEl) {
          previousCaptionEl.classList.add(isAfterPreviousMonth ? classNames[Animation.caption_before_exit] : classNames[Animation.caption_after_exit]);
          previousCaptionEl.addEventListener("animationend", cleanUp);
        }
        const previousWeeksEl = queryWeeksEl(previousMonthEl);
        if (previousWeeksEl) {
          previousWeeksEl.classList.add(isAfterPreviousMonth ? classNames[Animation.weeks_before_exit] : classNames[Animation.weeks_after_exit]);
        }
        currentMonthEl.insertBefore(previousMonthEl, currentMonthEl.firstChild);
      });
    }
  });
}
function getDates(displayMonths, maxDate, props, dateLib) {
  const firstMonth = displayMonths[0];
  const lastMonth = displayMonths[displayMonths.length - 1];
  const { ISOWeek, fixedWeeks, broadcastCalendar } = props ?? {};
  const { addDays: addDays2, differenceInCalendarDays: differenceInCalendarDays2, differenceInCalendarMonths: differenceInCalendarMonths2, endOfBroadcastWeek: endOfBroadcastWeek2, endOfISOWeek: endOfISOWeek2, endOfMonth: endOfMonth2, endOfWeek: endOfWeek2, isAfter: isAfter2, startOfBroadcastWeek: startOfBroadcastWeek2, startOfISOWeek: startOfISOWeek2, startOfWeek: startOfWeek2 } = dateLib;
  const startWeekFirstDate = broadcastCalendar ? startOfBroadcastWeek2(firstMonth, dateLib) : ISOWeek ? startOfISOWeek2(firstMonth) : startOfWeek2(firstMonth);
  const displayMonthsWeekEnd = broadcastCalendar ? endOfBroadcastWeek2(lastMonth) : ISOWeek ? endOfISOWeek2(endOfMonth2(lastMonth)) : endOfWeek2(endOfMonth2(lastMonth));
  const constraintWeekEnd = maxDate && (broadcastCalendar ? endOfBroadcastWeek2(maxDate) : ISOWeek ? endOfISOWeek2(maxDate) : endOfWeek2(maxDate));
  const gridEndDate = constraintWeekEnd && isAfter2(displayMonthsWeekEnd, constraintWeekEnd) ? constraintWeekEnd : displayMonthsWeekEnd;
  const nOfDays = differenceInCalendarDays2(gridEndDate, startWeekFirstDate);
  const nOfMonths = differenceInCalendarMonths2(lastMonth, firstMonth) + 1;
  const dates = [];
  for (let i = 0; i <= nOfDays; i++) {
    const date = addDays2(startWeekFirstDate, i);
    dates.push(date);
  }
  const nrOfDaysWithFixedWeeks = broadcastCalendar ? 35 : 42;
  const extraDates = nrOfDaysWithFixedWeeks * nOfMonths;
  if (fixedWeeks && dates.length < extraDates) {
    const daysToAdd = extraDates - dates.length;
    for (let i = 0; i < daysToAdd; i++) {
      const date = addDays2(dates[dates.length - 1], 1);
      dates.push(date);
    }
  }
  return dates;
}
function getDays(calendarMonths) {
  const initialDays = [];
  return calendarMonths.reduce((days, month2) => {
    const weekDays = month2.weeks.reduce((weekDays2, week2) => {
      return weekDays2.concat(week2.days.slice());
    }, initialDays.slice());
    return days.concat(weekDays.slice());
  }, initialDays.slice());
}
function getDisplayMonths(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
  const { numberOfMonths = 1 } = props;
  const months2 = [];
  for (let i = 0; i < numberOfMonths; i++) {
    const month2 = dateLib.addMonths(firstDisplayedMonth, i);
    if (calendarEndMonth && month2 > calendarEndMonth) {
      break;
    }
    months2.push(month2);
  }
  return months2;
}
function getInitialMonth(props, navStart, navEnd, dateLib) {
  const { month: month2, defaultMonth, today: today2 = dateLib.today(), numberOfMonths = 1 } = props;
  let initialMonth = month2 || defaultMonth || today2;
  const { differenceInCalendarMonths: differenceInCalendarMonths2, addMonths: addMonths2, startOfMonth: startOfMonth2 } = dateLib;
  if (navEnd && differenceInCalendarMonths2(navEnd, initialMonth) < numberOfMonths - 1) {
    const offset2 = -1 * (numberOfMonths - 1);
    initialMonth = addMonths2(navEnd, offset2);
  }
  if (navStart && differenceInCalendarMonths2(initialMonth, navStart) < 0) {
    initialMonth = navStart;
  }
  return startOfMonth2(initialMonth);
}
function getMonths(displayMonths, dates, props, dateLib) {
  const { addDays: addDays2, endOfBroadcastWeek: endOfBroadcastWeek2, endOfISOWeek: endOfISOWeek2, endOfMonth: endOfMonth2, endOfWeek: endOfWeek2, getISOWeek: getISOWeek2, getWeek: getWeek2, startOfBroadcastWeek: startOfBroadcastWeek2, startOfISOWeek: startOfISOWeek2, startOfWeek: startOfWeek2 } = dateLib;
  const dayPickerMonths = displayMonths.reduce((months2, month2) => {
    const firstDateOfFirstWeek = props.broadcastCalendar ? startOfBroadcastWeek2(month2, dateLib) : props.ISOWeek ? startOfISOWeek2(month2) : startOfWeek2(month2);
    const lastDateOfLastWeek = props.broadcastCalendar ? endOfBroadcastWeek2(month2) : props.ISOWeek ? endOfISOWeek2(endOfMonth2(month2)) : endOfWeek2(endOfMonth2(month2));
    const monthDates = dates.filter((date) => {
      return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
    });
    const nrOfDaysWithFixedWeeks = props.broadcastCalendar ? 35 : 42;
    if (props.fixedWeeks && monthDates.length < nrOfDaysWithFixedWeeks) {
      const extraDates = dates.filter((date) => {
        const daysToAdd = nrOfDaysWithFixedWeeks - monthDates.length;
        return date > lastDateOfLastWeek && date <= addDays2(lastDateOfLastWeek, daysToAdd);
      });
      monthDates.push(...extraDates);
    }
    const weeks = monthDates.reduce((weeks2, date) => {
      const weekNumber2 = props.ISOWeek ? getISOWeek2(date) : getWeek2(date);
      const week2 = weeks2.find((week3) => week3.weekNumber === weekNumber2);
      const day2 = new CalendarDay(date, month2, dateLib);
      if (!week2) {
        weeks2.push(new CalendarWeek(weekNumber2, [day2]));
      } else {
        week2.days.push(day2);
      }
      return weeks2;
    }, []);
    const dayPickerMonth = new CalendarMonth(month2, weeks);
    months2.push(dayPickerMonth);
    return months2;
  }, []);
  if (!props.reverseMonths) {
    return dayPickerMonths;
  } else {
    return dayPickerMonths.reverse();
  }
}
function getNavMonths(props, dateLib) {
  let { startMonth, endMonth } = props;
  const { startOfYear: startOfYear2, startOfDay: startOfDay2, startOfMonth: startOfMonth2, endOfMonth: endOfMonth2, addYears: addYears2, endOfYear: endOfYear2, newDate, today: today2 } = dateLib;
  const { fromYear, toYear, fromMonth, toMonth } = props;
  if (!startMonth && fromMonth) {
    startMonth = fromMonth;
  }
  if (!startMonth && fromYear) {
    startMonth = dateLib.newDate(fromYear, 0, 1);
  }
  if (!endMonth && toMonth) {
    endMonth = toMonth;
  }
  if (!endMonth && toYear) {
    endMonth = newDate(toYear, 11, 31);
  }
  const hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
  if (startMonth) {
    startMonth = startOfMonth2(startMonth);
  } else if (fromYear) {
    startMonth = newDate(fromYear, 0, 1);
  } else if (!startMonth && hasYearDropdown) {
    startMonth = startOfYear2(addYears2(props.today ?? today2(), -100));
  }
  if (endMonth) {
    endMonth = endOfMonth2(endMonth);
  } else if (toYear) {
    endMonth = newDate(toYear, 11, 31);
  } else if (!endMonth && hasYearDropdown) {
    endMonth = endOfYear2(props.today ?? today2());
  }
  return [
    startMonth ? startOfDay2(startMonth) : startMonth,
    endMonth ? startOfDay2(endMonth) : endMonth
  ];
}
function getNextMonth(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
  if (options.disableNavigation) {
    return void 0;
  }
  const { pagedNavigation, numberOfMonths = 1 } = options;
  const { startOfMonth: startOfMonth2, addMonths: addMonths2, differenceInCalendarMonths: differenceInCalendarMonths2 } = dateLib;
  const offset2 = pagedNavigation ? numberOfMonths : 1;
  const month2 = startOfMonth2(firstDisplayedMonth);
  if (!calendarEndMonth) {
    return addMonths2(month2, offset2);
  }
  const monthsDiff = differenceInCalendarMonths2(calendarEndMonth, firstDisplayedMonth);
  if (monthsDiff < numberOfMonths) {
    return void 0;
  }
  return addMonths2(month2, offset2);
}
function getPreviousMonth(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
  if (options.disableNavigation) {
    return void 0;
  }
  const { pagedNavigation, numberOfMonths } = options;
  const { startOfMonth: startOfMonth2, addMonths: addMonths2, differenceInCalendarMonths: differenceInCalendarMonths2 } = dateLib;
  const offset2 = pagedNavigation ? numberOfMonths ?? 1 : 1;
  const month2 = startOfMonth2(firstDisplayedMonth);
  if (!calendarStartMonth) {
    return addMonths2(month2, -offset2);
  }
  const monthsDiff = differenceInCalendarMonths2(month2, calendarStartMonth);
  if (monthsDiff <= 0) {
    return void 0;
  }
  return addMonths2(month2, -offset2);
}
function getWeeks(months2) {
  const initialWeeks = [];
  return months2.reduce((weeks, month2) => {
    return weeks.concat(month2.weeks.slice());
  }, initialWeeks.slice());
}
function useControlledValue(defaultValue, controlledValue) {
  const [uncontrolledValue, setValue] = useState(defaultValue);
  const value2 = controlledValue === void 0 ? uncontrolledValue : controlledValue;
  return [value2, setValue];
}
function useCalendar(props, dateLib) {
  var _a;
  const [navStart, navEnd] = getNavMonths(props, dateLib);
  const { startOfMonth: startOfMonth2, endOfMonth: endOfMonth2 } = dateLib;
  const initialMonth = getInitialMonth(props, navStart, navEnd, dateLib);
  const [firstMonth, setFirstMonth] = useControlledValue(
    initialMonth,
    // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : void 0
  );
  useEffect(() => {
    const newInitialMonth = getInitialMonth(props, navStart, navEnd, dateLib);
    setFirstMonth(newInitialMonth);
  }, [props.timeZone]);
  const { months: months2, weeks, days, previousMonth, nextMonth } = useMemo(() => {
    const displayMonths = getDisplayMonths(firstMonth, navEnd, { numberOfMonths: props.numberOfMonths }, dateLib);
    const dates = getDates(displayMonths, props.endMonth ? endOfMonth2(props.endMonth) : void 0, {
      ISOWeek: props.ISOWeek,
      fixedWeeks: props.fixedWeeks,
      broadcastCalendar: props.broadcastCalendar
    }, dateLib);
    const months3 = getMonths(displayMonths, dates, {
      broadcastCalendar: props.broadcastCalendar,
      fixedWeeks: props.fixedWeeks,
      ISOWeek: props.ISOWeek,
      reverseMonths: props.reverseMonths
    }, dateLib);
    const weeks2 = getWeeks(months3);
    const days2 = getDays(months3);
    const previousMonth2 = getPreviousMonth(firstMonth, navStart, props, dateLib);
    const nextMonth2 = getNextMonth(firstMonth, navEnd, props, dateLib);
    return {
      months: months3,
      weeks: weeks2,
      days: days2,
      previousMonth: previousMonth2,
      nextMonth: nextMonth2
    };
  }, [
    dateLib,
    firstMonth.getTime(),
    navEnd == null ? void 0 : navEnd.getTime(),
    navStart == null ? void 0 : navStart.getTime(),
    props.disableNavigation,
    props.broadcastCalendar,
    (_a = props.endMonth) == null ? void 0 : _a.getTime(),
    props.fixedWeeks,
    props.ISOWeek,
    props.numberOfMonths,
    props.pagedNavigation,
    props.reverseMonths
  ]);
  const { disableNavigation, onMonthChange } = props;
  const isDayInCalendar = (day2) => weeks.some((week2) => week2.days.some((d) => d.isEqualTo(day2)));
  const goToMonth = (date) => {
    if (disableNavigation) {
      return;
    }
    let newMonth = startOfMonth2(date);
    if (navStart && newMonth < startOfMonth2(navStart)) {
      newMonth = startOfMonth2(navStart);
    }
    if (navEnd && newMonth > startOfMonth2(navEnd)) {
      newMonth = startOfMonth2(navEnd);
    }
    setFirstMonth(newMonth);
    onMonthChange == null ? void 0 : onMonthChange(newMonth);
  };
  const goToDay = (day2) => {
    if (isDayInCalendar(day2)) {
      return;
    }
    goToMonth(day2.date);
  };
  const calendar = {
    months: months2,
    weeks,
    days,
    navStart,
    navEnd,
    previousMonth,
    nextMonth,
    goToMonth,
    goToDay
  };
  return calendar;
}
var FocusTargetPriority;
(function(FocusTargetPriority2) {
  FocusTargetPriority2[FocusTargetPriority2["Today"] = 0] = "Today";
  FocusTargetPriority2[FocusTargetPriority2["Selected"] = 1] = "Selected";
  FocusTargetPriority2[FocusTargetPriority2["LastFocused"] = 2] = "LastFocused";
  FocusTargetPriority2[FocusTargetPriority2["FocusedModifier"] = 3] = "FocusedModifier";
})(FocusTargetPriority || (FocusTargetPriority = {}));
function isFocusableDay(modifiers) {
  return !modifiers[DayFlag.disabled] && !modifiers[DayFlag.hidden] && !modifiers[DayFlag.outside];
}
function calculateFocusTarget(days, getModifiers, isSelected, lastFocused) {
  let focusTarget;
  let foundFocusTargetPriority = -1;
  for (const day2 of days) {
    const modifiers = getModifiers(day2);
    if (isFocusableDay(modifiers)) {
      if (modifiers[DayFlag.focused] && foundFocusTargetPriority < FocusTargetPriority.FocusedModifier) {
        focusTarget = day2;
        foundFocusTargetPriority = FocusTargetPriority.FocusedModifier;
      } else if ((lastFocused == null ? void 0 : lastFocused.isEqualTo(day2)) && foundFocusTargetPriority < FocusTargetPriority.LastFocused) {
        focusTarget = day2;
        foundFocusTargetPriority = FocusTargetPriority.LastFocused;
      } else if (isSelected(day2.date) && foundFocusTargetPriority < FocusTargetPriority.Selected) {
        focusTarget = day2;
        foundFocusTargetPriority = FocusTargetPriority.Selected;
      } else if (modifiers[DayFlag.today] && foundFocusTargetPriority < FocusTargetPriority.Today) {
        focusTarget = day2;
        foundFocusTargetPriority = FocusTargetPriority.Today;
      }
    }
  }
  if (!focusTarget) {
    focusTarget = days.find((day2) => isFocusableDay(getModifiers(day2)));
  }
  return focusTarget;
}
function getFocusableDate(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
  const { ISOWeek, broadcastCalendar } = props;
  const { addDays: addDays2, addMonths: addMonths2, addWeeks: addWeeks2, addYears: addYears2, endOfBroadcastWeek: endOfBroadcastWeek2, endOfISOWeek: endOfISOWeek2, endOfWeek: endOfWeek2, max: max2, min: min2, startOfBroadcastWeek: startOfBroadcastWeek2, startOfISOWeek: startOfISOWeek2, startOfWeek: startOfWeek2 } = dateLib;
  const moveFns = {
    day: addDays2,
    week: addWeeks2,
    month: addMonths2,
    year: addYears2,
    startOfWeek: (date) => broadcastCalendar ? startOfBroadcastWeek2(date, dateLib) : ISOWeek ? startOfISOWeek2(date) : startOfWeek2(date),
    endOfWeek: (date) => broadcastCalendar ? endOfBroadcastWeek2(date) : ISOWeek ? endOfISOWeek2(date) : endOfWeek2(date)
  };
  let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
  if (moveDir === "before" && navStart) {
    focusableDate = max2([navStart, focusableDate]);
  } else if (moveDir === "after" && navEnd) {
    focusableDate = min2([navEnd, focusableDate]);
  }
  return focusableDate;
}
function getNextFocus(moveBy, moveDir, refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
  if (attempt > 365) {
    return void 0;
  }
  const focusableDate = getFocusableDate(moveBy, moveDir, refDay.date, calendarStartMonth, calendarEndMonth, props, dateLib);
  const isDisabled = Boolean(props.disabled && dateMatchModifiers(focusableDate, props.disabled, dateLib));
  const isHidden2 = Boolean(props.hidden && dateMatchModifiers(focusableDate, props.hidden, dateLib));
  const targetMonth = focusableDate;
  const focusDay = new CalendarDay(focusableDate, targetMonth, dateLib);
  if (!isDisabled && !isHidden2) {
    return focusDay;
  }
  return getNextFocus(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}
function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
  const { autoFocus } = props;
  const [lastFocused, setLastFocused] = useState();
  const focusTarget = calculateFocusTarget(calendar.days, getModifiers, isSelected || (() => false), lastFocused);
  const [focusedDay, setFocused] = useState(autoFocus ? focusTarget : void 0);
  const blur = () => {
    setLastFocused(focusedDay);
    setFocused(void 0);
  };
  const moveFocus = (moveBy, moveDir) => {
    if (!focusedDay)
      return;
    const nextFocus = getNextFocus(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
    if (!nextFocus)
      return;
    if (props.disableNavigation) {
      const isNextInCalendar = calendar.days.some((day2) => day2.isEqualTo(nextFocus));
      if (!isNextInCalendar) {
        return;
      }
    }
    calendar.goToDay(nextFocus);
    setFocused(nextFocus);
  };
  const isFocusTarget = (day2) => {
    return Boolean(focusTarget == null ? void 0 : focusTarget.isEqualTo(day2));
  };
  const useFocus2 = {
    isFocusTarget,
    setFocused,
    focused: focusedDay,
    blur,
    moveFocus
  };
  return useFocus2;
}
function useMulti(props, dateLib) {
  const { selected: initiallySelected, required: required2, onSelect } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : void 0);
  const selected2 = !onSelect ? internallySelected : initiallySelected;
  const { isSameDay: isSameDay2 } = dateLib;
  const isSelected = (date) => {
    return (selected2 == null ? void 0 : selected2.some((d) => isSameDay2(d, date))) ?? false;
  };
  const { min: min2, max: max2 } = props;
  const select = (triggerDate, modifiers, e) => {
    let newDates = [...selected2 ?? []];
    if (isSelected(triggerDate)) {
      if ((selected2 == null ? void 0 : selected2.length) === min2) {
        return;
      }
      if (required2 && (selected2 == null ? void 0 : selected2.length) === 1) {
        return;
      }
      newDates = selected2 == null ? void 0 : selected2.filter((d) => !isSameDay2(d, triggerDate));
    } else {
      if ((selected2 == null ? void 0 : selected2.length) === max2) {
        newDates = [triggerDate];
      } else {
        newDates = [...newDates, triggerDate];
      }
    }
    if (!onSelect) {
      setSelected(newDates);
    }
    onSelect == null ? void 0 : onSelect(newDates, triggerDate, modifiers, e);
    return newDates;
  };
  return {
    selected: selected2,
    select,
    isSelected
  };
}
function addToRange(date, initialRange, min2 = 0, max2 = 0, required2 = false, dateLib = defaultDateLib) {
  const { from, to } = initialRange || {};
  const { isSameDay: isSameDay2, isAfter: isAfter2, isBefore: isBefore2 } = dateLib;
  let range2;
  if (!from && !to) {
    range2 = { from: date, to: min2 > 0 ? void 0 : date };
  } else if (from && !to) {
    if (isSameDay2(from, date)) {
      if (min2 === 0) {
        range2 = { from, to: date };
      } else if (required2) {
        range2 = { from, to: void 0 };
      } else {
        range2 = void 0;
      }
    } else if (isBefore2(date, from)) {
      range2 = { from: date, to: from };
    } else {
      range2 = { from, to: date };
    }
  } else if (from && to) {
    if (isSameDay2(from, date) && isSameDay2(to, date)) {
      if (required2) {
        range2 = { from, to };
      } else {
        range2 = void 0;
      }
    } else if (isSameDay2(from, date)) {
      range2 = { from, to: min2 > 0 ? void 0 : date };
    } else if (isSameDay2(to, date)) {
      range2 = { from: date, to: min2 > 0 ? void 0 : date };
    } else if (isBefore2(date, from)) {
      range2 = { from: date, to };
    } else if (isAfter2(date, from)) {
      range2 = { from, to: date };
    } else if (isAfter2(date, to)) {
      range2 = { from, to: date };
    } else {
      throw new Error("Invalid range");
    }
  }
  if ((range2 == null ? void 0 : range2.from) && (range2 == null ? void 0 : range2.to)) {
    const diff = dateLib.differenceInCalendarDays(range2.to, range2.from);
    if (max2 > 0 && diff > max2) {
      range2 = { from: date, to: void 0 };
    } else if (min2 > 1 && diff < min2) {
      range2 = { from: date, to: void 0 };
    }
  }
  return range2;
}
function rangeContainsDayOfWeek(range2, dayOfWeek, dateLib = defaultDateLib) {
  const dayOfWeekArr = !Array.isArray(dayOfWeek) ? [dayOfWeek] : dayOfWeek;
  let date = range2.from;
  const totalDays = dateLib.differenceInCalendarDays(range2.to, range2.from);
  const totalDaysLimit = Math.min(totalDays, 6);
  for (let i = 0; i <= totalDaysLimit; i++) {
    if (dayOfWeekArr.includes(date.getDay())) {
      return true;
    }
    date = dateLib.addDays(date, 1);
  }
  return false;
}
function rangeOverlaps(rangeLeft, rangeRight, dateLib = defaultDateLib) {
  return rangeIncludesDate(rangeLeft, rangeRight.from, false, dateLib) || rangeIncludesDate(rangeLeft, rangeRight.to, false, dateLib) || rangeIncludesDate(rangeRight, rangeLeft.from, false, dateLib) || rangeIncludesDate(rangeRight, rangeLeft.to, false, dateLib);
}
function rangeContainsModifiers(range2, modifiers, dateLib = defaultDateLib) {
  const matchers = Array.isArray(modifiers) ? modifiers : [modifiers];
  const nonFunctionMatchers = matchers.filter((matcher) => typeof matcher !== "function");
  const nonFunctionMatchersResult = nonFunctionMatchers.some((matcher) => {
    if (typeof matcher === "boolean")
      return matcher;
    if (dateLib.isDate(matcher)) {
      return rangeIncludesDate(range2, matcher, false, dateLib);
    }
    if (isDatesArray(matcher, dateLib)) {
      return matcher.some((date) => rangeIncludesDate(range2, date, false, dateLib));
    }
    if (isDateRange(matcher)) {
      if (matcher.from && matcher.to) {
        return rangeOverlaps(range2, { from: matcher.from, to: matcher.to }, dateLib);
      }
      return false;
    }
    if (isDayOfWeekType(matcher)) {
      return rangeContainsDayOfWeek(range2, matcher.dayOfWeek, dateLib);
    }
    if (isDateInterval(matcher)) {
      const isClosedInterval = dateLib.isAfter(matcher.before, matcher.after);
      if (isClosedInterval) {
        return rangeOverlaps(range2, {
          from: dateLib.addDays(matcher.after, 1),
          to: dateLib.addDays(matcher.before, -1)
        }, dateLib);
      }
      return dateMatchModifiers(range2.from, matcher, dateLib) || dateMatchModifiers(range2.to, matcher, dateLib);
    }
    if (isDateAfterType(matcher) || isDateBeforeType(matcher)) {
      return dateMatchModifiers(range2.from, matcher, dateLib) || dateMatchModifiers(range2.to, matcher, dateLib);
    }
    return false;
  });
  if (nonFunctionMatchersResult) {
    return true;
  }
  const functionMatchers = matchers.filter((matcher) => typeof matcher === "function");
  if (functionMatchers.length) {
    let date = range2.from;
    const totalDays = dateLib.differenceInCalendarDays(range2.to, range2.from);
    for (let i = 0; i <= totalDays; i++) {
      if (functionMatchers.some((matcher) => matcher(date))) {
        return true;
      }
      date = dateLib.addDays(date, 1);
    }
  }
  return false;
}
function useRange(props, dateLib) {
  const { disabled: disabled2, excludeDisabled, resetOnSelect, selected: initiallySelected, required: required2, onSelect } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : void 0);
  const selected2 = !onSelect ? internallySelected : initiallySelected;
  const isSelected = (date) => selected2 && rangeIncludesDate(selected2, date, false, dateLib);
  const select = (triggerDate, modifiers, e) => {
    const { min: min2, max: max2 } = props;
    let newRange;
    if (triggerDate) {
      const selectedFrom = selected2 == null ? void 0 : selected2.from;
      const selectedTo = selected2 == null ? void 0 : selected2.to;
      const hasFullRange = !!selectedFrom && !!selectedTo;
      const isClickingSingleDayRange = !!selectedFrom && !!selectedTo && dateLib.isSameDay(selectedFrom, selectedTo) && dateLib.isSameDay(triggerDate, selectedFrom);
      if (resetOnSelect && (hasFullRange || !(selected2 == null ? void 0 : selected2.from))) {
        if (!required2 && isClickingSingleDayRange) {
          newRange = void 0;
        } else {
          newRange = { from: triggerDate, to: void 0 };
        }
      } else {
        newRange = addToRange(triggerDate, selected2, min2, max2, required2, dateLib);
      }
    }
    if (excludeDisabled && disabled2 && (newRange == null ? void 0 : newRange.from) && newRange.to) {
      if (rangeContainsModifiers({ from: newRange.from, to: newRange.to }, disabled2, dateLib)) {
        newRange.from = triggerDate;
        newRange.to = void 0;
      }
    }
    if (!onSelect) {
      setSelected(newRange);
    }
    onSelect == null ? void 0 : onSelect(newRange, triggerDate, modifiers, e);
    return newRange;
  };
  return {
    selected: selected2,
    select,
    isSelected
  };
}
function useSingle(props, dateLib) {
  const { selected: initiallySelected, required: required2, onSelect } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : void 0);
  const selected2 = !onSelect ? internallySelected : initiallySelected;
  const { isSameDay: isSameDay2 } = dateLib;
  const isSelected = (compareDate) => {
    return selected2 ? isSameDay2(selected2, compareDate) : false;
  };
  const select = (triggerDate, modifiers, e) => {
    let newDate = triggerDate;
    if (!required2 && selected2 && selected2 && isSameDay2(triggerDate, selected2)) {
      newDate = void 0;
    }
    if (!onSelect) {
      setSelected(newDate);
    }
    if (required2) {
      onSelect == null ? void 0 : onSelect(newDate, triggerDate, modifiers, e);
    } else {
      onSelect == null ? void 0 : onSelect(newDate, triggerDate, modifiers, e);
    }
    return newDate;
  };
  return {
    selected: selected2,
    select,
    isSelected
  };
}
function useSelection(props, dateLib) {
  const single2 = useSingle(props, dateLib);
  const multi = useMulti(props, dateLib);
  const range2 = useRange(props, dateLib);
  switch (props.mode) {
    case "single":
      return single2;
    case "multiple":
      return multi;
    case "range":
      return range2;
    default:
      return void 0;
  }
}
function toTimeZone(date, timeZone) {
  if (date instanceof TZDate && date.timeZone === timeZone) {
    return date;
  }
  return new TZDate(date, timeZone);
}
function toZoneNoon(date, timeZone, noonSafe) {
  return toTimeZone(date, timeZone);
}
function convertMatcher(matcher, timeZone, noonSafe) {
  if (typeof matcher === "boolean" || typeof matcher === "function") {
    return matcher;
  }
  if (matcher instanceof Date) {
    return toZoneNoon(matcher, timeZone);
  }
  if (Array.isArray(matcher)) {
    return matcher.map((value2) => value2 instanceof Date ? toZoneNoon(value2, timeZone) : value2);
  }
  if (isDateRange(matcher)) {
    return {
      ...matcher,
      from: matcher.from ? toTimeZone(matcher.from, timeZone) : matcher.from,
      to: matcher.to ? toTimeZone(matcher.to, timeZone) : matcher.to
    };
  }
  if (isDateInterval(matcher)) {
    return {
      before: toZoneNoon(matcher.before, timeZone),
      after: toZoneNoon(matcher.after, timeZone)
    };
  }
  if (isDateAfterType(matcher)) {
    return {
      after: toZoneNoon(matcher.after, timeZone)
    };
  }
  if (isDateBeforeType(matcher)) {
    return {
      before: toZoneNoon(matcher.before, timeZone)
    };
  }
  return matcher;
}
function convertMatchersToTimeZone(matchers, timeZone, noonSafe) {
  if (!matchers) {
    return matchers;
  }
  if (Array.isArray(matchers)) {
    return matchers.map((matcher) => convertMatcher(matcher, timeZone));
  }
  return convertMatcher(matchers, timeZone);
}
function DayPicker(initialProps) {
  var _a;
  let props = initialProps;
  const timeZone = props.timeZone;
  if (timeZone) {
    props = {
      ...initialProps,
      timeZone
    };
    if (props.today) {
      props.today = toTimeZone(props.today, timeZone);
    }
    if (props.month) {
      props.month = toTimeZone(props.month, timeZone);
    }
    if (props.defaultMonth) {
      props.defaultMonth = toTimeZone(props.defaultMonth, timeZone);
    }
    if (props.startMonth) {
      props.startMonth = toTimeZone(props.startMonth, timeZone);
    }
    if (props.endMonth) {
      props.endMonth = toTimeZone(props.endMonth, timeZone);
    }
    if (props.mode === "single" && props.selected) {
      props.selected = toTimeZone(props.selected, timeZone);
    } else if (props.mode === "multiple" && props.selected) {
      props.selected = (_a = props.selected) == null ? void 0 : _a.map((date) => toTimeZone(date, timeZone));
    } else if (props.mode === "range" && props.selected) {
      props.selected = {
        from: props.selected.from ? toTimeZone(props.selected.from, timeZone) : props.selected.from,
        to: props.selected.to ? toTimeZone(props.selected.to, timeZone) : props.selected.to
      };
    }
    if (props.disabled !== void 0) {
      props.disabled = convertMatchersToTimeZone(props.disabled, timeZone);
    }
    if (props.hidden !== void 0) {
      props.hidden = convertMatchersToTimeZone(props.hidden, timeZone);
    }
    if (props.modifiers) {
      const nextModifiers = {};
      Object.keys(props.modifiers).forEach((key) => {
        var _a2;
        nextModifiers[key] = convertMatchersToTimeZone((_a2 = props.modifiers) == null ? void 0 : _a2[key], timeZone);
      });
      props.modifiers = nextModifiers;
    }
  }
  const { components: components2, formatters: formatters2, labels, dateLib, locale, classNames } = useMemo(() => {
    const locale2 = { ...enUS, ...props.locale };
    const weekStartsOn = props.broadcastCalendar ? 1 : props.weekStartsOn;
    const noonOverrides = props.noonSafe && props.timeZone ? createNoonOverrides(props.timeZone, {
      weekStartsOn,
      locale: locale2
    }) : void 0;
    const overrides = props.dateLib && noonOverrides ? { ...noonOverrides, ...props.dateLib } : props.dateLib ?? noonOverrides;
    const dateLib2 = new DateLib({
      locale: locale2,
      weekStartsOn,
      firstWeekContainsDate: props.firstWeekContainsDate,
      useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens,
      timeZone: props.timeZone,
      numerals: props.numerals
    }, overrides);
    return {
      dateLib: dateLib2,
      components: getComponents(props.components),
      formatters: getFormatters(props.formatters),
      labels: getLabels(props.labels, dateLib2.options),
      locale: locale2,
      classNames: { ...getDefaultClassNames(), ...props.classNames }
    };
  }, [
    props.locale,
    props.broadcastCalendar,
    props.weekStartsOn,
    props.firstWeekContainsDate,
    props.useAdditionalWeekYearTokens,
    props.useAdditionalDayOfYearTokens,
    props.timeZone,
    props.numerals,
    props.dateLib,
    props.noonSafe,
    props.components,
    props.formatters,
    props.labels,
    props.classNames
  ]);
  if (!props.today) {
    props = { ...props, today: dateLib.today() };
  }
  const { captionLayout, mode, navLayout, numberOfMonths = 1, onDayBlur, onDayClick, onDayFocus, onDayKeyDown, onDayMouseEnter, onDayMouseLeave, onNextClick, onPrevClick, showWeekNumber, styles: styles2 } = props;
  const { formatCaption: formatCaption2, formatDay: formatDay2, formatMonthDropdown: formatMonthDropdown2, formatWeekNumber: formatWeekNumber2, formatWeekNumberHeader: formatWeekNumberHeader2, formatWeekdayName: formatWeekdayName2, formatYearDropdown: formatYearDropdown2 } = formatters2;
  const calendar = useCalendar(props, dateLib);
  const { days, months: months2, navStart, navEnd, previousMonth, nextMonth, goToMonth } = calendar;
  const getModifiers = createGetModifiers(days, props, navStart, navEnd, dateLib);
  const { isSelected, select, selected: selectedValue } = useSelection(props, dateLib) ?? {};
  const { blur, focused, isFocusTarget, moveFocus, setFocused } = useFocus(props, calendar, getModifiers, isSelected ?? (() => false), dateLib);
  const { labelDayButton: labelDayButton2, labelGridcell: labelGridcell2, labelGrid: labelGrid2, labelMonthDropdown: labelMonthDropdown2, labelNav: labelNav2, labelPrevious: labelPrevious2, labelNext: labelNext2, labelWeekday: labelWeekday2, labelWeekNumber: labelWeekNumber2, labelWeekNumberHeader: labelWeekNumberHeader2, labelYearDropdown: labelYearDropdown2 } = labels;
  const weekdays2 = useMemo(() => getWeekdays(dateLib, props.ISOWeek, props.broadcastCalendar, props.today), [dateLib, props.ISOWeek, props.broadcastCalendar, props.today]);
  const isInteractive = mode !== void 0 || onDayClick !== void 0;
  const handlePreviousClick = useCallback(() => {
    if (!previousMonth)
      return;
    goToMonth(previousMonth);
    onPrevClick == null ? void 0 : onPrevClick(previousMonth);
  }, [previousMonth, goToMonth, onPrevClick]);
  const handleNextClick = useCallback(() => {
    if (!nextMonth)
      return;
    goToMonth(nextMonth);
    onNextClick == null ? void 0 : onNextClick(nextMonth);
  }, [goToMonth, nextMonth, onNextClick]);
  const handleDayClick = useCallback((day2, m) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFocused(day2);
    if (m.disabled) {
      return;
    }
    select == null ? void 0 : select(day2.date, m, e);
    onDayClick == null ? void 0 : onDayClick(day2.date, m, e);
  }, [select, onDayClick, setFocused]);
  const handleDayFocus = useCallback((day2, m) => (e) => {
    setFocused(day2);
    onDayFocus == null ? void 0 : onDayFocus(day2.date, m, e);
  }, [onDayFocus, setFocused]);
  const handleDayBlur = useCallback((day2, m) => (e) => {
    blur();
    onDayBlur == null ? void 0 : onDayBlur(day2.date, m, e);
  }, [blur, onDayBlur]);
  const handleDayKeyDown = useCallback((day2, modifiers) => (e) => {
    const keyMap = {
      ArrowLeft: [
        e.shiftKey ? "month" : "day",
        props.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        e.shiftKey ? "month" : "day",
        props.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [e.shiftKey ? "year" : "week", "after"],
      ArrowUp: [e.shiftKey ? "year" : "week", "before"],
      PageUp: [e.shiftKey ? "year" : "month", "before"],
      PageDown: [e.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (keyMap[e.key]) {
      e.preventDefault();
      e.stopPropagation();
      const [moveBy, moveDir] = keyMap[e.key];
      moveFocus(moveBy, moveDir);
    }
    onDayKeyDown == null ? void 0 : onDayKeyDown(day2.date, modifiers, e);
  }, [moveFocus, onDayKeyDown, props.dir]);
  const handleDayMouseEnter = useCallback((day2, modifiers) => (e) => {
    onDayMouseEnter == null ? void 0 : onDayMouseEnter(day2.date, modifiers, e);
  }, [onDayMouseEnter]);
  const handleDayMouseLeave = useCallback((day2, modifiers) => (e) => {
    onDayMouseLeave == null ? void 0 : onDayMouseLeave(day2.date, modifiers, e);
  }, [onDayMouseLeave]);
  const handleMonthChange = useCallback((date) => (e) => {
    const selectedMonth = Number(e.target.value);
    const month2 = dateLib.setMonth(dateLib.startOfMonth(date), selectedMonth);
    goToMonth(month2);
  }, [dateLib, goToMonth]);
  const handleYearChange = useCallback((date) => (e) => {
    const selectedYear = Number(e.target.value);
    const month2 = dateLib.setYear(dateLib.startOfMonth(date), selectedYear);
    goToMonth(month2);
  }, [dateLib, goToMonth]);
  const { className, style } = useMemo(() => ({
    className: [classNames[UI.Root], props.className].filter(Boolean).join(" "),
    style: { ...styles2 == null ? void 0 : styles2[UI.Root], ...props.style }
  }), [classNames, props.className, props.style, styles2]);
  const dataAttributes = getDataAttributes(props);
  const rootElRef = useRef(null);
  useAnimation(rootElRef, Boolean(props.animate), {
    classNames,
    months: months2,
    focused,
    dateLib
  });
  const contextValue = {
    dayPickerProps: props,
    selected: selectedValue,
    select,
    isSelected,
    months: months2,
    nextMonth,
    previousMonth,
    goToMonth,
    getModifiers,
    components: components2,
    classNames,
    styles: styles2,
    labels,
    formatters: formatters2
  };
  return React__default.createElement(
    dayPickerContext.Provider,
    { value: contextValue },
    React__default.createElement(
      components2.Root,
      { rootRef: props.animate ? rootElRef : void 0, className, style, dir: props.dir, id: props.id, lang: props.lang ?? locale.code, nonce: props.nonce, title: props.title, role: props.role, "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"], ...dataAttributes },
      React__default.createElement(
        components2.Months,
        { className: classNames[UI.Months], style: styles2 == null ? void 0 : styles2[UI.Months] },
        !props.hideNavigation && !navLayout && React__default.createElement(components2.Nav, { "data-animated-nav": props.animate ? "true" : void 0, className: classNames[UI.Nav], style: styles2 == null ? void 0 : styles2[UI.Nav], "aria-label": labelNav2(), onPreviousClick: handlePreviousClick, onNextClick: handleNextClick, previousMonth, nextMonth }),
        months2.map((calendarMonth, displayIndex) => {
          return React__default.createElement(
            components2.Month,
            {
              "data-animated-month": props.animate ? "true" : void 0,
              className: classNames[UI.Month],
              style: styles2 == null ? void 0 : styles2[UI.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: displayIndex,
              displayIndex,
              calendarMonth
            },
            navLayout === "around" && !props.hideNavigation && displayIndex === 0 && React__default.createElement(
              components2.PreviousMonthButton,
              { type: "button", className: classNames[UI.PreviousMonthButton], tabIndex: previousMonth ? void 0 : -1, "aria-disabled": previousMonth ? void 0 : true, "aria-label": labelPrevious2(previousMonth), onClick: handlePreviousClick, "data-animated-button": props.animate ? "true" : void 0 },
              React__default.createElement(components2.Chevron, { disabled: previousMonth ? void 0 : true, className: classNames[UI.Chevron], orientation: props.dir === "rtl" ? "right" : "left" })
            ),
            React__default.createElement(components2.MonthCaption, { "data-animated-caption": props.animate ? "true" : void 0, className: classNames[UI.MonthCaption], style: styles2 == null ? void 0 : styles2[UI.MonthCaption], calendarMonth, displayIndex }, (captionLayout == null ? void 0 : captionLayout.startsWith("dropdown")) ? React__default.createElement(
              components2.DropdownNav,
              { className: classNames[UI.Dropdowns], style: styles2 == null ? void 0 : styles2[UI.Dropdowns] },
              (() => {
                const monthControl = captionLayout === "dropdown" || captionLayout === "dropdown-months" ? React__default.createElement(components2.MonthsDropdown, { key: "month", className: classNames[UI.MonthsDropdown], "aria-label": labelMonthDropdown2(), classNames, components: components2, disabled: Boolean(props.disableNavigation), onChange: handleMonthChange(calendarMonth.date), options: getMonthOptions(calendarMonth.date, navStart, navEnd, formatters2, dateLib), style: styles2 == null ? void 0 : styles2[UI.Dropdown], value: dateLib.getMonth(calendarMonth.date) }) : React__default.createElement("span", { key: "month" }, formatMonthDropdown2(calendarMonth.date, dateLib));
                const yearControl = captionLayout === "dropdown" || captionLayout === "dropdown-years" ? React__default.createElement(components2.YearsDropdown, { key: "year", className: classNames[UI.YearsDropdown], "aria-label": labelYearDropdown2(dateLib.options), classNames, components: components2, disabled: Boolean(props.disableNavigation), onChange: handleYearChange(calendarMonth.date), options: getYearOptions(navStart, navEnd, formatters2, dateLib, Boolean(props.reverseYears)), style: styles2 == null ? void 0 : styles2[UI.Dropdown], value: dateLib.getYear(calendarMonth.date) }) : React__default.createElement("span", { key: "year" }, formatYearDropdown2(calendarMonth.date, dateLib));
                const controls = dateLib.getMonthYearOrder() === "year-first" ? [yearControl, monthControl] : [monthControl, yearControl];
                return controls;
              })(),
              React__default.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, formatCaption2(calendarMonth.date, dateLib.options, dateLib))
            ) : React__default.createElement(components2.CaptionLabel, { className: classNames[UI.CaptionLabel], role: "status", "aria-live": "polite" }, formatCaption2(calendarMonth.date, dateLib.options, dateLib))),
            navLayout === "around" && !props.hideNavigation && displayIndex === numberOfMonths - 1 && React__default.createElement(
              components2.NextMonthButton,
              { type: "button", className: classNames[UI.NextMonthButton], tabIndex: nextMonth ? void 0 : -1, "aria-disabled": nextMonth ? void 0 : true, "aria-label": labelNext2(nextMonth), onClick: handleNextClick, "data-animated-button": props.animate ? "true" : void 0 },
              React__default.createElement(components2.Chevron, { disabled: nextMonth ? void 0 : true, className: classNames[UI.Chevron], orientation: props.dir === "rtl" ? "left" : "right" })
            ),
            displayIndex === numberOfMonths - 1 && navLayout === "after" && !props.hideNavigation && React__default.createElement(components2.Nav, { "data-animated-nav": props.animate ? "true" : void 0, className: classNames[UI.Nav], style: styles2 == null ? void 0 : styles2[UI.Nav], "aria-label": labelNav2(), onPreviousClick: handlePreviousClick, onNextClick: handleNextClick, previousMonth, nextMonth }),
            React__default.createElement(
              components2.MonthGrid,
              { role: "grid", "aria-multiselectable": mode === "multiple" || mode === "range", "aria-label": labelGrid2(calendarMonth.date, dateLib.options, dateLib) || void 0, className: classNames[UI.MonthGrid], style: styles2 == null ? void 0 : styles2[UI.MonthGrid] },
              !props.hideWeekdays && React__default.createElement(
                components2.Weekdays,
                { "data-animated-weekdays": props.animate ? "true" : void 0, className: classNames[UI.Weekdays], style: styles2 == null ? void 0 : styles2[UI.Weekdays] },
                showWeekNumber && React__default.createElement(components2.WeekNumberHeader, { "aria-label": labelWeekNumberHeader2(dateLib.options), className: classNames[UI.WeekNumberHeader], style: styles2 == null ? void 0 : styles2[UI.WeekNumberHeader], scope: "col" }, formatWeekNumberHeader2()),
                weekdays2.map((weekday2) => React__default.createElement(components2.Weekday, { "aria-label": labelWeekday2(weekday2, dateLib.options, dateLib), className: classNames[UI.Weekday], key: String(weekday2), style: styles2 == null ? void 0 : styles2[UI.Weekday], scope: "col" }, formatWeekdayName2(weekday2, dateLib.options, dateLib)))
              ),
              React__default.createElement(components2.Weeks, { "data-animated-weeks": props.animate ? "true" : void 0, className: classNames[UI.Weeks], style: styles2 == null ? void 0 : styles2[UI.Weeks] }, calendarMonth.weeks.map((week2) => {
                return React__default.createElement(
                  components2.Week,
                  { className: classNames[UI.Week], key: week2.weekNumber, style: styles2 == null ? void 0 : styles2[UI.Week], week: week2 },
                  showWeekNumber && React__default.createElement(components2.WeekNumber, { week: week2, style: styles2 == null ? void 0 : styles2[UI.WeekNumber], "aria-label": labelWeekNumber2(week2.weekNumber, {
                    locale
                  }), className: classNames[UI.WeekNumber], scope: "row", role: "rowheader" }, formatWeekNumber2(week2.weekNumber, dateLib)),
                  week2.days.map((day2) => {
                    const { date } = day2;
                    const modifiers = getModifiers(day2);
                    modifiers[DayFlag.focused] = !modifiers.hidden && Boolean(focused == null ? void 0 : focused.isEqualTo(day2));
                    modifiers[SelectionState.selected] = (isSelected == null ? void 0 : isSelected(date)) || modifiers.selected;
                    if (isDateRange(selectedValue)) {
                      const { from, to } = selectedValue;
                      modifiers[SelectionState.range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                      modifiers[SelectionState.range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                      modifiers[SelectionState.range_middle] = rangeIncludesDate(selectedValue, date, true, dateLib);
                    }
                    const style2 = getStyleForModifiers(modifiers, styles2, props.modifiersStyles);
                    const className2 = getClassNamesForModifiers(modifiers, classNames, props.modifiersClassNames);
                    const ariaLabel = !isInteractive && !modifiers.hidden ? labelGridcell2(date, modifiers, dateLib.options, dateLib) : void 0;
                    return React__default.createElement(components2.Day, { key: `${day2.isoDate}_${day2.displayMonthId}`, day: day2, modifiers, className: className2.join(" "), style: style2, role: "gridcell", "aria-selected": modifiers.selected || void 0, "aria-label": ariaLabel, "data-day": day2.isoDate, "data-month": day2.outside ? day2.dateMonthId : void 0, "data-selected": modifiers.selected || void 0, "data-disabled": modifiers.disabled || void 0, "data-hidden": modifiers.hidden || void 0, "data-outside": day2.outside || void 0, "data-focused": modifiers.focused || void 0, "data-today": modifiers.today || void 0 }, !modifiers.hidden && isInteractive ? React__default.createElement(components2.DayButton, { className: classNames[UI.DayButton], style: styles2 == null ? void 0 : styles2[UI.DayButton], type: "button", day: day2, modifiers, disabled: !modifiers.focused && modifiers.disabled || void 0, "aria-disabled": modifiers.focused && modifiers.disabled || void 0, tabIndex: isFocusTarget(day2) ? 0 : -1, "aria-label": labelDayButton2(date, modifiers, dateLib.options, dateLib), onClick: handleDayClick(day2, modifiers), onBlur: handleDayBlur(day2, modifiers), onFocus: handleDayFocus(day2, modifiers), onKeyDown: handleDayKeyDown(day2, modifiers), onMouseEnter: handleDayMouseEnter(day2, modifiers), onMouseLeave: handleDayMouseLeave(day2, modifiers) }, formatDay2(date, dateLib.options, dateLib)) : !modifiers.hidden && formatDay2(day2.date, dateLib.options, dateLib));
                  })
                );
              }))
            )
          );
        })
      ),
      props.footer && React__default.createElement(components2.Footer, { className: classNames[UI.Footer], style: styles2 == null ? void 0 : styles2[UI.Footer], role: "status", "aria-live": "polite" }, props.footer)
    )
  );
}
const root$1 = "_root_j64i6_6 _root_1vzln_3";
const navButton = "_navButton_j64i6_14";
const calendarRoot = "_calendarRoot_j64i6_27";
const months = "_months_j64i6_31";
const month = "_month_j64i6_31";
const nav = "_nav_j64i6_14";
const monthCaption = "_monthCaption_j64i6_70";
const dropdowns = "_dropdowns_j64i6_79";
const dropdownRoot = "_dropdownRoot_j64i6_90";
const dropdown = "_dropdown_j64i6_79";
const captionLabel = "_captionLabel_j64i6_109";
const captionLabelDropdown = "_captionLabelDropdown_j64i6_115";
const table$3 = "_table_j64i6_131";
const weekdays = "_weekdays_j64i6_136";
const weekday = "_weekday_j64i6_136";
const week = "_week_j64i6_136";
const weekNumberHeader = "_weekNumberHeader_j64i6_155";
const weekNumber = "_weekNumber_j64i6_155";
const weekNumberCell = "_weekNumberCell_j64i6_166";
const day = "_day_j64i6_175";
const dayWithWeekNumber = "_dayWithWeekNumber_j64i6_193";
const dayButton = "_dayButton_j64i6_199";
const rangeStart = "_rangeStart_j64i6_254";
const rangeMiddle = "_rangeMiddle_j64i6_259";
const rangeEnd = "_rangeEnd_j64i6_263";
const today = "_today_j64i6_268";
const outside = "_outside_j64i6_278";
const disabled = "_disabled_j64i6_286";
const hidden = "_hidden_j64i6_291";
const chevron$1 = "_chevron_j64i6_295";
const styles$p = {
  root: root$1,
  navButton,
  calendarRoot,
  months,
  month,
  nav,
  monthCaption,
  dropdowns,
  dropdownRoot,
  dropdown,
  captionLabel,
  captionLabelDropdown,
  table: table$3,
  weekdays,
  weekday,
  week,
  weekNumberHeader,
  weekNumber,
  weekNumberCell,
  day,
  dayWithWeekNumber,
  dayButton,
  rangeStart,
  rangeMiddle,
  rangeEnd,
  today,
  outside,
  disabled,
  hidden,
  chevron: chevron$1
};
function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  captionLayout = "label",
  buttonVariant = "ghost",
  formatters: formatters2,
  components: components2,
  locale,
  ...props
}) {
  const defaultClassNames = getDefaultClassNames();
  const resolvedLocale = locale ?? getPathDateLocale();
  return /* @__PURE__ */ jsx(
    DayPicker,
    {
      locale: resolvedLocale,
      showOutsideDays,
      className: clsx(styles$p.root, className),
      captionLayout,
      formatters: {
        formatMonthDropdown: (date) => date.toLocaleString(resolvedLocale.code, { month: "short" }),
        ...formatters2
      },
      classNames: {
        root: clsx(styles$p.calendarRoot, defaultClassNames.root),
        months: clsx(styles$p.months, defaultClassNames.months),
        month: clsx(styles$p.month, defaultClassNames.month),
        nav: clsx(styles$p.nav, defaultClassNames.nav),
        button_previous: clsx(
          buttonVariants({ variant: buttonVariant }),
          styles$p.navButton,
          defaultClassNames.button_previous
        ),
        button_next: clsx(
          buttonVariants({ variant: buttonVariant }),
          styles$p.navButton,
          defaultClassNames.button_next
        ),
        month_caption: clsx(
          styles$p.monthCaption,
          defaultClassNames.month_caption
        ),
        dropdowns: clsx(styles$p.dropdowns, defaultClassNames.dropdowns),
        dropdown_root: clsx(
          styles$p.dropdownRoot,
          defaultClassNames.dropdown_root
        ),
        dropdown: clsx(styles$p.dropdown, defaultClassNames.dropdown),
        caption_label: clsx(
          styles$p.captionLabel,
          captionLayout !== "label" && styles$p.captionLabelDropdown,
          defaultClassNames.caption_label
        ),
        table: styles$p.table,
        weekdays: clsx(styles$p.weekdays, defaultClassNames.weekdays),
        weekday: clsx(styles$p.weekday, defaultClassNames.weekday),
        week: clsx(styles$p.week, defaultClassNames.week),
        week_number_header: clsx(
          styles$p.weekNumberHeader,
          defaultClassNames.week_number_header
        ),
        week_number: clsx(styles$p.weekNumber, defaultClassNames.week_number),
        day: clsx(
          styles$p.day,
          props.showWeekNumber && styles$p.dayWithWeekNumber,
          defaultClassNames.day
        ),
        range_start: clsx(styles$p.rangeStart, defaultClassNames.range_start),
        range_middle: clsx(styles$p.rangeMiddle, defaultClassNames.range_middle),
        range_end: clsx(styles$p.rangeEnd, defaultClassNames.range_end),
        today: clsx(styles$p.today, defaultClassNames.today),
        outside: clsx(styles$p.outside, defaultClassNames.outside),
        disabled: clsx(styles$p.disabled, defaultClassNames.disabled),
        hidden: clsx(styles$p.hidden, defaultClassNames.hidden),
        ...classNames
      },
      components: {
        Root: ({ className: className2, rootRef, ...props2 }) => {
          return /* @__PURE__ */ jsx(
            "div",
            {
              "data-slot": "calendar",
              ref: rootRef,
              className: className2,
              ...props2
            }
          );
        },
        Chevron: ({ className: className2, orientation, ...props2 }) => {
          if (orientation === "left") {
            return /* @__PURE__ */ jsx(
              ChevronLeftIcon$1,
              {
                className: clsx(styles$p.chevron, className2),
                ...props2
              }
            );
          }
          if (orientation === "right") {
            return /* @__PURE__ */ jsx(
              ChevronRightIcon$1,
              {
                className: clsx(styles$p.chevron, className2),
                ...props2
              }
            );
          }
          return /* @__PURE__ */ jsx(
            ChevronDownIcon,
            {
              className: clsx(styles$p.chevron, className2),
              ...props2
            }
          );
        },
        DayButton: CalendarDayButton,
        WeekNumber: ({ children, ...props2 }) => {
          return /* @__PURE__ */ jsx("td", { ...props2, children: /* @__PURE__ */ jsx("div", { className: styles$p.weekNumberCell, children }) });
        },
        ...components2
      },
      ...props
    }
  );
}
function CalendarDayButton({
  className,
  day: day2,
  modifiers,
  ...props
}) {
  const defaultClassNames = getDefaultClassNames();
  const ref = React.useRef(null);
  React.useEffect(() => {
    var _a;
    if (modifiers.focused) (_a = ref.current) == null ? void 0 : _a.focus();
  }, [modifiers.focused]);
  return /* @__PURE__ */ jsx(
    Button$2,
    {
      ref,
      variant: "ghost",
      size: "icon",
      "data-day": day2.date.toLocaleDateString(),
      "data-selected-single": modifiers.selected && !modifiers.range_start && !modifiers.range_end && !modifiers.range_middle,
      "data-range-start": modifiers.range_start,
      "data-range-end": modifiers.range_end,
      "data-range-middle": modifiers.range_middle,
      className: clsx(styles$p.dayButton, defaultClassNames.day, className),
      ...props
    }
  );
}
const content$2 = "_content_q7qik_4 _root_1gk3t_3";
const styles$o = {
  content: content$2
};
function Popover$1({
  ...props
}) {
  return /* @__PURE__ */ jsx(Root2, { "data-slot": "popover", ...props });
}
function PopoverTrigger$1({
  ...props
}) {
  return /* @__PURE__ */ jsx(Trigger, { "data-slot": "popover-trigger", ...props });
}
function PopoverContent$1({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}) {
  return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(
    Content2,
    {
      "data-slot": "popover-content",
      align,
      sideOffset,
      className: clsx(styles$o.content, className),
      ...props
    }
  ) });
}
const trigger$3 = "_trigger_13qvz_11";
const triggerPlaceholder$1 = "_triggerPlaceholder_13qvz_46 _triggerText_13qvz_39";
const triggerIcon$3 = "_triggerIcon_13qvz_51";
const panel$2 = "_panel_13qvz_62";
const styles$n = {
  trigger: trigger$3,
  triggerPlaceholder: triggerPlaceholder$1,
  triggerIcon: triggerIcon$3,
  panel: panel$2
};
function DatePicker({
  value: value2,
  onChange,
  placeholder = "Pick a date",
  className,
  dateFormat = "PPP",
  min: min2,
  max: max2,
  align = "start",
  locale,
  disabled: disabled2 = false
}) {
  const [open2, setOpen] = React.useState(false);
  const resolvedLocale = locale ?? getPathDateLocale();
  const handleSelect = (date) => {
    onChange(date);
    setOpen(false);
  };
  return /* @__PURE__ */ jsxs(Popover$1, { open: open2 && !disabled2, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx(PopoverTrigger$1, { asChild: true, children: /* @__PURE__ */ jsxs(
      Button$2,
      {
        variant: "outline",
        disabled: disabled2,
        className: clsx(
          styles$n.trigger,
          !value2 && styles$n.triggerPlaceholder,
          className
        ),
        children: [
          /* @__PURE__ */ jsx(CalendarIcon, { className: styles$n.triggerIcon }),
          value2 ? format(value2, dateFormat, { locale: resolvedLocale }) : /* @__PURE__ */ jsx("span", { children: placeholder })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(PopoverContent$1, { className: styles$n.panel, align, children: /* @__PURE__ */ jsx(
      Calendar,
      {
        mode: "single",
        selected: value2,
        onSelect: handleSelect,
        locale: resolvedLocale,
        numberOfMonths: 1,
        disabled: [
          ...min2 ? [{ before: min2 }] : [],
          ...max2 ? [{ after: max2 }] : []
        ]
      }
    ) })
  ] });
}
const field$1 = "_field_kpfnv_4";
const styles$m = {
  field: field$1
};
function DateAnswer({
  value: value2,
  onChange,
  placeholder = "DD/MM/YY",
  dateFormat = "dd/MM/yy",
  align,
  disabled: disabled2 = false,
  className
}) {
  const parsed = value2 ? new Date(value2) : void 0;
  const dateValue = parsed && !Number.isNaN(parsed.getTime()) ? parsed : void 0;
  return /* @__PURE__ */ jsx("div", { className: styles$m.field, children: /* @__PURE__ */ jsx(
    DatePicker,
    {
      value: dateValue,
      onChange: (date) => onChange(date ? date.toISOString() : ""),
      placeholder,
      dateFormat,
      align,
      disabled: disabled2,
      className
    }
  ) });
}
const content$1 = "_content_lirus_3 _root_b93b7_3";
const styles$l = {
  content: content$1
};
const Popover = Root2;
const PopoverTrigger = Trigger;
const PopoverContent = forwardRef(
  ({ className, align = "start", sideOffset = 4, container: container2, ...props }, ref) => /* @__PURE__ */ jsx(Portal, { container: container2 ?? void 0, children: /* @__PURE__ */ jsx(
    Content2,
    {
      ref,
      align,
      sideOffset,
      className: `${styles$l.content}${className ? ` ${className}` : ""}`,
      ...props
    }
  ) })
);
PopoverContent.displayName = "PopoverContent";
const wrapper = "_wrapper_1icn4_3 _root_muxnn_4";
const wrapperSm = "_wrapperSm_1icn4_13";
const panel$1 = "_panel_1icn4_12 _root_muxnn_4";
const panelSm = "_panelSm_1icn4_18";
const trigger$2 = "_trigger_1icn4_26";
const triggerOpen = "_triggerOpen_1icn4_50";
const triggerBody = "_triggerBody_1icn4_72";
const triggerIcon$2 = "_triggerIcon_1icn4_80";
const triggerText = "_triggerText_1icn4_91";
const triggerLabel = "_triggerLabel_1icn4_99";
const triggerValue = "_triggerValue_1icn4_104";
const triggerPlaceholder = "_triggerPlaceholder_1icn4_110";
const chevron = "_chevron_1icn4_121";
const chevronOpen = "_chevronOpen_1icn4_129 _chevron_1icn4_121";
const panelRadio = "_panelRadio_1icn4_155";
const search = "_search_1icn4_165";
const searchIcon = "_searchIcon_1icn4_185";
const searchInput$1 = "_searchInput_1icn4_192";
const optionsList = "_optionsList_1icn4_212";
const optionsListRadio = "_optionsListRadio_1icn4_227";
const groupHeader = "_groupHeader_1icn4_251";
const option = "_option_1icn4_212";
const optionSelected = "_optionSelected_1icn4_301";
const optionRadio = "_optionRadio_1icn4_306";
const radio = "_radio_1icn4_319";
const radioChecked = "_radioChecked_1icn4_332";
const optionDisabled = "_optionDisabled_1icn4_344";
const optionIcon = "_optionIcon_1icn4_354";
const optionText = "_optionText_1icn4_365";
const styles$k = {
  wrapper,
  wrapperSm,
  panel: panel$1,
  panelSm,
  trigger: trigger$2,
  triggerOpen,
  triggerBody,
  triggerIcon: triggerIcon$2,
  triggerText,
  triggerLabel,
  triggerValue,
  triggerPlaceholder,
  chevron,
  chevronOpen,
  panelRadio,
  search,
  searchIcon,
  searchInput: searchInput$1,
  optionsList,
  optionsListRadio,
  groupHeader,
  option,
  optionSelected,
  optionRadio,
  radio,
  radioChecked,
  optionDisabled,
  optionIcon,
  optionText
};
function Select({
  value: value2,
  onChange,
  options,
  label: label2,
  placeholder = "Select...",
  searchPlaceholder = "Search...",
  showSelectedValue = true,
  enableSearch = false,
  indicator: indicator2 = "none",
  size: size2 = "md",
  disabled: disabled2 = false,
  leftIcon,
  zIndex,
  id,
  className,
  panelClassName,
  triggerTextStyle,
  optionTextStyle
}) {
  const [open2, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const triggerRef = useRef(null);
  const [container2, setContainer] = useState(null);
  const handleOpenChange = (next) => {
    var _a;
    if (next)
      setContainer(
        ((_a = triggerRef.current) == null ? void 0 : _a.closest('[role="dialog"]')) ?? null
      );
    setOpen(next);
    if (!next) setSearchText("");
  };
  const selectedOption = useMemo(
    () => options.find((option2) => option2.value === value2),
    [options, value2]
  );
  const filteredOptions = useMemo(() => {
    if (!searchText) return options;
    const lower = searchText.toLowerCase();
    return options.filter(
      (option2) => option2.label.toLowerCase().includes(lower) || option2.value.toLowerCase().includes(lower)
    );
  }, [options, searchText]);
  const optionGroups = useMemo(() => {
    const order = [];
    const byGroup = /* @__PURE__ */ new Map();
    for (const option2 of filteredOptions) {
      const group2 = option2.group ?? null;
      const bucket = byGroup.get(group2);
      if (bucket) {
        bucket.push(option2);
      } else {
        byGroup.set(group2, [option2]);
        order.push(group2);
      }
    }
    return order.map((group2) => ({
      group: group2,
      options: byGroup.get(group2)
    }));
  }, [filteredOptions]);
  const reserveOptionIconSlot = useMemo(
    () => options.some((option2) => option2.icon != null),
    [options]
  );
  const hasValue = selectedOption != null;
  const triggerIcon2 = (selectedOption == null ? void 0 : selectedOption.icon) ?? leftIcon ?? null;
  const triggerClass = [styles$k.trigger, open2 ? styles$k.triggerOpen : null].filter(Boolean).join(" ");
  const wrapperClass = [
    styles$k.wrapper,
    size2 === "sm" ? styles$k.wrapperSm : null,
    className
  ].filter(Boolean).join(" ");
  const radio2 = indicator2 === "radio";
  const panelClass = [
    styles$k.panel,
    size2 === "sm" ? styles$k.panelSm : null,
    radio2 ? styles$k.panelRadio : null,
    panelClassName
  ].filter(Boolean).join(" ");
  const handleSelect = (next) => {
    onChange(next);
    setOpen(false);
  };
  return /* @__PURE__ */ jsx("div", { className: wrapperClass, children: /* @__PURE__ */ jsxs(Popover, { open: open2, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
      "button",
      {
        ref: triggerRef,
        id,
        type: "button",
        className: triggerClass,
        disabled: disabled2,
        children: [
          /* @__PURE__ */ jsxs("span", { className: styles$k.triggerBody, children: [
            triggerIcon2 && /* @__PURE__ */ jsx("span", { className: styles$k.triggerIcon, children: triggerIcon2 }),
            /* @__PURE__ */ jsxs("span", { className: styles$k.triggerText, children: [
              label2 && /* @__PURE__ */ jsxs(
                "span",
                {
                  className: styles$k.triggerLabel,
                  style: triggerTextStyle,
                  children: [
                    label2,
                    showSelectedValue && ":"
                  ]
                }
              ),
              hasValue && showSelectedValue ? /* @__PURE__ */ jsx(
                "span",
                {
                  className: styles$k.triggerValue,
                  style: triggerTextStyle,
                  children: selectedOption.label
                }
              ) : !hasValue && /* @__PURE__ */ jsx(
                "span",
                {
                  className: styles$k.triggerPlaceholder,
                  style: triggerTextStyle,
                  children: placeholder
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            DropdownIcon,
            {
              className: open2 ? styles$k.chevronOpen : styles$k.chevron
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(
      PopoverContent,
      {
        className: panelClass,
        container: container2,
        style: zIndex != null ? { zIndex } : void 0,
        children: [
          enableSearch && /* @__PURE__ */ jsxs("div", { className: styles$k.search, children: [
            /* @__PURE__ */ jsx(SearchIcon, { className: styles$k.searchIcon }),
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "text",
                value: searchText,
                onChange: (e) => setSearchText(e.target.value),
                placeholder: searchPlaceholder,
                className: styles$k.searchInput
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: `${styles$k.optionsList} ${radio2 ? styles$k.optionsListRadio : ""}`,
              role: radio2 ? "radiogroup" : void 0,
              "aria-label": radio2 ? label2 : void 0,
              children: optionGroups.map(({ group: group2, options: groupOptions }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
                group2 != null && /* @__PURE__ */ jsx("div", { className: styles$k.groupHeader, children: group2 }),
                groupOptions.map((option2) => {
                  const isSelected = option2.value === value2;
                  const optionClass = [
                    styles$k.option,
                    radio2 ? styles$k.optionRadio : null,
                    // The radio itself carries the selected state, so the row
                    // keeps the plain surface the design asks for.
                    isSelected && !radio2 ? styles$k.optionSelected : null,
                    option2.disabled ? styles$k.optionDisabled : null
                  ].filter(Boolean).join(" ");
                  return /* @__PURE__ */ jsxs(
                    "button",
                    {
                      type: "button",
                      className: optionClass,
                      disabled: option2.disabled,
                      role: radio2 ? "radio" : void 0,
                      "aria-checked": radio2 ? isSelected : void 0,
                      onClick: () => handleSelect(option2.value),
                      children: [
                        radio2 && /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: `${styles$k.radio} ${isSelected ? styles$k.radioChecked : ""}`,
                            "aria-hidden": "true"
                          }
                        ),
                        reserveOptionIconSlot && /* @__PURE__ */ jsx("span", { className: styles$k.optionIcon, children: option2.icon ?? null }),
                        /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: styles$k.optionText,
                            style: optionTextStyle,
                            children: option2.label
                          }
                        )
                      ]
                    },
                    option2.value
                  );
                })
              ] }, group2 ?? " ungrouped"))
            }
          )
        ]
      }
    )
  ] }) });
}
const root = "_root_1a8go_8";
const panel = "_panel_1a8go_17";
const styles$j = {
  root,
  panel
};
function PartAnswer({
  value: value2,
  onChange,
  parts: parts2,
  placeholder,
  searchPlaceholder,
  disabled: disabled2 = false,
  className
}) {
  const options = parts2.map((part2) => ({
    value: String(part2.id),
    label: `${part2.name} - ${part2.code}`
  }));
  return /* @__PURE__ */ jsx(
    Select,
    {
      value: value2,
      onChange,
      options,
      placeholder,
      searchPlaceholder,
      enableSearch: true,
      disabled: disabled2,
      className: [styles$j.root, className].filter(Boolean).join(" "),
      panelClassName: styles$j.panel
    }
  );
}
const primary = "_primary_hnhx8_42 _base_hnhx8_3 _root_1e0q4_3";
const secondary = "_secondary_hnhx8_68 _base_hnhx8_3 _root_1e0q4_3";
const tertiary = "_tertiary_hnhx8_94 _base_hnhx8_3 _root_1e0q4_3";
const sm = "_sm_hnhx8_123";
const md = "_md_hnhx8_131";
const lg = "_lg_hnhx8_139";
const danger = "_danger_hnhx8_147 _base_hnhx8_3 _root_1e0q4_3";
const ghost = "_ghost_hnhx8_172 _base_hnhx8_3 _root_1e0q4_3";
const brand$1 = "_brand_hnhx8_192";
const iconOnly = "_iconOnly_hnhx8_226";
const icon$2 = "_icon_hnhx8_226";
const styles$i = {
  primary,
  secondary,
  tertiary,
  sm,
  md,
  lg,
  danger,
  ghost,
  brand: brand$1,
  iconOnly,
  icon: icon$2
};
const variantClass = {
  primary: styles$i.primary,
  secondary: styles$i.secondary,
  tertiary: styles$i.tertiary,
  ghost: styles$i.ghost,
  danger: styles$i.danger
};
const sizeClass = {
  sm: styles$i.sm,
  md: styles$i.md,
  lg: styles$i.lg
};
const toneClass = {
  default: null,
  brand: styles$i.brand
};
const Button = forwardRef(
  function Button22({
    variant = "primary",
    size: size2 = "md",
    tone = "default",
    icon: icon2,
    children,
    className,
    type = "button",
    asChild = false,
    ...rest
  }, ref) {
    const isIconOnly = icon2 != null && (children == null || children === false);
    const classes = [
      variantClass[variant],
      sizeClass[size2],
      toneClass[tone],
      isIconOnly ? styles$i.iconOnly : null,
      className
    ].filter(Boolean).join(" ");
    if (asChild) {
      return /* @__PURE__ */ jsx(Slot$1, { ref, className: classes, ...rest, children });
    }
    return /* @__PURE__ */ jsxs("button", { ref, className: classes, type, ...rest, children: [
      icon2 && /* @__PURE__ */ jsx("span", { className: styles$i.icon, children: icon2 }),
      !isIconOnly && children
    ] });
  }
);
const trigger$1 = "_trigger_1c20f_7";
const modal$3 = "_modal_1c20f_18";
const dialog = "_dialog_1c20f_23 _root_z4sht_3";
const title$2 = "_title_1c20f_33";
const instruction = "_instruction_1c20f_40";
const searchArea = "_searchArea_1c20f_47";
const searchInput = "_searchInput_1c20f_57";
const error$1 = "_error_1c20f_61";
const actions$1 = "_actions_1c20f_66";
const styles$h = {
  trigger: trigger$1,
  modal: modal$3,
  dialog,
  title: title$2,
  instruction,
  searchArea,
  searchInput,
  error: error$1,
  actions: actions$1
};
function findByCode(orders, code) {
  const needle = code.trim().toLowerCase();
  return orders.find((order) => order.code.trim().toLowerCase() === needle);
}
function OrderSearchDialog({
  orders,
  onConfirm,
  close,
  title: title2,
  instruction: instruction2,
  searchPlaceholder,
  errorLabel,
  cancelLabel,
  addLabel
}) {
  const [text2, setText] = useState("");
  const matched = text2.trim() ? findByCode(orders, text2) : void 0;
  const showError = text2.trim() !== "" && !matched;
  return /* @__PURE__ */ jsxs("div", { className: styles$h.dialog, children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h2", { className: styles$h.title, children: title2 }),
      instruction2 && /* @__PURE__ */ jsx("label", { className: styles$h.instruction, children: instruction2 })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$h.searchArea, children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        SearchInput,
        {
          value: text2,
          onChange: setText,
          placeholder: searchPlaceholder,
          className: styles$h.searchInput
        }
      ) }),
      showError && /* @__PURE__ */ jsx("span", { className: styles$h.error, children: errorLabel })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$h.actions, children: [
      /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "md", onClick: close, children: cancelLabel }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: "md",
          disabled: !matched,
          onClick: () => {
            if (matched) {
              onConfirm(matched);
              close();
            }
          },
          children: addLabel
        }
      )
    ] })
  ] });
}
function OrderAnswer({
  value: value2,
  onChange,
  orders,
  orderCode: orderCode2,
  disabled: disabled2 = false,
  className,
  triggerPlaceholder: triggerPlaceholder2 = "Select order",
  title: title2 = "Search order",
  instruction: instruction2 = "Type or scan the order code",
  searchPlaceholder,
  errorLabel = "Order not found",
  cancelLabel = "Cancel",
  addLabel = "Add"
}) {
  const [open2, setOpen] = useState(false);
  const codeById = useMemo(
    () => new Map(orders.map((order) => [String(order.id), order.code])),
    [orders]
  );
  const resolvedCode = codeById.get(value2) ?? orderCode2 ?? "";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "md",
        disabled: disabled2,
        onClick: () => setOpen(true),
        className: [styles$h.trigger, className].filter(Boolean).join(" "),
        children: resolvedCode || triggerPlaceholder2
      }
    ),
    open2 && /* @__PURE__ */ jsx(
      Modal,
      {
        onClose: () => setOpen(false),
        className: styles$h.modal,
        ariaLabel: title2,
        children: (close) => /* @__PURE__ */ jsx(
          OrderSearchDialog,
          {
            orders,
            onConfirm: (order) => onChange(String(order.id)),
            close,
            title: title2,
            instruction: instruction2,
            searchPlaceholder,
            errorLabel,
            cancelLabel,
            addLabel
          }
        )
      }
    )
  ] });
}
const preview$1 = "_preview_1nif1_4";
const image$2 = "_image_1nif1_9";
const contentImage = "_contentImage_1nif1_19";
const triggerIcon$1 = "_triggerIcon_1nif1_26";
const importIcon$1 = "_importIcon_1nif1_31";
const remove$2 = "_remove_1nif1_37";
const removeIcon$2 = "_removeIcon_1nif1_64";
const modal$2 = "_modal_1nif1_70";
const camera = "_camera_1nif1_75";
const video = "_video_1nif1_83";
const snapshot$1 = "_snapshot_1nif1_84";
const cameraError = "_cameraError_1nif1_98";
const header$3 = "_header_1nif1_108";
const back$1 = "_back_1nif1_116";
const backIcon$1 = "_backIcon_1nif1_134";
const headerActions = "_headerActions_1nif1_140";
const bottomActions$1 = "_bottomActions_1nif1_148";
const halfButton$1 = "_halfButton_1nif1_153";
const styles$g = {
  preview: preview$1,
  image: image$2,
  contentImage,
  triggerIcon: triggerIcon$1,
  importIcon: importIcon$1,
  remove: remove$2,
  removeIcon: removeIcon$2,
  modal: modal$2,
  camera,
  video,
  snapshot: snapshot$1,
  cameraError,
  header: header$3,
  back: back$1,
  backIcon: backIcon$1,
  headerActions,
  bottomActions: bottomActions$1,
  halfButton: halfButton$1
};
function CameraCapture({
  onConfirm,
  close,
  labels
}) {
  const videoRef = useRef(null);
  const fileRef = useRef(null);
  const streamRef = useRef(null);
  const [facing, setFacing] = useState("environment");
  const [snapshot2, setSnapshot] = useState(null);
  const [error2, setError] = useState(false);
  useEffect(() => {
    if (snapshot2) return;
    let active2 = true;
    const start = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: facing },
          audio: false
        });
        if (!active2) {
          stream.getTracks().forEach((track2) => track2.stop());
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
      } catch {
        setError(true);
      }
    };
    start();
    return () => {
      var _a;
      active2 = false;
      (_a = streamRef.current) == null ? void 0 : _a.getTracks().forEach((track2) => track2.stop());
      streamRef.current = null;
    };
  }, [facing, snapshot2]);
  const takePhoto = () => {
    var _a;
    const video2 = videoRef.current;
    if (!video2 || !video2.videoWidth) return;
    const canvas2 = document.createElement("canvas");
    canvas2.width = video2.videoWidth;
    canvas2.height = video2.videoHeight;
    (_a = canvas2.getContext("2d")) == null ? void 0 : _a.drawImage(video2, 0, 0);
    setSnapshot(canvas2.toDataURL("image/jpeg", 0.9));
  };
  const handleFile = (event) => {
    var _a;
    const file = (_a = event.target.files) == null ? void 0 : _a[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => typeof reader.result === "string" && setSnapshot(reader.result);
    reader.readAsDataURL(file);
    event.target.value = "";
  };
  return /* @__PURE__ */ jsxs("div", { className: styles$g.camera, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$g.header, children: [
      /* @__PURE__ */ jsxs("button", { type: "button", className: styles$g.back, onClick: close, children: [
        /* @__PURE__ */ jsx(ChevronLeft, { className: styles$g.backIcon, "aria-hidden": true }),
        labels.backLabel
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles$g.headerActions, children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: fileRef,
            type: "file",
            accept: "image/*",
            capture: "environment",
            hidden: true,
            onChange: handleFile
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "secondary",
            size: "md",
            icon: /* @__PURE__ */ jsx(
              CaptureImportFileIcon,
              {
                className: styles$g.importIcon,
                "aria-hidden": true
              }
            ),
            disabled: !!snapshot2,
            onClick: () => {
              var _a;
              return (_a = fileRef.current) == null ? void 0 : _a.click();
            },
            children: labels.chooseFileLabel
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "secondary",
            size: "md",
            icon: /* @__PURE__ */ jsx(SwitchCamera, { size: 16, "aria-hidden": true }),
            disabled: !!snapshot2 || error2,
            onClick: () => setFacing((f) => f === "environment" ? "user" : "environment"),
            children: labels.flipLabel
          }
        )
      ] })
    ] }),
    snapshot2 ? /* @__PURE__ */ jsx("img", { className: styles$g.snapshot, src: snapshot2, alt: "" }) : error2 ? /* @__PURE__ */ jsx("p", { className: styles$g.cameraError, children: labels.cameraErrorLabel }) : /* @__PURE__ */ jsx(
      "video",
      {
        ref: videoRef,
        className: styles$g.video,
        autoPlay: true,
        muted: true,
        playsInline: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: styles$g.bottomActions, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "md",
          className: styles$g.halfButton,
          icon: /* @__PURE__ */ jsx(X, { size: 16, "aria-hidden": true }),
          disabled: !snapshot2,
          onClick: () => setSnapshot(null),
          children: labels.deleteLabel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: "md",
          className: styles$g.halfButton,
          icon: snapshot2 ? /* @__PURE__ */ jsx(Check, { size: 16, "aria-hidden": true }) : /* @__PURE__ */ jsx(Camera, { size: 16, "aria-hidden": true }),
          disabled: !snapshot2 && error2,
          onClick: () => {
            if (snapshot2) {
              onConfirm(snapshot2);
              close();
            } else {
              takePhoto();
            }
          },
          children: snapshot2 ? labels.confirmLabel : labels.takePhotoLabel
        }
      )
    ] })
  ] });
}
function ImageAnswer({
  value: value2,
  onChange,
  addLabel = "Add photo",
  removeLabel = "Remove photo",
  backLabel = "Back",
  chooseFileLabel = "Explore files",
  flipLabel = "Flip camera",
  takePhotoLabel = "Capture",
  deleteLabel = "Delete",
  confirmLabel = "Continue",
  cameraErrorLabel = "Could not access the camera",
  disabled: disabled2 = false,
  className
}) {
  const [open2, setOpen] = useState(false);
  const handleConfirm = (next) => {
    onChange(next);
    setOpen(false);
  };
  if (value2) {
    return /* @__PURE__ */ jsxs("div", { className: [styles$g.preview, className].filter(Boolean).join(" "), children: [
      /* @__PURE__ */ jsx("img", { className: styles$g.image, src: value2, alt: "" }),
      !disabled2 && /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: styles$g.remove,
          onClick: () => onChange(""),
          "aria-label": removeLabel,
          children: /* @__PURE__ */ jsx(X, { className: styles$g.removeIcon, "aria-hidden": true })
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: [styles$g.contentImage, className].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "md",
        icon: /* @__PURE__ */ jsx(Camera, { size: 16, className: styles$g.triggerIcon, "aria-hidden": true }),
        disabled: disabled2,
        onClick: () => setOpen(true),
        children: addLabel
      }
    ),
    open2 && /* @__PURE__ */ jsx(
      Modal,
      {
        onClose: () => setOpen(false),
        className: styles$g.modal,
        ariaLabel: addLabel,
        children: (close) => /* @__PURE__ */ jsx(
          CameraCapture,
          {
            onConfirm: handleConfirm,
            close,
            labels: {
              backLabel,
              chooseFileLabel,
              flipLabel,
              takePhotoLabel,
              deleteLabel,
              confirmLabel,
              cameraErrorLabel
            }
          }
        )
      }
    )
  ] });
}
const wrap$1 = "_wrap_12f4y_4";
const triggerIcon = "_triggerIcon_12f4y_10";
const importIcon = "_importIcon_12f4y_15";
const modal$1 = "_modal_12f4y_20";
const pad = "_pad_12f4y_26";
const canvasBox = "_canvasBox_12f4y_34";
const canvas = "_canvas_12f4y_34";
const snapshot = "_snapshot_12f4y_52";
const hint = "_hint_12f4y_64";
const header$2 = "_header_12f4y_75";
const back = "_back_12f4y_83";
const backIcon = "_backIcon_12f4y_101";
const bottomActions = "_bottomActions_12f4y_108";
const halfButton = "_halfButton_12f4y_113";
const preview = "_preview_12f4y_118";
const image$1 = "_image_12f4y_123";
const remove$1 = "_remove_12f4y_135";
const removeIcon$1 = "_removeIcon_12f4y_157";
const styles$f = {
  wrap: wrap$1,
  triggerIcon,
  importIcon,
  modal: modal$1,
  pad,
  canvasBox,
  canvas,
  snapshot,
  hint,
  header: header$2,
  back,
  backIcon,
  bottomActions,
  halfButton,
  preview,
  image: image$1,
  remove: remove$1,
  removeIcon: removeIcon$1
};
function SignaturePad({
  hint: hint2,
  backLabel,
  importLabel,
  deleteLabel,
  confirmLabel,
  onConfirm,
  close
}) {
  const canvasRef = useRef(null);
  const fileRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [hasDrawn, setHasDrawn] = useState(false);
  const [imported, setImported] = useState(null);
  const hasContent = hasDrawn || imported != null;
  const toPoint = (event) => {
    const canvas2 = canvasRef.current;
    if (!canvas2) return { x: 0, y: 0 };
    const rect = canvas2.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) * (canvas2.width / rect.width),
      y: (event.clientY - rect.top) * (canvas2.height / rect.height)
    };
  };
  const handleDown = (event) => {
    var _a;
    drawing.current = true;
    last.current = toPoint(event);
    (_a = canvasRef.current) == null ? void 0 : _a.setPointerCapture(event.pointerId);
  };
  const handleMove = (event) => {
    var _a;
    if (!drawing.current || !last.current) return;
    const ctx = (_a = canvasRef.current) == null ? void 0 : _a.getContext("2d");
    if (!ctx) return;
    const point = toPoint(event);
    ctx.strokeStyle = "#333d5f";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();
    last.current = point;
    setHasDrawn(true);
  };
  const handleUp = () => {
    drawing.current = false;
    last.current = null;
  };
  const handleFile = (event) => {
    var _a;
    const file = (_a = event.target.files) == null ? void 0 : _a[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => typeof reader.result === "string" && setImported(reader.result);
    reader.readAsDataURL(file);
    event.target.value = "";
  };
  const clearAll = () => {
    var _a;
    const canvas2 = canvasRef.current;
    (_a = canvas2 == null ? void 0 : canvas2.getContext("2d")) == null ? void 0 : _a.clearRect(0, 0, canvas2.width, canvas2.height);
    setHasDrawn(false);
    setImported(null);
  };
  const confirm = () => {
    if (imported) {
      onConfirm(imported);
      close();
      return;
    }
    const canvas2 = canvasRef.current;
    if (canvas2 && hasDrawn) onConfirm(canvas2.toDataURL("image/png"));
    close();
  };
  return /* @__PURE__ */ jsxs("div", { className: styles$f.pad, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$f.header, children: [
      /* @__PURE__ */ jsxs("button", { type: "button", className: styles$f.back, onClick: close, children: [
        /* @__PURE__ */ jsx(ChevronLeft, { className: styles$f.backIcon, "aria-hidden": true }),
        backLabel
      ] }),
      /* @__PURE__ */ jsx(
        "input",
        {
          ref: fileRef,
          type: "file",
          accept: "image/*",
          hidden: true,
          onChange: handleFile
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "md",
          icon: /* @__PURE__ */ jsx(CaptureImportFileIcon, { className: styles$f.importIcon, "aria-hidden": true }),
          disabled: hasContent,
          onClick: () => {
            var _a;
            return (_a = fileRef.current) == null ? void 0 : _a.click();
          },
          children: importLabel
        }
      )
    ] }),
    imported ? /* @__PURE__ */ jsx("img", { className: styles$f.snapshot, src: imported, alt: "" }) : /* @__PURE__ */ jsxs("div", { className: styles$f.canvasBox, children: [
      !hasDrawn && /* @__PURE__ */ jsx("span", { className: styles$f.hint, children: hint2 }),
      /* @__PURE__ */ jsx(
        "canvas",
        {
          ref: canvasRef,
          width: 640,
          height: 320,
          className: styles$f.canvas,
          onPointerDown: handleDown,
          onPointerMove: handleMove,
          onPointerUp: handleUp,
          onPointerLeave: handleUp
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$f.bottomActions, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "md",
          className: styles$f.halfButton,
          icon: /* @__PURE__ */ jsx(X, { size: 16, "aria-hidden": true }),
          disabled: !hasContent,
          onClick: clearAll,
          children: deleteLabel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: "md",
          className: styles$f.halfButton,
          icon: /* @__PURE__ */ jsx(Check, { size: 16, "aria-hidden": true }),
          disabled: !hasContent,
          onClick: confirm,
          children: confirmLabel
        }
      )
    ] })
  ] });
}
function SignatureAnswer({
  value: value2,
  onChange,
  addLabel = "Add signature",
  removeLabel = "Remove",
  backLabel = "Back",
  importLabel = "Import signature",
  hint: hint2 = "Sign here",
  deleteLabel = "Delete",
  confirmLabel = "Continue",
  disabled: disabled2 = false,
  className
}) {
  const [open2, setOpen] = useState(false);
  const handleConfirm = (next) => {
    onChange(next);
    setOpen(false);
  };
  if (value2) {
    return /* @__PURE__ */ jsxs("div", { className: [styles$f.preview, className].filter(Boolean).join(" "), children: [
      /* @__PURE__ */ jsx("img", { className: styles$f.image, src: value2, alt: hint2 }),
      !disabled2 && /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: styles$f.remove,
          onClick: () => onChange(""),
          "aria-label": removeLabel,
          children: /* @__PURE__ */ jsx(X, { className: styles$f.removeIcon, "aria-hidden": true })
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: [styles$f.wrap, className].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "md",
        icon: /* @__PURE__ */ jsx(Pencil, { size: 16, className: styles$f.triggerIcon, "aria-hidden": true }),
        disabled: disabled2,
        onClick: () => setOpen(true),
        children: addLabel
      }
    ),
    open2 && /* @__PURE__ */ jsx(
      Modal,
      {
        onClose: () => setOpen(false),
        className: styles$f.modal,
        ariaLabel: addLabel,
        children: (close) => /* @__PURE__ */ jsx(
          SignaturePad,
          {
            hint: hint2,
            backLabel,
            importLabel,
            deleteLabel,
            confirmLabel,
            onConfirm: handleConfirm,
            close
          }
        )
      }
    )
  ] });
}
const trigger = "_trigger_y7fbb_7";
const modal = "_modal_y7fbb_12";
const body = "_body_y7fbb_17";
const header$1 = "_header_y7fbb_55";
const title$1 = "_title_y7fbb_61";
const subtitle = "_subtitle_y7fbb_68";
const table$2 = "_table_y7fbb_75";
const totalsRow = "_totalsRow_y7fbb_87";
const defectRow = "_defectRow_y7fbb_88";
const defectRowReadOnly = "_defectRowReadOnly_y7fbb_114";
const name$2 = "_name_y7fbb_118";
const qtyInput = "_qtyInput_y7fbb_126";
const readonlyBox = "_readonlyBox_y7fbb_136";
const pctBox = "_pctBox_y7fbb_137";
const addRow = "_addRow_y7fbb_147";
const addIcon = "_addIcon_y7fbb_162";
const defectRows = "_defectRows_y7fbb_167";
const remove = "_remove_y7fbb_175";
const removeIcon = "_removeIcon_y7fbb_194";
const defectSelect = "_defectSelect_y7fbb_199";
const defectSelectPanel = "_defectSelectPanel_y7fbb_205";
const actions = "_actions_y7fbb_210";
const cancelBtn = "_cancelBtn_y7fbb_217";
const saveBtn = "_saveBtn_y7fbb_218";
const styles$e = {
  trigger,
  modal,
  body,
  header: header$1,
  title: title$1,
  subtitle,
  table: table$2,
  totalsRow,
  defectRow,
  defectRowReadOnly,
  name: name$2,
  qtyInput,
  readonlyBox,
  pctBox,
  addRow,
  addIcon,
  defectRows,
  remove,
  removeIcon,
  defectSelect,
  defectSelectPanel,
  actions,
  cancelBtn,
  saveBtn
};
function percent(count2, sample) {
  if (!sample) return "0.00";
  return (count2 / sample * 100).toFixed(2);
}
function DefectEditor({
  defectOptions,
  initialSampleTotal,
  initialDefects,
  labels,
  readOnly,
  onCancel,
  onSave
}) {
  const keyRef = useRef(0);
  const [sampleTotal, setSampleTotal] = useState(initialSampleTotal);
  const [rows, setRows] = useState(
    () => initialDefects.map((defect2) => ({
      key: String(keyRef.current++),
      id: defect2.id,
      value: defect2.value
    }))
  );
  const total2 = Number(sampleTotal) || 0;
  const sum = rows.reduce((acc, row2) => acc + (Number(row2.value) || 0), 0);
  const options = defectOptions.map((defect2) => ({
    value: String(defect2.id),
    label: defect2.name
  }));
  const addRow2 = () => setRows((prev) => [
    ...prev,
    { key: String(keyRef.current++), id: null, value: "0" }
  ]);
  const removeRow = (key) => setRows((prev) => prev.filter((row2) => row2.key !== key));
  const patchRow = (key, patch) => setRows(
    (prev) => prev.map((row2) => row2.key === key ? { ...row2, ...patch } : row2)
  );
  return /* @__PURE__ */ jsxs("div", { className: styles$e.body, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$e.header, children: [
      /* @__PURE__ */ jsx("h2", { className: styles$e.title, children: labels.title }),
      /* @__PURE__ */ jsx("p", { className: styles$e.subtitle, children: labels.editorHint })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$e.table, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$e.totalsRow, children: [
        /* @__PURE__ */ jsx("span", { className: styles$e.name, children: labels.sampleTotal }),
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "number",
            min: 0,
            value: sampleTotal,
            onChange: setSampleTotal,
            disabled: readOnly,
            className: styles$e.qtyInput
          }
        ),
        /* @__PURE__ */ jsx("span", { className: styles$e.pctBox, children: "100%" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles$e.totalsRow, children: [
        /* @__PURE__ */ jsx("span", { className: styles$e.name, children: labels.calculatedTotal }),
        /* @__PURE__ */ jsx("span", { className: styles$e.readonlyBox, children: sum }),
        /* @__PURE__ */ jsxs("span", { className: styles$e.pctBox, children: [
          percent(sum, total2),
          "%"
        ] })
      ] }),
      !readOnly && /* @__PURE__ */ jsxs("button", { type: "button", className: styles$e.addRow, onClick: addRow2, children: [
        /* @__PURE__ */ jsx(Plus, { className: styles$e.addIcon, "aria-hidden": true }),
        labels.addDefect
      ] }),
      /* @__PURE__ */ jsx("div", { className: styles$e.defectRows, children: rows.map((row2) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${styles$e.defectRow} ${readOnly ? styles$e.defectRowReadOnly : ""}`.trim(),
          children: [
            !readOnly && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: styles$e.remove,
                onClick: () => removeRow(row2.key),
                "aria-label": labels.removeDefect,
                children: /* @__PURE__ */ jsx(Trash2, { className: styles$e.removeIcon, "aria-hidden": true })
              }
            ),
            /* @__PURE__ */ jsx(
              Select,
              {
                value: row2.id != null ? String(row2.id) : "",
                onChange: (id) => patchRow(row2.key, { id: Number(id) }),
                options,
                placeholder: labels.searchDefect,
                enableSearch: true,
                disabled: readOnly,
                className: styles$e.defectSelect,
                panelClassName: styles$e.defectSelectPanel,
                size: "sm"
              }
            ),
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "number",
                min: 0,
                value: row2.value,
                onChange: (value2) => patchRow(row2.key, { value: value2 }),
                disabled: readOnly,
                className: styles$e.qtyInput
              }
            ),
            /* @__PURE__ */ jsxs("span", { className: styles$e.pctBox, children: [
              percent(Number(row2.value) || 0, total2),
              "%"
            ] })
          ]
        },
        row2.key
      )) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$e.actions, children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "md",
          className: styles$e.cancelBtn,
          onClick: onCancel,
          children: readOnly ? labels.close : labels.cancel
        }
      ),
      !readOnly && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: "md",
          className: styles$e.saveBtn,
          onClick: () => onSave(
            sampleTotal,
            rows.map((row2) => ({ id: row2.id, value: row2.value }))
          ),
          children: labels.save
        }
      )
    ] })
  ] });
}
const DEFAULT_LABELS = {
  enter: "Enter defects",
  title: "Quality percentage",
  editorHint: "Enter the sample total and the defects found.",
  sampleTotal: "Sample total",
  calculatedTotal: "Calculated total",
  addDefect: "Add defect",
  removeDefect: "Remove defect",
  searchDefect: "Search defect",
  cancel: "Cancel",
  save: "Save",
  close: "Close"
};
function DefectAnswer({
  sampleTotal,
  defects,
  onChange,
  defectOptions,
  disabled: disabled2 = false,
  className,
  labels
}) {
  const [open2, setOpen] = useState(false);
  const merged = { ...DEFAULT_LABELS, ...labels };
  const total2 = Number(sampleTotal) || 0;
  const sum = defects.reduce((acc, d) => acc + (Number(d.value) || 0), 0);
  const triggerLabel2 = !disabled2 && sampleTotal.trim() === "" ? merged.enter : `${percent(sum, total2)}%`;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "md",
        onClick: () => setOpen(true),
        className: [styles$e.trigger, className].filter(Boolean).join(" "),
        children: triggerLabel2
      }
    ),
    open2 && /* @__PURE__ */ jsx(
      Modal,
      {
        onClose: () => setOpen(false),
        className: styles$e.modal,
        ariaLabel: merged.title,
        children: (close) => /* @__PURE__ */ jsx(
          DefectEditor,
          {
            defectOptions,
            initialSampleTotal: sampleTotal,
            initialDefects: defects,
            labels: merged,
            readOnly: disabled2,
            onCancel: close,
            onSave: (nextTotal, nextDefects) => {
              onChange({ sampleTotal: nextTotal, defects: nextDefects });
              close();
            }
          }
        )
      }
    )
  ] });
}
const card$2 = "_card_5jdn2_5 _root_7nwvh_3";
const requiredHint = "_requiredHint_5jdn2_38";
const row = "_row_5jdn2_44";
const question = "_question_5jdn2_51";
const dot = "_dot_5jdn2_59";
const answer = "_answer_5jdn2_64";
const commentArea = "_commentArea_5jdn2_77";
const divider = "_divider_5jdn2_82";
const commentToggle = "_commentToggle_5jdn2_90";
const commentIcon = "_commentIcon_5jdn2_109";
const range = "_range_5jdn2_116";
const commentFilled = "_commentFilled_5jdn2_132";
const styles$d = {
  card: card$2,
  requiredHint,
  row,
  question,
  dot,
  answer,
  commentArea,
  divider,
  commentToggle,
  commentIcon,
  range,
  commentFilled
};
function QuestionCard({
  question: question2,
  children,
  required: required2 = false,
  requiredLabel,
  range: range2,
  rangeLabel = "Preferred range",
  comment,
  onCommentChange,
  commentPlaceholder,
  commentToggleLabel = "Add comment",
  commentOpen,
  disabled: disabled2 = false,
  className
}) {
  const [showComment, setShowComment] = useState(
    commentOpen ?? Boolean(comment)
  );
  return /* @__PURE__ */ jsxs("div", { className: [styles$d.card, className].filter(Boolean).join(" "), children: [
    required2 && requiredLabel && /* @__PURE__ */ jsxs("div", { className: styles$d.requiredHint, children: [
      "* ",
      requiredLabel
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles$d.row, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$d.question, children: [
        question2,
        required2 && /* @__PURE__ */ jsx("span", { className: styles$d.dot, children: "*" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles$d.answer, children: [
        range2 && /* @__PURE__ */ jsxs("div", { className: styles$d.range, children: [
          rangeLabel,
          ": ",
          range2.lower,
          "-",
          range2.higher,
          range2.unit ? ` ${range2.unit}` : ""
        ] }),
        children
      ] }),
      onCommentChange && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: styles$d.divider, "aria-hidden": true }),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: styles$d.commentToggle,
            onClick: () => setShowComment((value2) => !value2),
            "aria-label": commentToggleLabel,
            "aria-pressed": showComment,
            children: /* @__PURE__ */ jsx(MessageSquare, { className: styles$d.commentIcon, "aria-hidden": true })
          }
        )
      ] })
    ] }),
    showComment && onCommentChange && /* @__PURE__ */ jsx(
      "div",
      {
        className: [styles$d.commentArea, comment ? styles$d.commentFilled : null].filter(Boolean).join(" "),
        children: /* @__PURE__ */ jsx(
          Textarea,
          {
            variant: "sunken",
            value: comment ?? "",
            onChange: onCommentChange,
            placeholder: commentPlaceholder,
            rows: 2,
            disabled: disabled2
          }
        )
      }
    )
  ] });
}
const mediaWidget = "_mediaWidget_12lbp_6 _root_j1dn3_3";
const content = "_content_12lbp_39";
const name$1 = "_name_12lbp_53";
const empty$2 = "_empty_12lbp_60";
const styles$c = {
  mediaWidget,
  content,
  name: name$1,
  empty: empty$2
};
function MediaWidget({
  name: name2,
  children,
  onExpand,
  emptyLabel = "No media",
  className
}) {
  const hasPreview = children != null && children !== false;
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: `${styles$c.mediaWidget} ${className ?? ""}`.trim(),
      onClick: onExpand,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles$c.content, children: hasPreview ? children : /* @__PURE__ */ jsx("span", { className: styles$c.empty, children: emptyLabel }) }),
        /* @__PURE__ */ jsx("span", { className: styles$c.name, children: name2 })
      ]
    }
  );
}
const zoomControls = "_zoomControls_1oaki_4 _root_149tz_4";
const styles$b = {
  zoomControls
};
const roundTo = (value2) => Math.round(value2 * 100) / 100;
function ZoomControls({
  value: value2,
  onChange,
  min: min2 = 0.5,
  max: max2 = 5,
  step = 0.5,
  zoomOutLabel = "Zoom out",
  zoomInLabel = "Zoom in",
  className
}) {
  const clamp2 = (next) => Math.min(max2, Math.max(min2, roundTo(next)));
  return /* @__PURE__ */ jsxs("div", { className: `${styles$b.zoomControls} ${className ?? ""}`.trim(), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "sm",
        icon: /* @__PURE__ */ jsx(ZoomOutIcon, {}),
        "aria-label": zoomOutLabel,
        disabled: value2 <= min2,
        onClick: () => onChange(clamp2(value2 - step))
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "tertiary",
        size: "sm",
        icon: /* @__PURE__ */ jsx(ZoomInIcon, {}),
        "aria-label": zoomInLabel,
        disabled: value2 >= max2,
        onClick: () => onChange(clamp2(value2 + step))
      }
    )
  ] });
}
const viewport = "_viewport_b52e6_5 _root_kzmes_3";
const image = "_image_b52e6_16";
const styles$a = {
  viewport,
  image
};
function ZoomableImage({
  src,
  alt = "",
  scale = 1,
  className
}) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const start = useRef({ x: 0, y: 0 });
  const onPointerDown = (event) => {
    setDragging(true);
    start.current = {
      x: event.clientX - position.x,
      y: event.clientY - position.y
    };
    event.currentTarget.setPointerCapture(event.pointerId);
  };
  const onPointerMove = (event) => {
    if (!dragging) return;
    setPosition({
      x: event.clientX - start.current.x,
      y: event.clientY - start.current.y
    });
  };
  const endDrag = (event) => {
    setDragging(false);
    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }
  };
  const imageStyle = {
    transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
    transformOrigin: "center",
    transition: dragging ? "none" : "transform 0.2s ease",
    cursor: dragging ? "grabbing" : "grab"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${styles$a.viewport} ${className ?? ""}`.trim(),
      onPointerDown,
      onPointerMove,
      onPointerUp: endDrag,
      onPointerLeave: endDrag,
      children: /* @__PURE__ */ jsx(
        "img",
        {
          className: styles$a.image,
          src,
          alt,
          draggable: false,
          style: imageStyle
        }
      )
    }
  );
}
const getNestedValue = (obj, path) => {
  if (!obj) return void 0;
  return path.split(".").reduce((acc, part2) => {
    if (acc === void 0 || acc === null) return void 0;
    if (typeof acc === "object" && acc !== null && part2 in acc) {
      return acc[part2];
    }
    return void 0;
  }, obj);
};
const DEFAULT_CONFIG = {
  defaultLanguage: "en",
  supportedLanguages: ["es", "en", "ro"]
};
const LOCALE_MAP = {
  es: "es-MX",
  en: "en-US",
  ro: "ro-RO"
};
function getCurrentLanguage(config2) {
  const segments = window.location.pathname.split("/");
  const candidate = segments[1];
  if (config2.supportedLanguages.includes(candidate)) return candidate;
  return config2.defaultLanguage;
}
function useLanguage(dicts, config2) {
  const mergedConfig = { ...DEFAULT_CONFIG, ...config2 };
  const currentLanguage = getCurrentLanguage(mergedConfig);
  const translations = dicts[currentLanguage];
  return useMemo(() => {
    const locale = LOCALE_MAP[currentLanguage];
    const numberFormatter = new Intl.NumberFormat(locale);
    const translate = (path, params) => {
      let value2 = getNestedValue(translations, path) ?? path;
      if (params) {
        for (const [key, val] of Object.entries(params)) {
          value2 = value2.replace(
            new RegExp(`\\{\\{${key}\\}\\}`, "g"),
            String(val)
          );
        }
      }
      return value2;
    };
    const alternativeLanguages = mergedConfig.supportedLanguages.filter(
      (l) => l !== currentLanguage
    );
    return {
      currentLanguage,
      locale,
      translations,
      alternativeLanguages,
      translate,
      formatNumber: (value2) => numberFormatter.format(value2)
    };
  }, [currentLanguage, translations, mergedConfig.supportedLanguages]);
}
const en$2 = {
  noPartSelected: "No part selected",
  createManufacturingOrders: "Create manufacturing orders"
};
const es$2 = {
  noPartSelected: "No hay parte seleccionada",
  createManufacturingOrders: "Crear órdenes de manufactura"
};
const ro$2 = {
  noPartSelected: "Nu există referintă selectată",
  createManufacturingOrders: "Creați comenzi de fabricație"
};
const workstationActivePartsI18n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  en: en$2,
  es: es$2,
  ro: ro$2
}, Symbol.toStringTag, { value: "Module" }));
const itemsWorked = "_itemsWorked_1gira_3";
const orderCode = "_orderCode_1gira_24";
const styles$9 = {
  itemsWorked,
  orderCode
};
function WorkstationActiveParts({
  parts: parts2,
  orders,
  services,
  type = "main",
  className
}) {
  const { translations: t } = useLanguage(
    workstationActivePartsI18n
  );
  const part2 = useMemo(
    () => pickActiveItem({ items: parts2, type }),
    [parts2, type]
  );
  const order = useMemo(
    () => pickActiveItem({ items: orders, type }),
    [orders, type]
  );
  const createsOrders = services.includes("create_traceability_order");
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: `${styles$9.itemsWorked} ${className ?? ""}`.trim(),
      "data-testid": "workstation-active-parts",
      children: createsOrders ? /* @__PURE__ */ jsx("p", { children: t.createManufacturingOrders }) : part2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        order && /* @__PURE__ */ jsx("p", { className: styles$9.orderCode, children: order.code }),
        /* @__PURE__ */ jsx("p", { children: `${part2.name} - ${part2.code}` })
      ] }) : /* @__PURE__ */ jsx("p", { children: t.noPartSelected })
    }
  );
}
const icon$1 = "_icon_5t6b0_3";
const single = "_single_5t6b0_14";
const styles$8 = {
  icon: icon$1,
  single
};
function WorkstationPartsBadge({
  quantity: quantity2,
  className
}) {
  if (quantity2 <= 0) return null;
  return /* @__PURE__ */ jsx(
    CaptureTwoPartsIcon,
    {
      className: `${styles$8.icon} ${quantity2 === 1 ? styles$8.single : ""} ${className ?? ""}`.trim(),
      "data-testid": "workstation-parts-badge",
      "aria-hidden": true
    }
  );
}
const en$1 = {
  available: "Available",
  inOperation: "In operation"
};
const es$1 = {
  available: "Disponible",
  inOperation: "En operación"
};
const ro$1 = {
  available: "Disponibil",
  inOperation: "În funcțiune"
};
const workstationCardI18n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  en: en$1,
  es: es$1,
  ro: ro$1
}, Symbol.toStringTag, { value: "Module" }));
const card$1 = "_card_1fewi_3 _root_1ks6j_3";
const name = "_name_1fewi_61";
const nameText = "_nameText_1fewi_74";
const separator = "_separator_1fewi_81";
const cardFooter = "_cardFooter_1fewi_89";
const status = "_status_1fewi_96";
const operator = "_operator_1fewi_118";
const styles$7 = {
  card: card$1,
  name,
  nameText,
  separator,
  cardFooter,
  status,
  operator
};
function WorkstationCard({
  workstation,
  onSelect,
  className
}) {
  const { translations: t } = useLanguage(workstationCardI18n);
  const { status: status2, services, parts: parts2, orders, typeName, operatorName } = workstation;
  const isAvailable = status2 === "available";
  const ribbon = resolveWorkstationRibbon({ typeName, services });
  const operator2 = shortenOperatorName(operatorName);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: `${styles$7.card} ${className ?? ""}`.trim(),
      "data-status": status2,
      "data-ribbon": ribbon ?? void 0,
      disabled: !isAvailable || !onSelect,
      onClick: () => onSelect == null ? void 0 : onSelect(workstation),
      "data-testid": "workstation-card",
      children: [
        /* @__PURE__ */ jsxs("h4", { className: styles$7.name, children: [
          /* @__PURE__ */ jsx("span", { className: styles$7.nameText, children: resolveWorkstationName(workstation) }),
          /* @__PURE__ */ jsx(WorkstationPartsBadge, { quantity: parts2.length })
        ] }),
        /* @__PURE__ */ jsx("span", { className: styles$7.separator }),
        /* @__PURE__ */ jsx(
          WorkstationActiveParts,
          {
            parts: parts2,
            orders,
            services
          }
        ),
        /* @__PURE__ */ jsxs("footer", { className: styles$7.cardFooter, children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: styles$7.status,
              "data-status": status2,
              "data-testid": "workstation-status",
              children: isAvailable ? t.available : t.inOperation
            }
          ),
          !isAvailable && operator2 && /* @__PURE__ */ jsx("span", { className: styles$7.operator, children: operator2 })
        ] })
      ]
    }
  );
}
const en = {
  noWorkstationsHere: "No workstations here at the moment"
};
const es = {
  noWorkstationsHere: "No hay estaciones aquí por el momento"
};
const ro = {
  noWorkstationsHere: "Nu există stații aici în acest moment"
};
const workstationGridI18n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  en,
  es,
  ro
}, Symbol.toStringTag, { value: "Module" }));
const grid = "_grid_147pl_3";
const empty$1 = "_empty_147pl_20";
const styles$6 = {
  grid,
  empty: empty$1
};
function WorkstationGrid({
  workstations,
  onSelect,
  emptyLabel,
  className
}) {
  const { translations: t } = useLanguage(workstationGridI18n);
  if (workstations.length === 0) {
    return /* @__PURE__ */ jsx("p", { className: `${styles$6.empty} ${className ?? ""}`.trim(), children: emptyLabel ?? t.noWorkstationsHere });
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${styles$6.grid} ${className ?? ""}`.trim(),
      "data-testid": "workstation-grid",
      children: workstations.map((workstation) => /* @__PURE__ */ jsx(
        WorkstationCard,
        {
          workstation,
          onSelect
        },
        workstation.id
      ))
    }
  );
}
const card = "_card_1ws26_4 _root_97llu_4";
const label$1 = "_label_1ws26_19";
const value$1 = "_value_1ws26_24";
const brand = "_brand_1ws26_31";
const styles$5 = {
  card,
  label: label$1,
  value: value$1,
  brand
};
function IndicatorCard({
  label: label2,
  value: value2,
  tone = "default",
  className
}) {
  const classes = [
    styles$5.card,
    tone === "brand" ? styles$5.brand : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("div", { className: classes, children: [
    /* @__PURE__ */ jsx("span", { className: styles$5.label, children: label2 }),
    /* @__PURE__ */ jsx("span", { className: styles$5.value, children: value2 })
  ] });
}
const track = "_track_1y6hp_5 _root_1dda2_5";
const bar = "_bar_1y6hp_19 _bar_1dda2_22";
const button$1 = "_button_1y6hp_24";
const active = "_active_1y6hp_52";
const styles$4 = {
  track,
  bar,
  button: button$1,
  active
};
function SegmentedTabs({
  options,
  value: value2,
  onChange,
  variant = "default",
  ariaLabel,
  className
}) {
  const classes = [
    styles$4.track,
    variant === "bar" ? styles$4.bar : null,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("div", { className: classes, role: "group", "aria-label": ariaLabel, children: options.map((option2) => {
    const isActive = option2.value === value2;
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `${styles$4.button} ${isActive ? styles$4.active : ""}`.trim(),
        "aria-pressed": isActive,
        onClick: () => {
          if (!isActive) onChange(option2.value);
        },
        children: option2.label
      },
      option2.value
    );
  }) });
}
const ticket = "_ticket_ox2y6_5 _root_tyypl_4";
const header = "_header_ox2y6_19";
const title = "_title_ox2y6_25";
const table$1 = "_table_ox2y6_29";
const rowLabel = "_rowLabel_ox2y6_35";
const rowValue = "_rowValue_ox2y6_36";
const barcode = "_barcode_ox2y6_47";
const styles$3 = {
  ticket,
  header,
  title,
  table: table$1,
  rowLabel,
  rowValue,
  barcode
};
const Ticket = forwardRef(function Ticket2({ title: title2, date, rows, barcode: barcode2, className }, ref) {
  return /* @__PURE__ */ jsxs(
    "section",
    {
      ref,
      className: [styles$3.ticket, className].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$3.header, children: [
          /* @__PURE__ */ jsx("h3", { className: styles$3.title, children: title2 }),
          date != null && /* @__PURE__ */ jsx("span", { className: styles$3.date, children: date })
        ] }),
        /* @__PURE__ */ jsx("table", { className: styles$3.table, children: /* @__PURE__ */ jsx("tbody", { children: rows.map((row2, index2) => /* @__PURE__ */ jsxs("tr", { children: [
          /* @__PURE__ */ jsx("th", { scope: "row", className: styles$3.rowLabel, children: row2.label }),
          /* @__PURE__ */ jsx("td", { className: styles$3.rowValue, children: row2.value })
        ] }, index2)) }) }),
        barcode2 != null && /* @__PURE__ */ jsx("div", { className: styles$3.barcode, children: barcode2 })
      ]
    }
  );
});
const stepper = "_stepper_bvdzm_4 _root_1fays_3";
const button = "_button_bvdzm_12";
const icon = "_icon_bvdzm_38";
const value = "_value_bvdzm_43";
const styles$2 = {
  stepper,
  button,
  icon,
  value
};
function QuantityStepper({
  value: value2,
  onChange,
  min: min2 = 1,
  max: max2 = 99,
  step = 1,
  disabled: disabled2 = false,
  decrementLabel = "Decrease",
  incrementLabel = "Increase",
  className
}) {
  const clamp2 = (next) => Math.min(max2, Math.max(min2, next));
  const set = (next) => onChange(clamp2(next));
  return /* @__PURE__ */ jsxs("div", { className: [styles$2.stepper, className].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: styles$2.button,
        "aria-label": decrementLabel,
        disabled: disabled2 || value2 <= min2,
        onClick: () => set(value2 - step),
        children: /* @__PURE__ */ jsx(Minus, { className: styles$2.icon, "aria-hidden": true })
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "number",
        className: styles$2.value,
        value: value2,
        min: min2,
        max: max2,
        disabled: disabled2,
        onChange: (event) => {
          const raw = event.target.value;
          if (raw === "") return;
          const next = Number(raw);
          if (!Number.isNaN(next)) set(next);
        }
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: styles$2.button,
        "aria-label": incrementLabel,
        disabled: disabled2 || value2 >= max2,
        onClick: () => set(value2 + step),
        children: /* @__PURE__ */ jsx(Plus, { className: styles$2.icon, "aria-hidden": true })
      }
    )
  ] });
}
const wrap = "_wrap_1ljoa_5 _root_xok2e_4";
const table = "_table_1ljoa_17";
const head = "_head_1ljoa_27";
const headRow = "_headRow_1ljoa_35";
const headCell = "_headCell_1ljoa_43";
const cell = "_cell_1ljoa_44";
const checkCell = "_checkCell_1ljoa_45";
const sortButton = "_sortButton_1ljoa_68";
const alignCenter = "_alignCenter_1ljoa_80";
const alignRight = "_alignRight_1ljoa_84";
const headCheckCell = "_headCheckCell_1ljoa_103 _checkCell_1ljoa_45";
const rowDanger = "_rowDanger_1ljoa_112";
const empty = "_empty_1ljoa_117";
const styles$1 = {
  wrap,
  table,
  head,
  headRow,
  headCell,
  cell,
  checkCell,
  sortButton,
  alignCenter,
  alignRight,
  headCheckCell,
  rowDanger,
  empty
};
function renderSlot(slot, context) {
  return typeof slot === "function" ? slot(context) : slot ?? null;
}
const alignClass = {
  left: void 0,
  center: styles$1.alignCenter,
  right: styles$1.alignRight
};
function SelectableTable({
  columns,
  data,
  rowId,
  selectable = true,
  selectedIds,
  onSelectionChange,
  selectAllLabel = "Select all",
  rowLabel: rowLabel2,
  getRowTone,
  emptyLabel = "No results",
  className
}) {
  const [sorting, setSorting] = useState([]);
  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
  const selectedInData = useMemo(
    () => data.reduce((n, row2) => selectedSet.has(rowId(row2)) ? n + 1 : n, 0),
    [data, rowId, selectedSet]
  );
  const allSelected = data.length > 0 && selectedInData === data.length;
  const someSelected = selectedInData > 0 && !allSelected;
  const toggleAll = (checked) => onSelectionChange(checked ? data.map(rowId) : []);
  const toggleRow = (id, checked) => onSelectionChange(
    checked ? [...selectedIds, id] : selectedIds.filter((x) => x !== id)
  );
  const tableColumns = useMemo(() => {
    const select = {
      id: "select",
      enableSorting: false,
      header: () => /* @__PURE__ */ jsx(
        Checkbox,
        {
          checked: allSelected,
          indeterminate: someSelected,
          onChange: toggleAll,
          ariaLabel: selectAllLabel
        }
      ),
      cell: ({ row: row2 }) => {
        const id = rowId(row2.original);
        return /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: selectedSet.has(id),
            onChange: (checked) => toggleRow(id, checked),
            ariaLabel: rowLabel2 == null ? void 0 : rowLabel2(row2.original)
          }
        );
      }
    };
    const rest = columns.map((column2) => ({
      id: column2.id,
      accessorFn: (row2) => column2.value ? column2.value(row2) ?? "" : "",
      header: () => column2.header,
      cell: ({ row: row2 }) => {
        if (column2.cell) return column2.cell(row2.original);
        if (!column2.value) return "";
        const value2 = column2.value(row2.original);
        return value2 == null ? "" : String(value2);
      },
      enableSorting: column2.enableSorting ?? true,
      meta: { align: column2.align ?? "left" }
    }));
    return selectable ? [select, ...rest] : rest;
  }, [
    columns,
    selectable,
    selectAllLabel,
    rowLabel2,
    allSelected,
    someSelected,
    selectedSet,
    selectedIds,
    data,
    rowId,
    onSelectionChange
  ]);
  const table2 = useReactTable({
    data,
    columns: tableColumns,
    state: { sorting },
    getRowId: rowId,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel()
  });
  const columnCount = table2.getAllLeafColumns().length;
  return /* @__PURE__ */ jsx("div", { className: [styles$1.wrap, className].filter(Boolean).join(" "), children: /* @__PURE__ */ jsxs("table", { className: styles$1.table, children: [
    /* @__PURE__ */ jsx("thead", { className: styles$1.head, children: table2.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx("tr", { className: styles$1.headRow, children: headerGroup.headers.map((header2) => {
      var _a;
      const isSelect = header2.column.id === "select";
      const align = ((_a = header2.column.columnDef.meta) == null ? void 0 : _a.align) ?? "left";
      const canSort = header2.column.getCanSort();
      return /* @__PURE__ */ jsx(
        "th",
        {
          scope: "col",
          className: `${isSelect ? styles$1.headCheckCell : styles$1.headCell} ${alignClass[align] ?? ""}`.trim(),
          children: isSelect ? renderSlot(
            header2.column.columnDef.header,
            header2.getContext()
          ) : canSort ? /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: styles$1.sortButton,
              onClick: header2.column.getToggleSortingHandler(),
              children: renderSlot(
                header2.column.columnDef.header,
                header2.getContext()
              )
            }
          ) : renderSlot(
            header2.column.columnDef.header,
            header2.getContext()
          )
        },
        header2.id
      );
    }) }, headerGroup.id)) }),
    /* @__PURE__ */ jsx("tbody", { children: table2.getRowModel().rows.length === 0 ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { className: styles$1.empty, colSpan: columnCount, children: emptyLabel }) }) : table2.getRowModel().rows.map((row2) => {
      const tone = (getRowTone == null ? void 0 : getRowTone(row2.original)) ?? "default";
      return /* @__PURE__ */ jsx(
        "tr",
        {
          className: tone === "danger" ? styles$1.rowDanger : void 0,
          children: row2.getVisibleCells().map((cell2) => {
            var _a;
            const isSelect = cell2.column.id === "select";
            const align = ((_a = cell2.column.columnDef.meta) == null ? void 0 : _a.align) ?? "left";
            return /* @__PURE__ */ jsx(
              "td",
              {
                className: `${isSelect ? styles$1.checkCell : styles$1.cell} ${alignClass[align] ?? ""}`.trim(),
                children: renderSlot(
                  cell2.column.columnDef.cell,
                  cell2.getContext()
                )
              },
              cell2.id
            );
          })
        },
        row2.id
      );
    }) })
  ] }) });
}
const concatArrays = (array1, array2) => {
  const combinedArray = new Array(array1.length + array2.length);
  for (let i = 0; i < array1.length; i++) {
    combinedArray[i] = array1[i];
  }
  for (let i = 0; i < array2.length; i++) {
    combinedArray[array1.length + i] = array2[i];
  }
  return combinedArray;
};
const createClassValidatorObject = (classGroupId, validator) => ({
  classGroupId,
  validator
});
const createClassPartObject = (nextPart = /* @__PURE__ */ new Map(), validators = null, classGroupId) => ({
  nextPart,
  validators,
  classGroupId
});
const CLASS_PART_SEPARATOR = "-";
const EMPTY_CONFLICTS = [];
const ARBITRARY_PROPERTY_PREFIX = "arbitrary..";
const createClassGroupUtils = (config2) => {
  const classMap = createClassMap(config2);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config2;
  const getClassGroupId = (className) => {
    if (className.startsWith("[") && className.endsWith("]")) {
      return getGroupIdForArbitraryProperty(className);
    }
    const classParts = className.split(CLASS_PART_SEPARATOR);
    const startIndex = classParts[0] === "" && classParts.length > 1 ? 1 : 0;
    return getGroupRecursive(classParts, startIndex, classMap);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    if (hasPostfixModifier) {
      const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
      const baseConflicts = conflictingClassGroups[classGroupId];
      if (modifierConflicts) {
        if (baseConflicts) {
          return concatArrays(baseConflicts, modifierConflicts);
        }
        return modifierConflicts;
      }
      return baseConflicts || EMPTY_CONFLICTS;
    }
    return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, startIndex, classPartObject) => {
  const classPathsLength = classParts.length - startIndex;
  if (classPathsLength === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[startIndex];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  if (nextClassPartObject) {
    const result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
    if (result) return result;
  }
  const validators = classPartObject.validators;
  if (validators === null) {
    return void 0;
  }
  const classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
  const validatorsLength = validators.length;
  for (let i = 0; i < validatorsLength; i++) {
    const validatorObj = validators[i];
    if (validatorObj.validator(classRest)) {
      return validatorObj.classGroupId;
    }
  }
  return void 0;
};
const getGroupIdForArbitraryProperty = (className) => className.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const content2 = className.slice(1, -1);
  const colonIndex = content2.indexOf(":");
  const property = content2.slice(0, colonIndex);
  return property ? ARBITRARY_PROPERTY_PREFIX + property : void 0;
})();
const createClassMap = (config2) => {
  const {
    theme,
    classGroups
  } = config2;
  return processClassGroups(classGroups, theme);
};
const processClassGroups = (classGroups, theme) => {
  const classMap = createClassPartObject();
  for (const classGroupId in classGroups) {
    const group2 = classGroups[classGroupId];
    processClassesRecursively(group2, classMap, classGroupId, theme);
  }
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  const len = classGroup.length;
  for (let i = 0; i < len; i++) {
    const classDefinition = classGroup[i];
    processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
  }
};
const processClassDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (typeof classDefinition === "string") {
    processStringDefinition(classDefinition, classPartObject, classGroupId);
    return;
  }
  if (typeof classDefinition === "function") {
    processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
    return;
  }
  processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const processStringDefinition = (classDefinition, classPartObject, classGroupId) => {
  const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
  classPartObjectToEdit.classGroupId = classGroupId;
};
const processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (isThemeGetter(classDefinition)) {
    processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
    return;
  }
  if (classPartObject.validators === null) {
    classPartObject.validators = [];
  }
  classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
};
const processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  const entries = Object.entries(classDefinition);
  const len = entries.length;
  for (let i = 0; i < len; i++) {
    const [key, value2] = entries[i];
    processClassesRecursively(value2, getPart(classPartObject, key), classGroupId, theme);
  }
};
const getPart = (classPartObject, path) => {
  let current2 = classPartObject;
  const parts2 = path.split(CLASS_PART_SEPARATOR);
  const len = parts2.length;
  for (let i = 0; i < len; i++) {
    const part2 = parts2[i];
    let next = current2.nextPart.get(part2);
    if (!next) {
      next = createClassPartObject();
      current2.nextPart.set(part2, next);
    }
    current2 = next;
  }
  return current2;
};
const isThemeGetter = (func) => "isThemeGetter" in func && func.isThemeGetter === true;
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ Object.create(null);
  let previousCache = /* @__PURE__ */ Object.create(null);
  const update = (key, value2) => {
    cache[key] = value2;
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ Object.create(null);
    }
  };
  return {
    get(key) {
      let value2 = cache[key];
      if (value2 !== void 0) {
        return value2;
      }
      if ((value2 = previousCache[key]) !== void 0) {
        update(key, value2);
        return value2;
      }
    },
    set(key, value2) {
      if (key in cache) {
        cache[key] = value2;
      } else {
        update(key, value2);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const MODIFIER_SEPARATOR = ":";
const EMPTY_MODIFIERS = [];
const createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) => ({
  modifiers,
  hasImportantModifier,
  baseClassName,
  maybePostfixModifierPosition,
  isExternal
});
const createParseClassName = (config2) => {
  const {
    prefix,
    experimentalParseClassName
  } = config2;
  let parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    const len = className.length;
    for (let index2 = 0; index2 < len; index2++) {
      const currentCharacter = className[index2];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + 1;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") bracketDepth++;
      else if (currentCharacter === "]") bracketDepth--;
      else if (currentCharacter === "(") parenDepth++;
      else if (currentCharacter === ")") parenDepth--;
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
    let baseClassName = baseClassNameWithImportantModifier;
    let hasImportantModifier = false;
    if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
      baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
      hasImportantModifier = true;
    } else if (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)
    ) {
      baseClassName = baseClassNameWithImportantModifier.slice(1);
      hasImportantModifier = true;
    }
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
  };
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, void 0, true);
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    });
  }
  return parseClassName;
};
const createSortModifiers = (config2) => {
  const modifierWeights = /* @__PURE__ */ new Map();
  config2.orderSensitiveModifiers.forEach((mod, index2) => {
    modifierWeights.set(mod, 1e6 + index2);
  });
  return (modifiers) => {
    const result = [];
    let currentSegment = [];
    for (let i = 0; i < modifiers.length; i++) {
      const modifier = modifiers[i];
      const isArbitrary = modifier[0] === "[";
      const isOrderSensitive = modifierWeights.has(modifier);
      if (isArbitrary || isOrderSensitive) {
        if (currentSegment.length > 0) {
          currentSegment.sort();
          result.push(...currentSegment);
          currentSegment = [];
        }
        result.push(modifier);
      } else {
        currentSegment.push(modifier);
      }
    }
    if (currentSegment.length > 0) {
      currentSegment.sort();
      result.push(...currentSegment);
    }
    return result;
  };
};
const createConfigUtils = (config2) => ({
  cache: createLruCache(config2.cacheSize),
  parseClassName: createParseClassName(config2),
  sortModifiers: createSortModifiers(config2),
  postfixLookupClassGroupIds: createPostfixLookupClassGroupIds(config2),
  ...createClassGroupUtils(config2)
});
const createPostfixLookupClassGroupIds = (config2) => {
  const lookup = /* @__PURE__ */ Object.create(null);
  const classGroupIds = config2.postfixLookupClassGroups;
  if (classGroupIds) {
    for (let i = 0; i < classGroupIds.length; i++) {
      lookup[classGroupIds[i]] = true;
    }
  }
  return lookup;
};
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers,
    postfixLookupClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index2 = classNames.length - 1; index2 >= 0; index2 -= 1) {
    const originalClassName = classNames[index2];
    const {
      isExternal,
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId;
    if (hasPostfixModifier) {
      const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
      classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
      const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : void 0;
      if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
        classGroupId = classGroupIdWithPostfix;
        hasPostfixModifier = false;
      }
    } else {
      classGroupId = getClassGroupId(baseClassName);
    }
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = modifiers.length === 0 ? "" : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.indexOf(classId) > -1) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group2 = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group2);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
const twJoin = (...classLists) => {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index2 < classLists.length) {
    if (argument = classLists[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
const createTailwindMerge = (createConfigFirst, ...createConfigRest) => {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall;
  const initTailwindMerge = (classList) => {
    const config2 = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config2);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  };
  const tailwindMerge = (classList) => {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  };
  functionToCall = initTailwindMerge;
  return (...args) => functionToCall(twJoin(...args));
};
const fallbackThemeArr = [];
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || fallbackThemeArr;
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isFraction = (value2) => fractionRegex.test(value2);
const isNumber = (value2) => !!value2 && !Number.isNaN(Number(value2));
const isInteger = (value2) => !!value2 && Number.isInteger(Number(value2));
const isPercent = (value2) => value2.endsWith("%") && isNumber(value2.slice(0, -1));
const isTshirtSize = (value2) => tshirtUnitRegex.test(value2);
const isAny = () => true;
const isLengthOnly = (value2) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value2) && !colorFunctionRegex.test(value2)
);
const isNever = () => false;
const isShadow = (value2) => shadowRegex.test(value2);
const isImage = (value2) => imageRegex.test(value2);
const isAnyNonArbitrary = (value2) => !isArbitraryValue(value2) && !isArbitraryVariable(value2);
const isNamedContainerQuery = (value2) => value2.startsWith("@container") && (value2[10] === "/" && value2[11] !== void 0 || value2[11] === "s" && value2[16] !== void 0 && value2.startsWith("-size/", 10) || value2[11] === "n" && value2[18] !== void 0 && value2.startsWith("-normal/", 10));
const isArbitrarySize = (value2) => getIsArbitraryValue(value2, isLabelSize, isNever);
const isArbitraryValue = (value2) => arbitraryValueRegex.test(value2);
const isArbitraryLength = (value2) => getIsArbitraryValue(value2, isLabelLength, isLengthOnly);
const isArbitraryNumber = (value2) => getIsArbitraryValue(value2, isLabelNumber, isNumber);
const isArbitraryWeight = (value2) => getIsArbitraryValue(value2, isLabelWeight, isAny);
const isArbitraryFamilyName = (value2) => getIsArbitraryValue(value2, isLabelFamilyName, isNever);
const isArbitraryPosition = (value2) => getIsArbitraryValue(value2, isLabelPosition, isNever);
const isArbitraryImage = (value2) => getIsArbitraryValue(value2, isLabelImage, isImage);
const isArbitraryShadow = (value2) => getIsArbitraryValue(value2, isLabelShadow, isShadow);
const isArbitraryVariable = (value2) => arbitraryVariableRegex.test(value2);
const isArbitraryVariableLength = (value2) => getIsArbitraryVariable(value2, isLabelLength);
const isArbitraryVariableFamilyName = (value2) => getIsArbitraryVariable(value2, isLabelFamilyName);
const isArbitraryVariablePosition = (value2) => getIsArbitraryVariable(value2, isLabelPosition);
const isArbitraryVariableSize = (value2) => getIsArbitraryVariable(value2, isLabelSize);
const isArbitraryVariableImage = (value2) => getIsArbitraryVariable(value2, isLabelImage);
const isArbitraryVariableShadow = (value2) => getIsArbitraryVariable(value2, isLabelShadow, true);
const isArbitraryVariableWeight = (value2) => getIsArbitraryVariable(value2, isLabelWeight, true);
const getIsArbitraryValue = (value2, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value2);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const getIsArbitraryVariable = (value2, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value2);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
};
const isLabelPosition = (label2) => label2 === "position" || label2 === "percentage";
const isLabelImage = (label2) => label2 === "image" || label2 === "url";
const isLabelSize = (label2) => label2 === "length" || label2 === "size" || label2 === "bg-size";
const isLabelLength = (label2) => label2 === "length";
const isLabelNumber = (label2) => label2 === "number";
const isLabelFamilyName = (label2) => label2 === "family-name";
const isLabelWeight = (label2) => label2 === "number" || label2 === "weight";
const isLabelShadow = (label2) => label2 === "shadow";
const getDefaultConfig = () => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeTextShadow = fromTheme("text-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const scalePosition = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ];
  const scalePositionWithArbitrary = () => [...scalePosition(), isArbitraryVariable, isArbitraryValue];
  const scaleOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const scaleOverscroll = () => ["auto", "contain", "none"];
  const scaleUnambiguousSpacing = () => [isArbitraryVariable, isArbitraryValue, themeSpacing];
  const scaleInset = () => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()];
  const scaleGridTemplateColsRows = () => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartAndEnd = () => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isInteger, isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartOrEnd = () => [isInteger, "auto", isArbitraryVariable, isArbitraryValue];
  const scaleGridAutoColsRows = () => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue];
  const scaleAlignPrimaryAxis = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"];
  const scaleAlignSecondaryAxis = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"];
  const scaleMargin = () => ["auto", ...scaleUnambiguousSpacing()];
  const scaleSizing = () => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleSizingInline = () => [isFraction, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleSizingBlock = () => [isFraction, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleColor = () => [themeColor, isArbitraryVariable, isArbitraryValue];
  const scaleBgPosition = () => [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition, {
    position: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleBgRepeat = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }];
  const scaleBgSize = () => ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize, {
    size: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleGradientStopPosition = () => [isPercent, isArbitraryVariableLength, isArbitraryLength];
  const scaleRadius = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleBorderWidth = () => ["", isNumber, isArbitraryVariableLength, isArbitraryLength];
  const scaleLineStyle = () => ["solid", "dashed", "dotted", "double"];
  const scaleBlendMode = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const scaleMaskImagePosition = () => [isNumber, isPercent, isArbitraryVariablePosition, isArbitraryPosition];
  const scaleBlur = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleRotate = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleScale = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleSkew = () => [isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleTranslate = () => [isFraction, "full", ...scaleUnambiguousSpacing()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      "text-shadow": [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [isNamedContainerQuery],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: scalePositionWithArbitrary()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: scaleInset()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: scaleInset()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": scaleInset()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: scaleMargin()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...scaleSizingInline()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...scaleSizingInline()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...scaleSizingInline()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...scaleSizingBlock()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariableWeight, isArbitraryWeight]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryFamilyName, themeFont]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [isArbitraryValue]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [isInteger, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: scaleBgPosition()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: scaleBgRepeat()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: scaleBgSize()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: [isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": scaleBorderWidth()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": scaleColor()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: scaleColor()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", themeInsetShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", themeTextShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [isNumber]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": scaleMaskImagePosition()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": scaleMaskImagePosition()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": scaleColor()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": scaleColor()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": scaleMaskImagePosition()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": scaleMaskImagePosition()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": scaleColor()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": scaleColor()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": scaleMaskImagePosition()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": scaleMaskImagePosition()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": scaleColor()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": scaleColor()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": scaleMaskImagePosition()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": scaleMaskImagePosition()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": scaleColor()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": scaleColor()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": scaleMaskImagePosition()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": scaleMaskImagePosition()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": scaleColor()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": scaleColor()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": scaleMaskImagePosition()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": scaleMaskImagePosition()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": scaleColor()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": scaleColor()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": scaleMaskImagePosition()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": scaleMaskImagePosition()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": scaleColor()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": scaleColor()
      }],
      "mask-image-radial": [{
        "mask-radial": [isArbitraryVariable, isArbitraryValue]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": scaleMaskImagePosition()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": scaleMaskImagePosition()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": scaleColor()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": scaleColor()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": scalePosition()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [isNumber]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": scaleMaskImagePosition()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": scaleMaskImagePosition()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": scaleColor()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": scaleColor()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: scaleBgPosition()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: scaleBgRepeat()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: scaleBgSize()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": scaleColor()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scalePositionWithArbitrary()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scalePositionWithArbitrary()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [isInteger, isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": scaleColor()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": scaleColor()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
};
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
function cn(...inputs2) {
  return twMerge(clsx(inputs2));
}
const field = "_field_1y5a6_3 _root_1vpoq_3";
const fieldHorizontal = "_fieldHorizontal_1y5a6_10 _field_1y5a6_3 _root_1vpoq_3";
const label = "_label_1y5a6_17";
const required = "_required_1y5a6_27";
const error = "_error_1y5a6_32";
const styles = {
  field,
  fieldHorizontal,
  label,
  required,
  error
};
function FormField({
  label: label2,
  error: error2,
  required: required2 = false,
  layout = "vertical",
  htmlFor,
  className,
  children
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        layout === "horizontal" ? styles.fieldHorizontal : styles.field,
        className
      ),
      children: [
        label2 && /* @__PURE__ */ jsxs("label", { className: styles.label, htmlFor, children: [
          label2,
          required2 && /* @__PURE__ */ jsx("span", { className: styles.required, children: "*" })
        ] }),
        children,
        error2 && /* @__PURE__ */ jsx("span", { className: styles.error, children: error2 })
      ]
    }
  );
}
const collator = new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
});
function naturalSort(a, b) {
  return collator.compare(a, b);
}
const ITEM_TYPES = ["main", "associated", "none"];
function toItemType(value2) {
  return ITEM_TYPES.includes(value2) ? value2 : "none";
}
function toStatus(value2) {
  return value2 === "available" ? "available" : "unavailable";
}
function mapPart(part2) {
  return {
    id: part2.id,
    name: part2.name,
    code: part2.code,
    type: toItemType(part2.type)
  };
}
function mapOrder(order) {
  return {
    id: order.id,
    code: order.code,
    type: toItemType(order.type)
  };
}
function mapWorkstation(workstation) {
  var _a, _b;
  return {
    id: workstation.id,
    name: workstation.name,
    // The API sends `""` for a station with no alias; normalize it away so the
    // display helper's `alias ? alias : name` fallback is not load-bearing.
    alias: workstation.alias || void 0,
    status: toStatus(workstation.status),
    typeName: (_a = workstation.workstation_type) == null ? void 0 : _a.type_name,
    services: workstation.workstation_services ?? [],
    parts: (workstation.activated_parts ?? []).map(mapPart),
    orders: (workstation.active_manufactoring_orders ?? []).map(mapOrder),
    // A free station comes back with `user: {}`, so there is no name to show.
    operatorName: ((_b = workstation.user) == null ? void 0 : _b.name) || void 0
  };
}
function mapWorkstations(workstations) {
  return workstations.map(mapWorkstation).sort((a, b) => naturalSort(a.alias ?? a.name, b.alias ?? b.name));
}
let config = {};
function configureCaptureClient(next) {
  config = { ...config, ...next };
}
function captureClientConfig() {
  return config;
}
function captureBackend() {
  const configured = captureClientConfig().backend;
  if (configured) return configured;
  return "legacy";
}
function notImplemented(operation, target) {
  throw new Error(
    `captureApi.${operation} is not implemented for the "${target}" backend`
  );
}
const CAPTURE_BASE_PATH = "";
function captureBaseUrl() {
  const configured = captureClientConfig().baseUrl;
  if (configured && configured.length > 0) {
    return configured.replace(/\/$/, "");
  }
  const override = void 0;
  return override && override.length > 0 ? override.replace(/\/$/, "") : CAPTURE_BASE_PATH;
}
class CaptureApiError extends Error {
  constructor(status2, url) {
    super(`Capture API error (${status2}) for ${url}`);
    this.status = status2;
    this.url = url;
    this.name = "CaptureApiError";
  }
}
const LEGACY_HEADERS = {
  Accept: "application/json",
  "x-monitorapp-service": "vite-react"
};
function legacyHeaders(extra) {
  var _a, _b;
  const headers = { ...LEGACY_HEADERS, ...extra };
  const token = (_b = (_a = captureClientConfig()).getToken) == null ? void 0 : _b.call(_a);
  if (token) headers.Authorization = `Token ${token}`;
  return headers;
}
const VIA_PARAM = "_via";
function viaValue() {
  return captureBackend() === "platform" ? "platform-native" : "platform-legacy";
}
function captureUrl(path, query) {
  const search2 = new URLSearchParams();
  for (const [key, value2] of Object.entries(query ?? {})) {
    if (value2 === void 0 || value2 === null) continue;
    search2.set(key, String(value2));
  }
  search2.set(VIA_PARAM, viaValue());
  return `${captureBaseUrl()}${path}?${search2.toString()}`;
}
async function getJson(url) {
  const res = await fetch(url, {
    headers: legacyHeaders(),
    // Sends the Rails session cookie (same-origin via the proxy/edge).
    credentials: "include"
  });
  if (!res.ok) throw new CaptureApiError(res.status, url);
  return await res.json();
}
const queryKeys = {
  // Capture (shop-floor terminals). Namespaced away from the analytics
  // `workstations` key above: same word, different backend and shape.
  captureSession: ["capture-session"],
  captureWorkstations: ["capture-workstations"]
};
function mapUser(user) {
  return { id: user.id, name: user.name, type: user.type };
}
function mapCompany(company) {
  return {
    id: company.id,
    name: company.name,
    timeZone: company.time_zone
  };
}
function mapSchedule(schedule) {
  return {
    id: schedule.id,
    // Shift names come back with stray padding (`"Primer Turno  LV "`), which
    // would show up in every picker label.
    name: schedule.name.trim(),
    startsAt: schedule.starts_at,
    endsAt: schedule.ends_at,
    activeHours: schedule.active_hours,
    crossesMidnight: scheduleCrossesMidnight({
      startsAt: schedule.starts_at,
      endsAt: schedule.ends_at
    })
  };
}
function mapSession(session) {
  return {
    user: mapUser(session.user),
    company: mapCompany(session.company),
    schedules: (session.schedules ?? []).map(mapSchedule).sort((a, b) => naturalSort(a.name, b.name))
  };
}
const items$1 = { "user": { "id": 2361, "name": "Operador", "type": "Supervisor" }, "company": { "name": "Monitor Team Dev", "id": 152, "time_zone": "Guadalajara" }, "schedules": [{ "id": 504, "name": "Horario Principal", "starts_at": "01:00:00", "ends_at": "12:15:00", "active_hours": 11 }, { "id": 545, "name": "Tarde", "starts_at": "12:15:00", "ends_at": "16:30:00", "active_hours": 4 }, { "id": 546, "name": "Noche", "starts_at": "16:30:00", "ends_at": "20:00:00", "active_hours": 3 }, { "id": 575, "name": "Primer Turno  LV ", "starts_at": "07:00:00", "ends_at": "15:30:00", "active_hours": 8.5 }, { "id": 610, "name": "Nocturno", "starts_at": "20:00:00", "ends_at": "15:00:00", "active_hours": 19 }, { "id": 621, "name": "Entre Fechas", "starts_at": "19:00:00", "ends_at": "17:00:00", "active_hours": 5 }, { "id": 654, "name": "Diurno", "starts_at": "08:00:00", "ends_at": "17:30:00", "active_hours": 9 }, { "id": 724, "name": "Pruebas", "starts_at": "06:00:00", "ends_at": "18:00:00", "active_hours": 9 }, { "id": 755, "name": "All Days", "starts_at": "01:00:00", "ends_at": "01:00:00", "active_hours": 6 }, { "id": 763, "name": "Nuevo Horario", "starts_at": "08:00:00", "ends_at": "20:00:00", "active_hours": 12 }, { "id": 764, "name": "Otro Horario", "starts_at": "20:00:00", "ends_at": "06:00:00", "active_hours": 10 }, { "id": 792, "name": "PruebaNotificaciones", "starts_at": "08:00:00", "ends_at": "12:40:00", "active_hours": 4 }] };
const fixture$1 = {
  items: items$1
};
const SESSION_FIXTURE = fixture$1.items;
const LEGACY_ENDPOINTS = {
  session: {
    /** `GET` — the session context: operator, company and shift catalog.
     *  Named `user` on the wire, but the body carries all three. */
    get: "/capture/user"
  },
  workstations: {
    /** `GET` — the workstations list behind the operator's station picker.
     *  Takes a `datetime` query param (`YYYY-MM-DD HH:mm:ss`). */
    list: "/capture/workstations"
  }
};
const sessionService = {
  /** Fetches the capture session context for the signed-in operator. */
  async getSession() {
    const target = captureBackend();
    if (target === "mock") return SESSION_FIXTURE;
    if (target === "platform") notImplemented("getSession", target);
    const url = captureUrl(LEGACY_ENDPOINTS.session.get);
    const body2 = await getJson(url);
    return body2.items;
  }
};
const items = [{ "id": 1743, "workstation_services": ["boarding_outgoing"], "name": "workstation01", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Dev Pulsos", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [{ "id": 18990, "code": "REVISIONOFS1", "type": "none" }] }, { "id": 1766, "workstation_services": ["create_traceability_order"], "name": "workstation03", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Dev Creación OF Trazabilidad", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 1784, "workstation_services": [], "name": "workstation04", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Dev Impresion Etiquetas Trazabilidad", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [{ "id": 39614, "code": "Orden Unicio Ikano", "type": "none" }] }, { "id": 1789, "workstation_services": [], "name": "Workstation05", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Dev Unión Etiquetas", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [{ "id": 39613, "code": "Union Ikano", "type": "none" }] }, { "id": 1813, "workstation_services": [], "name": "Workstation06", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Estación hora x hora", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [{ "id": 43134, "code": "prueba Operador", "type": "none" }] }, { "id": 1989, "workstation_services": [], "name": "Partes paralelas", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Partes paralelas", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 2021, "workstation_services": [], "name": "Entre Fechas", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Entre Fechas", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 2117, "workstation_services": ["create_traceability_order"], "name": "workstation4", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "3.0 Creación de Lote", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 2613, "workstation_services": ["create_traceability_order"], "name": "Creacion de OF", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Creación de OF", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 2651, "workstation_services": [], "name": "Prueba", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Prueba Issues", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [] }, { "id": 3058, "workstation_services": ["tracking"], "name": "estacion dos de union", "workstation_type": { "id": 2, "type_name": "traceability", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Union 2", "status": "available", "user": {}, "activated_parts": [], "active_manufactoring_orders": [{ "id": 40371, "code": "union 2", "type": "none" }] }, { "id": 3102, "workstation_services": [], "name": "workstation07", "workstation_type": { "id": 1, "type_name": "productivity", "created_at": "2023-12-08T17:30:10.000Z", "updated_at": "2023-12-08T17:30:10.000Z" }, "alias": "Dev Ensamble 2", "status": "unavailable", "user": { "id": 431, "name": "Ana María López Ruiz" }, "activated_parts": [{ "id": 10, "name": "Soporte lateral", "code": "SP-4410", "type": "main" }, { "id": 11, "name": "Refuerzo", "code": "RF-0921", "type": "associated" }], "active_manufactoring_orders": [{ "id": 44012, "code": "OF-2026-0431", "type": "main" }] }];
const fixture = {
  items
};
const WORKSTATIONS_FIXTURE = fixture.items;
function toCaptureDatetime(date) {
  const pad2 = (value2) => String(value2).padStart(2, "0");
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())} ${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
}
const workstationsService = {
  /**
   * Lists every workstation the operator can claim, with its availability and
   * whatever it is currently running.
   */
  async listWorkstations(params = {}) {
    const target = captureBackend();
    if (target === "mock") return WORKSTATIONS_FIXTURE;
    if (target === "platform") notImplemented("listWorkstations", target);
    const url = captureUrl(LEGACY_ENDPOINTS.workstations.list, {
      datetime: toCaptureDatetime(params.datetime ?? /* @__PURE__ */ new Date())
    });
    const body2 = await getJson(url);
    return body2.items;
  }
};
const captureApi = {
  session: sessionService,
  workstations: workstationsService
};
function captureSessionQueryOptions() {
  return queryOptions({
    queryKey: queryKeys.captureSession,
    queryFn: () => captureApi.session.getSession(),
    select: (session) => mapSession(session),
    // The operator, their company and the shift catalog do not change during a
    // capture session, so this is fetched once and reused across pages.
    staleTime: 5 * 6e4
  });
}
function useCaptureSessionQuery() {
  return useQuery(captureSessionQueryOptions());
}
const REFETCH_INTERVAL_MS = 3e4;
function captureWorkstationsQueryOptions() {
  return queryOptions({
    queryKey: queryKeys.captureWorkstations,
    queryFn: () => captureApi.workstations.listWorkstations(),
    staleTime: 1e4,
    refetchInterval: REFETCH_INTERVAL_MS
  });
}
function captureWorkstationCardsQueryOptions() {
  return queryOptions({
    ...captureWorkstationsQueryOptions(),
    select: (workstations) => mapWorkstations(workstations)
  });
}
function useCaptureWorkstationsQuery() {
  return useQuery(captureWorkstationsQueryOptions());
}
function useCaptureWorkstationCardsQuery() {
  return useQuery(captureWorkstationCardsQueryOptions());
}
export {
  Button,
  CaptureApiError,
  CaptureMultiSelectList,
  CaptureSelectList,
  CaptureTabs,
  CaptureTooltip,
  CheckAnswer,
  Checkbox,
  ChecklistGroup,
  ChecklistRow,
  ChecklistTemplateItem,
  ConfirmPartSummary,
  ConfirmQuantityInputs,
  DateAnswer,
  DatePicker,
  DefectAnswer,
  DefectCountList,
  FormField,
  ImageAnswer,
  IndicatorCard,
  IndicatorTile,
  Input,
  LanguageMenu,
  MediaWidget,
  MetricIndicator,
  Modal,
  OpenAnswer,
  OrderAnswer,
  PartAndOf,
  PartAnswer,
  PartCountRow,
  PartNavRow,
  PartTotalRow,
  PartsProgressBar,
  PartsQuantityInput,
  PasswordInput,
  QuantityStepper,
  QuestionCard,
  RadioGroup,
  RangeAnswer,
  ScheduleTimeline,
  SearchInput,
  SegmentedTabs,
  SelectableTable,
  SideBar,
  SideDrawer,
  SideItem,
  SignatureAnswer,
  Slider,
  SliderCard,
  SuccessMessage,
  Textarea,
  Ticket,
  TopBar,
  TopBarButton,
  WarningModal,
  WorkstationActiveParts,
  WorkstationCard,
  WorkstationGrid,
  WorkstationPartsBadge,
  ZoomControls,
  ZoomableImage,
  captureSessionQueryOptions,
  captureWorkstationCardsQueryOptions,
  captureWorkstationsQueryOptions,
  configureCaptureClient,
  filterWorkstationsBySearch,
  filterWorkstationsByStatus,
  getScheduleById,
  mapWorkstation,
  mapWorkstations,
  naturalSort,
  pickActiveItem,
  resolveWorkstationName,
  resolveWorkstationRibbon,
  scheduleCrossesMidnight,
  shortenOperatorName,
  toCaptureDatetime,
  useCaptureSessionQuery,
  useCaptureWorkstationCardsQuery,
  useCaptureWorkstationsQuery
};
//# sourceMappingURL=capture.js.map
